// source: xcommon/collection.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_ticket_pb = require('../xcommon/ticket_pb.js');
goog.object.extend(proto, xcommon_ticket_pb);
var xcommon_core_pb = require('../xcommon/core_pb.js');
goog.object.extend(proto, xcommon_core_pb);
var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_dialer_pb = require('../xcommon/dialer_pb.js');
goog.object.extend(proto, xcommon_dialer_pb);
var xcommon_enum_pb = require('../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
goog.exportSymbol('proto.xcommon.AccountAlternativeContactUrge', null, global);
goog.exportSymbol('proto.xcommon.ApplyFrozenInterestReq', null, global);
goog.exportSymbol('proto.xcommon.ApplyFrozenInterestResp', null, global);
goog.exportSymbol('proto.xcommon.CalcMarketPaymentCodeFeeReq', null, global);
goog.exportSymbol('proto.xcommon.CalcMarketPaymentCodeFeeResp', null, global);
goog.exportSymbol('proto.xcommon.CaseLogDetailBackend', null, global);
goog.exportSymbol('proto.xcommon.CasePageTurningReq', null, global);
goog.exportSymbol('proto.xcommon.CasePageTurningResp', null, global);
goog.exportSymbol('proto.xcommon.CollectionTicket', null, global);
goog.exportSymbol('proto.xcommon.CommonCollaborationNotifyReq', null, global);
goog.exportSymbol('proto.xcommon.CreatePaymentLinkReq', null, global);
goog.exportSymbol('proto.xcommon.CreatePaymentLinkResp', null, global);
goog.exportSymbol('proto.xcommon.CreatePaymentVoucherReq', null, global);
goog.exportSymbol('proto.xcommon.CreatePaymentVoucherResp', null, global);
goog.exportSymbol('proto.xcommon.DiscardReason', null, global);
goog.exportSymbol('proto.xcommon.DownloadDocumentReq', null, global);
goog.exportSymbol('proto.xcommon.DownloadDocumentResp', null, global);
goog.exportSymbol('proto.xcommon.DownloadUrgeLetterReq', null, global);
goog.exportSymbol('proto.xcommon.DownloadUrgeLetterResp', null, global);
goog.exportSymbol('proto.xcommon.ExtContacts', null, global);
goog.exportSymbol('proto.xcommon.GetAllAutoCallResultReq', null, global);
goog.exportSymbol('proto.xcommon.GetAllAutoCallResultResp', null, global);
goog.exportSymbol('proto.xcommon.GetCaseLogDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetCaseLogDetailResp', null, global);
goog.exportSymbol('proto.xcommon.GetCouponTaskIdMapReq', null, global);
goog.exportSymbol('proto.xcommon.GetCouponTaskIdMapResp', null, global);
goog.exportSymbol('proto.xcommon.GetCustomerDetailReq', null, global);
goog.exportSymbol('proto.xcommon.GetCustomerDetailResp', null, global);
goog.exportSymbol('proto.xcommon.GetCustomerOtherMobileReq', null, global);
goog.exportSymbol('proto.xcommon.GetCustomerOtherMobileResp', null, global);
goog.exportSymbol('proto.xcommon.GetOtherOrdersReq', null, global);
goog.exportSymbol('proto.xcommon.GetOtherOrdersResp', null, global);
goog.exportSymbol('proto.xcommon.GetOverdueCaseReq', null, global);
goog.exportSymbol('proto.xcommon.GetOverdueCaseResp', null, global);
goog.exportSymbol('proto.xcommon.GetOverdueListParamReq', null, global);
goog.exportSymbol('proto.xcommon.GetOverdueListParamResp', null, global);
goog.exportSymbol('proto.xcommon.GetOverdueListReq', null, global);
goog.exportSymbol('proto.xcommon.GetOverdueListResp', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneObjectsReq', null, global);
goog.exportSymbol('proto.xcommon.GetPhoneObjectsResp', null, global);
goog.exportSymbol('proto.xcommon.GetReductionListReq', null, global);
goog.exportSymbol('proto.xcommon.GetReductionListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRemindCaseReq', null, global);
goog.exportSymbol('proto.xcommon.GetRemindCaseResp', null, global);
goog.exportSymbol('proto.xcommon.GetRemindListReq', null, global);
goog.exportSymbol('proto.xcommon.GetRemindListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRepayReportInfoReq', null, global);
goog.exportSymbol('proto.xcommon.GetRepayReportInfoResp', null, global);
goog.exportSymbol('proto.xcommon.GetRobotCorpusMarkCaseListReq', null, global);
goog.exportSymbol('proto.xcommon.GetRobotCorpusMarkCaseListResp', null, global);
goog.exportSymbol('proto.xcommon.GetRobotCorpusMarkCaseReq', null, global);
goog.exportSymbol('proto.xcommon.GetRobotCorpusMarkCaseResp', null, global);
goog.exportSymbol('proto.xcommon.GetSmsTaskIdMapReq', null, global);
goog.exportSymbol('proto.xcommon.GetSmsTaskIdMapResp', null, global);
goog.exportSymbol('proto.xcommon.GetUrgeLetterMapReq', null, global);
goog.exportSymbol('proto.xcommon.GetUrgeLetterMapResp', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyListReq', null, global);
goog.exportSymbol('proto.xcommon.GetVerifyListResp', null, global);
goog.exportSymbol('proto.xcommon.GetVoipQICaseListReq', null, global);
goog.exportSymbol('proto.xcommon.GetVoipQICaseListResp', null, global);
goog.exportSymbol('proto.xcommon.GetVoipQICaseReq', null, global);
goog.exportSymbol('proto.xcommon.GetVoipQICaseResp', null, global);
goog.exportSymbol('proto.xcommon.GetWhatsAppMsgMapReq', null, global);
goog.exportSymbol('proto.xcommon.GetWhatsAppMsgMapResp', null, global);
goog.exportSymbol('proto.xcommon.OptionItem', null, global);
goog.exportSymbol('proto.xcommon.OtherOrderInfo', null, global);
goog.exportSymbol('proto.xcommon.OverdueCase', null, global);
goog.exportSymbol('proto.xcommon.OverdueCaseDetails', null, global);
goog.exportSymbol('proto.xcommon.PhoneInfos', null, global);
goog.exportSymbol('proto.xcommon.ReasonConfig', null, global);
goog.exportSymbol('proto.xcommon.ReduceCreditCardFeeReq', null, global);
goog.exportSymbol('proto.xcommon.ReduceCreditCardFeeResp', null, global);
goog.exportSymbol('proto.xcommon.RemindCaseDialog', null, global);
goog.exportSymbol('proto.xcommon.RemindCaseLog', null, global);
goog.exportSymbol('proto.xcommon.RepayPlanStageTab', null, global);
goog.exportSymbol('proto.xcommon.RepayRemindCase', null, global);
goog.exportSymbol('proto.xcommon.ReplayPlanPageAddField', null, global);
goog.exportSymbol('proto.xcommon.ResourceUseMark', null, global);
goog.exportSymbol('proto.xcommon.RiskReportShow', null, global);
goog.exportSymbol('proto.xcommon.RmTicket', null, global);
goog.exportSymbol('proto.xcommon.SaveContactReq', null, global);
goog.exportSymbol('proto.xcommon.SaveContactResp', null, global);
goog.exportSymbol('proto.xcommon.SaveOverdueCaseReq', null, global);
goog.exportSymbol('proto.xcommon.SaveOverdueCaseResp', null, global);
goog.exportSymbol('proto.xcommon.SaveRemindCaseReq', null, global);
goog.exportSymbol('proto.xcommon.SaveRemindCaseResp', null, global);
goog.exportSymbol('proto.xcommon.SaveRiskReportReq', null, global);
goog.exportSymbol('proto.xcommon.SaveRiskReportResp', null, global);
goog.exportSymbol('proto.xcommon.SaveRobotCorpusMarkCaseReq', null, global);
goog.exportSymbol('proto.xcommon.SaveRobotCorpusMarkCaseResp', null, global);
goog.exportSymbol('proto.xcommon.SaveUrgeCaseBaseInfo', null, global);
goog.exportSymbol('proto.xcommon.SaveVoipQICaseReq', null, global);
goog.exportSymbol('proto.xcommon.SaveVoipQICaseResp', null, global);
goog.exportSymbol('proto.xcommon.SaveWhatsappFlagReq', null, global);
goog.exportSymbol('proto.xcommon.SaveWhatsappFlagResp', null, global);
goog.exportSymbol('proto.xcommon.SendCouponByTaskIdReq', null, global);
goog.exportSymbol('proto.xcommon.SendCouponByTaskIdResp', null, global);
goog.exportSymbol('proto.xcommon.SendSmsByTaskIdReq', null, global);
goog.exportSymbol('proto.xcommon.SendSmsByTaskIdResp', null, global);
goog.exportSymbol('proto.xcommon.UpdateCustomerSalaryInfoReq', null, global);
goog.exportSymbol('proto.xcommon.UpdateCustomerSalaryInfoResp', null, global);
goog.exportSymbol('proto.xcommon.UpdateMarketPaymentCodeAmountReq', null, global);
goog.exportSymbol('proto.xcommon.UpdateMarketPaymentCodeAmountResp', null, global);
goog.exportSymbol('proto.xcommon.UploadDocumentReq', null, global);
goog.exportSymbol('proto.xcommon.UploadDocumentResp', null, global);
goog.exportSymbol('proto.xcommon.UrgeCaseBaseInfo', null, global);
goog.exportSymbol('proto.xcommon.VerifyTicket', null, global);
goog.exportSymbol('proto.xcommon.VoipQICaseData', null, global);
goog.exportSymbol('proto.xcommon.WBSNotifyData', null, global);
goog.exportSymbol('proto.xcommon.WebSocketNotifyResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVerifyListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVerifyListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyListReq.displayName = 'proto.xcommon.GetVerifyListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVerifyListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVerifyListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVerifyListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVerifyListResp.displayName = 'proto.xcommon.GetVerifyListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOverdueListParamReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOverdueListParamReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOverdueListParamReq.displayName = 'proto.xcommon.GetOverdueListParamReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOverdueListParamResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOverdueListParamResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOverdueListParamResp.displayName = 'proto.xcommon.GetOverdueListParamResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOverdueListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetOverdueListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetOverdueListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOverdueListReq.displayName = 'proto.xcommon.GetOverdueListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOverdueListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetOverdueListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetOverdueListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOverdueListResp.displayName = 'proto.xcommon.GetOverdueListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRemindListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRemindListReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRemindListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRemindListReq.displayName = 'proto.xcommon.GetRemindListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRemindListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRemindListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRemindListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRemindListResp.displayName = 'proto.xcommon.GetRemindListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOverdueCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOverdueCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOverdueCaseReq.displayName = 'proto.xcommon.GetOverdueCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOverdueCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOverdueCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOverdueCaseResp.displayName = 'proto.xcommon.GetOverdueCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRemindCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRemindCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRemindCaseReq.displayName = 'proto.xcommon.GetRemindCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRemindCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRemindCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRemindCaseResp.displayName = 'proto.xcommon.GetRemindCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.PhoneInfos = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.PhoneInfos, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.PhoneInfos.displayName = 'proto.xcommon.PhoneInfos';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ExtContacts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ExtContacts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ExtContacts.displayName = 'proto.xcommon.ExtContacts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeCaseBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.UrgeCaseBaseInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.UrgeCaseBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeCaseBaseInfo.displayName = 'proto.xcommon.UrgeCaseBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RepayPlanStageTab = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RepayPlanStageTab.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RepayPlanStageTab, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RepayPlanStageTab.displayName = 'proto.xcommon.RepayPlanStageTab';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.VerifyTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.VerifyTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.VerifyTicket.displayName = 'proto.xcommon.VerifyTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RmTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RmTicket.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RmTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RmTicket.displayName = 'proto.xcommon.RmTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CollectionTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CollectionTicket.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CollectionTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CollectionTicket.displayName = 'proto.xcommon.CollectionTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RepayRemindCase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RepayRemindCase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RepayRemindCase.displayName = 'proto.xcommon.RepayRemindCase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RemindCaseLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RemindCaseLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RemindCaseLog.displayName = 'proto.xcommon.RemindCaseLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RemindCaseDialog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RemindCaseDialog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RemindCaseDialog.displayName = 'proto.xcommon.RemindCaseDialog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReasonConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReasonConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReasonConfig.displayName = 'proto.xcommon.ReasonConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RiskReportShow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RiskReportShow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RiskReportShow.displayName = 'proto.xcommon.RiskReportShow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OverdueCase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OverdueCase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OverdueCase.displayName = 'proto.xcommon.OverdueCase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OverdueCaseDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OverdueCaseDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OverdueCaseDetails.displayName = 'proto.xcommon.OverdueCaseDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CaseLogDetailBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CaseLogDetailBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CaseLogDetailBackend.displayName = 'proto.xcommon.CaseLogDetailBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReplayPlanPageAddField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReplayPlanPageAddField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReplayPlanPageAddField.displayName = 'proto.xcommon.ReplayPlanPageAddField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountAlternativeContactUrge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountAlternativeContactUrge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountAlternativeContactUrge.displayName = 'proto.xcommon.AccountAlternativeContactUrge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OtherOrderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OtherOrderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OtherOrderInfo.displayName = 'proto.xcommon.OtherOrderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReductionListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetReductionListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReductionListReq.displayName = 'proto.xcommon.GetReductionListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetReductionListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetReductionListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetReductionListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetReductionListResp.displayName = 'proto.xcommon.GetReductionListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneObjectsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetPhoneObjectsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneObjectsReq.displayName = 'proto.xcommon.GetPhoneObjectsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetPhoneObjectsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetPhoneObjectsResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetPhoneObjectsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetPhoneObjectsResp.displayName = 'proto.xcommon.GetPhoneObjectsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveOverdueCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveOverdueCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveOverdueCaseReq.displayName = 'proto.xcommon.SaveOverdueCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveOverdueCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveOverdueCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveOverdueCaseResp.displayName = 'proto.xcommon.SaveOverdueCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveRemindCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveRemindCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveRemindCaseReq.displayName = 'proto.xcommon.SaveRemindCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveRemindCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveRemindCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveRemindCaseResp.displayName = 'proto.xcommon.SaveRemindCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveUrgeCaseBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveUrgeCaseBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveUrgeCaseBaseInfo.displayName = 'proto.xcommon.SaveUrgeCaseBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OptionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OptionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OptionItem.displayName = 'proto.xcommon.OptionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCustomerDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCustomerDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCustomerDetailReq.displayName = 'proto.xcommon.GetCustomerDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCustomerDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetCustomerDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetCustomerDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCustomerDetailResp.displayName = 'proto.xcommon.GetCustomerDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UpdateCustomerSalaryInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UpdateCustomerSalaryInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UpdateCustomerSalaryInfoReq.displayName = 'proto.xcommon.UpdateCustomerSalaryInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UpdateCustomerSalaryInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UpdateCustomerSalaryInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UpdateCustomerSalaryInfoResp.displayName = 'proto.xcommon.UpdateCustomerSalaryInfoResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetSmsTaskIdMapReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetSmsTaskIdMapReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetSmsTaskIdMapReq.displayName = 'proto.xcommon.GetSmsTaskIdMapReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetSmsTaskIdMapResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetSmsTaskIdMapResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetSmsTaskIdMapResp.displayName = 'proto.xcommon.GetSmsTaskIdMapResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SendSmsByTaskIdReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SendSmsByTaskIdReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SendSmsByTaskIdReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SendSmsByTaskIdReq.displayName = 'proto.xcommon.SendSmsByTaskIdReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SendSmsByTaskIdResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SendSmsByTaskIdResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SendSmsByTaskIdResp.displayName = 'proto.xcommon.SendSmsByTaskIdResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUrgeLetterMapReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUrgeLetterMapReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUrgeLetterMapReq.displayName = 'proto.xcommon.GetUrgeLetterMapReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetUrgeLetterMapResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetUrgeLetterMapResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetUrgeLetterMapResp.displayName = 'proto.xcommon.GetUrgeLetterMapResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DownloadUrgeLetterReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DownloadUrgeLetterReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DownloadUrgeLetterReq.displayName = 'proto.xcommon.DownloadUrgeLetterReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DownloadUrgeLetterResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DownloadUrgeLetterResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DownloadUrgeLetterResp.displayName = 'proto.xcommon.DownloadUrgeLetterResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UpdateMarketPaymentCodeAmountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UpdateMarketPaymentCodeAmountReq.displayName = 'proto.xcommon.UpdateMarketPaymentCodeAmountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UpdateMarketPaymentCodeAmountResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UpdateMarketPaymentCodeAmountResp.displayName = 'proto.xcommon.UpdateMarketPaymentCodeAmountResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CasePageTurningReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CasePageTurningReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CasePageTurningReq.displayName = 'proto.xcommon.CasePageTurningReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CasePageTurningResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CasePageTurningResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CasePageTurningResp.displayName = 'proto.xcommon.CasePageTurningResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveRiskReportReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveRiskReportReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveRiskReportReq.displayName = 'proto.xcommon.SaveRiskReportReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveRiskReportResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveRiskReportResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveRiskReportResp.displayName = 'proto.xcommon.SaveRiskReportResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveContactReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveContactReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveContactReq.displayName = 'proto.xcommon.SaveContactReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveContactResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveContactResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveContactResp.displayName = 'proto.xcommon.SaveContactResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWhatsAppMsgMapReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWhatsAppMsgMapReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWhatsAppMsgMapReq.displayName = 'proto.xcommon.GetWhatsAppMsgMapReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetWhatsAppMsgMapResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetWhatsAppMsgMapResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetWhatsAppMsgMapResp.displayName = 'proto.xcommon.GetWhatsAppMsgMapResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAllAutoCallResultReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetAllAutoCallResultReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAllAutoCallResultReq.displayName = 'proto.xcommon.GetAllAutoCallResultReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetAllAutoCallResultResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetAllAutoCallResultResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetAllAutoCallResultResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetAllAutoCallResultResp.displayName = 'proto.xcommon.GetAllAutoCallResultResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCaseLogDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCaseLogDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCaseLogDetailReq.displayName = 'proto.xcommon.GetCaseLogDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCaseLogDetailResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetCaseLogDetailResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetCaseLogDetailResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCaseLogDetailResp.displayName = 'proto.xcommon.GetCaseLogDetailResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreatePaymentVoucherReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CreatePaymentVoucherReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CreatePaymentVoucherReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreatePaymentVoucherReq.displayName = 'proto.xcommon.CreatePaymentVoucherReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreatePaymentVoucherResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreatePaymentVoucherResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreatePaymentVoucherResp.displayName = 'proto.xcommon.CreatePaymentVoucherResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UploadDocumentReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UploadDocumentReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UploadDocumentReq.displayName = 'proto.xcommon.UploadDocumentReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UploadDocumentResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UploadDocumentResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UploadDocumentResp.displayName = 'proto.xcommon.UploadDocumentResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DownloadDocumentReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DownloadDocumentReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DownloadDocumentReq.displayName = 'proto.xcommon.DownloadDocumentReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DownloadDocumentResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DownloadDocumentResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DownloadDocumentResp.displayName = 'proto.xcommon.DownloadDocumentResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCustomerOtherMobileReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCustomerOtherMobileReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCustomerOtherMobileReq.displayName = 'proto.xcommon.GetCustomerOtherMobileReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCustomerOtherMobileResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetCustomerOtherMobileResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetCustomerOtherMobileResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCustomerOtherMobileResp.displayName = 'proto.xcommon.GetCustomerOtherMobileResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCouponTaskIdMapReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCouponTaskIdMapReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCouponTaskIdMapReq.displayName = 'proto.xcommon.GetCouponTaskIdMapReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetCouponTaskIdMapResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetCouponTaskIdMapResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetCouponTaskIdMapResp.displayName = 'proto.xcommon.GetCouponTaskIdMapResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SendCouponByTaskIdReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SendCouponByTaskIdReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SendCouponByTaskIdReq.displayName = 'proto.xcommon.SendCouponByTaskIdReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SendCouponByTaskIdResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SendCouponByTaskIdResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SendCouponByTaskIdResp.displayName = 'proto.xcommon.SendCouponByTaskIdResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CalcMarketPaymentCodeFeeReq.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CalcMarketPaymentCodeFeeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CalcMarketPaymentCodeFeeReq.displayName = 'proto.xcommon.CalcMarketPaymentCodeFeeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CalcMarketPaymentCodeFeeResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CalcMarketPaymentCodeFeeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CalcMarketPaymentCodeFeeResp.displayName = 'proto.xcommon.CalcMarketPaymentCodeFeeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVoipQICaseListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetVoipQICaseListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVoipQICaseListReq.displayName = 'proto.xcommon.GetVoipQICaseListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVoipQICaseListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVoipQICaseListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVoipQICaseListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVoipQICaseListResp.displayName = 'proto.xcommon.GetVoipQICaseListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVoipQICaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetVoipQICaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVoipQICaseReq.displayName = 'proto.xcommon.GetVoipQICaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetVoipQICaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetVoipQICaseResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetVoipQICaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetVoipQICaseResp.displayName = 'proto.xcommon.GetVoipQICaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.DiscardReason = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.DiscardReason, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.DiscardReason.displayName = 'proto.xcommon.DiscardReason';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveVoipQICaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveVoipQICaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveVoipQICaseReq.displayName = 'proto.xcommon.SaveVoipQICaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.VoipQICaseData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.VoipQICaseData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.VoipQICaseData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.VoipQICaseData.displayName = 'proto.xcommon.VoipQICaseData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveVoipQICaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveVoipQICaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveVoipQICaseResp.displayName = 'proto.xcommon.SaveVoipQICaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceCreditCardFeeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceCreditCardFeeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceCreditCardFeeReq.displayName = 'proto.xcommon.ReduceCreditCardFeeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceCreditCardFeeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceCreditCardFeeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceCreditCardFeeResp.displayName = 'proto.xcommon.ReduceCreditCardFeeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayReportInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayReportInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayReportInfoReq.displayName = 'proto.xcommon.GetRepayReportInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRepayReportInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRepayReportInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRepayReportInfoResp.displayName = 'proto.xcommon.GetRepayReportInfoResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveWhatsappFlagReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveWhatsappFlagReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveWhatsappFlagReq.displayName = 'proto.xcommon.SaveWhatsappFlagReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveWhatsappFlagResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveWhatsappFlagResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveWhatsappFlagResp.displayName = 'proto.xcommon.SaveWhatsappFlagResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ApplyFrozenInterestReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ApplyFrozenInterestReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ApplyFrozenInterestReq.displayName = 'proto.xcommon.ApplyFrozenInterestReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ApplyFrozenInterestResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ApplyFrozenInterestResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ApplyFrozenInterestResp.displayName = 'proto.xcommon.ApplyFrozenInterestResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRobotCorpusMarkCaseListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRobotCorpusMarkCaseListReq.displayName = 'proto.xcommon.GetRobotCorpusMarkCaseListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.GetRobotCorpusMarkCaseListResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.GetRobotCorpusMarkCaseListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRobotCorpusMarkCaseListResp.displayName = 'proto.xcommon.GetRobotCorpusMarkCaseListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRobotCorpusMarkCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRobotCorpusMarkCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRobotCorpusMarkCaseReq.displayName = 'proto.xcommon.GetRobotCorpusMarkCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetRobotCorpusMarkCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetRobotCorpusMarkCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetRobotCorpusMarkCaseResp.displayName = 'proto.xcommon.GetRobotCorpusMarkCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveRobotCorpusMarkCaseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveRobotCorpusMarkCaseReq.displayName = 'proto.xcommon.SaveRobotCorpusMarkCaseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SaveRobotCorpusMarkCaseResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SaveRobotCorpusMarkCaseResp.displayName = 'proto.xcommon.SaveRobotCorpusMarkCaseResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CommonCollaborationNotifyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CommonCollaborationNotifyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CommonCollaborationNotifyReq.displayName = 'proto.xcommon.CommonCollaborationNotifyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WBSNotifyData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.WBSNotifyData.repeatedFields_, null);
};
goog.inherits(proto.xcommon.WBSNotifyData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WBSNotifyData.displayName = 'proto.xcommon.WBSNotifyData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.WebSocketNotifyResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.WebSocketNotifyResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.WebSocketNotifyResp.displayName = 'proto.xcommon.WebSocketNotifyResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreatePaymentLinkReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreatePaymentLinkReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreatePaymentLinkReq.displayName = 'proto.xcommon.CreatePaymentLinkReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreatePaymentLinkResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreatePaymentLinkResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreatePaymentLinkResp.displayName = 'proto.xcommon.CreatePaymentLinkResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOtherOrdersReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOtherOrdersReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOtherOrdersReq.displayName = 'proto.xcommon.GetOtherOrdersReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetOtherOrdersResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetOtherOrdersResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetOtherOrdersResp.displayName = 'proto.xcommon.GetOtherOrdersResp';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVerifyListReq.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    action: jspb.Message.getFieldWithDefault(msg, 4, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 7, 0),
    itemidList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    createtimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    verifyresult: jspb.Message.getFieldWithDefault(msg, 11, 0),
    inspectionresult: jspb.Message.getFieldWithDefault(msg, 12, 0),
    previtemid: jspb.Message.getFieldWithDefault(msg, 13, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyListReq}
 */
proto.xcommon.GetVerifyListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyListReq;
  return proto.xcommon.GetVerifyListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyListReq}
 */
proto.xcommon.GetVerifyListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsreloan(value);
      break;
    case 8:
      var values = /** @type {!Array<!proto.xcommon.TicketItemEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addItemid(values[i]);
      }
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVerifyresult(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInspectionresult(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setPrevitemid(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getItemidList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getVerifyresult();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getInspectionresult();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getPrevitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVerifyListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
*/
proto.xcommon.GetVerifyListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetVerifyListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
*/
proto.xcommon.GetVerifyListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.GetVerifyListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Action = 4;
 * @return {string}
 */
proto.xcommon.GetVerifyListReq.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetVerifyListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string CompleteTimeRange = 6;
 * @return {string}
 */
proto.xcommon.GetVerifyListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setCompletetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Bool IsReloan = 7;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetVerifyListReq.prototype.getIsreloan = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setIsreloan = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated TicketItemEnum ItemId = 8;
 * @return {!Array<!proto.xcommon.TicketItemEnum>}
 */
proto.xcommon.GetVerifyListReq.prototype.getItemidList = function() {
  return /** @type {!Array<!proto.xcommon.TicketItemEnum>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<!proto.xcommon.TicketItemEnum>} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setItemidList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.xcommon.TicketItemEnum} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.addItemid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.clearItemidList = function() {
  return this.setItemidList([]);
};


/**
 * optional string CreateTimeRange = 9;
 * @return {string}
 */
proto.xcommon.GetVerifyListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setCreatetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string AssignTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetVerifyListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setAssigntimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 VerifyResult = 11;
 * @return {number}
 */
proto.xcommon.GetVerifyListReq.prototype.getVerifyresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setVerifyresult = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 InspectionResult = 12;
 * @return {number}
 */
proto.xcommon.GetVerifyListReq.prototype.getInspectionresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setInspectionresult = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional TicketItemEnum PrevItemId = 13;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.xcommon.GetVerifyListReq.prototype.getPrevitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.xcommon.TicketItemEnum} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setPrevitemid = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string AppName = 14;
 * @return {string}
 */
proto.xcommon.GetVerifyListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListReq} returns this
 */
proto.xcommon.GetVerifyListReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVerifyListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVerifyListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVerifyListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVerifyListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.VerifyTicket.toObject, includeInstance),
    applist: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVerifyListResp}
 */
proto.xcommon.GetVerifyListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVerifyListResp;
  return proto.xcommon.GetVerifyListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVerifyListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVerifyListResp}
 */
proto.xcommon.GetVerifyListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.VerifyTicket;
      reader.readMessage(value,proto.xcommon.VerifyTicket.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVerifyListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVerifyListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVerifyListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVerifyListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.VerifyTicket.serializeBinaryToWriter
    );
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVerifyListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetVerifyListResp} returns this
*/
proto.xcommon.GetVerifyListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVerifyListResp} returns this
 */
proto.xcommon.GetVerifyListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetVerifyListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetVerifyListResp} returns this
*/
proto.xcommon.GetVerifyListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVerifyListResp} returns this
 */
proto.xcommon.GetVerifyListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVerifyListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated VerifyTicket List = 3;
 * @return {!Array<!proto.xcommon.VerifyTicket>}
 */
proto.xcommon.GetVerifyListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.VerifyTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.VerifyTicket, 3));
};


/**
 * @param {!Array<!proto.xcommon.VerifyTicket>} value
 * @return {!proto.xcommon.GetVerifyListResp} returns this
*/
proto.xcommon.GetVerifyListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.VerifyTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.VerifyTicket}
 */
proto.xcommon.GetVerifyListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.VerifyTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetVerifyListResp} returns this
 */
proto.xcommon.GetVerifyListResp.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional string AppList = 4;
 * @return {string}
 */
proto.xcommon.GetVerifyListResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVerifyListResp} returns this
 */
proto.xcommon.GetVerifyListResp.prototype.setApplist = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOverdueListParamReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOverdueListParamReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOverdueListParamReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListParamReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOverdueListParamReq}
 */
proto.xcommon.GetOverdueListParamReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOverdueListParamReq;
  return proto.xcommon.GetOverdueListParamReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOverdueListParamReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOverdueListParamReq}
 */
proto.xcommon.GetOverdueListParamReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOverdueListParamReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOverdueListParamReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOverdueListParamReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListParamReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOverdueListParamReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetOverdueListParamReq} returns this
*/
proto.xcommon.GetOverdueListParamReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueListParamReq} returns this
 */
proto.xcommon.GetOverdueListParamReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueListParamReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOverdueListParamResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOverdueListParamResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOverdueListParamResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListParamResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    tickettagmapMap: (f = msg.getTickettagmapMap()) ? f.toObject(includeInstance, undefined) : [],
    prestatusmapMap: (f = msg.getPrestatusmapMap()) ? f.toObject(includeInstance, undefined) : [],
    robotcallintenttagmapMap: (f = msg.getRobotcallintenttagmapMap()) ? f.toObject(includeInstance, undefined) : [],
    applist: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOverdueListParamResp}
 */
proto.xcommon.GetOverdueListParamResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOverdueListParamResp;
  return proto.xcommon.GetOverdueListParamResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOverdueListParamResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOverdueListParamResp}
 */
proto.xcommon.GetOverdueListParamResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getTickettagmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 3:
      var value = msg.getPrestatusmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 4:
      var value = msg.getRobotcallintenttagmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOverdueListParamResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOverdueListParamResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOverdueListParamResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListParamResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTickettagmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPrestatusmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRobotcallintenttagmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getApplist();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOverdueListParamResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetOverdueListParamResp} returns this
*/
proto.xcommon.GetOverdueListParamResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueListParamResp} returns this
 */
proto.xcommon.GetOverdueListParamResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueListParamResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int32, string> TicketTagMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetOverdueListParamResp.prototype.getTickettagmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetOverdueListParamResp} returns this
 */
proto.xcommon.GetOverdueListParamResp.prototype.clearTickettagmapMap = function() {
  this.getTickettagmapMap().clear();
  return this;
};


/**
 * map<int32, string> PreStatusMap = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetOverdueListParamResp.prototype.getPrestatusmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetOverdueListParamResp} returns this
 */
proto.xcommon.GetOverdueListParamResp.prototype.clearPrestatusmapMap = function() {
  this.getPrestatusmapMap().clear();
  return this;
};


/**
 * map<int32, string> RobotCallIntentTagMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetOverdueListParamResp.prototype.getRobotcallintenttagmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetOverdueListParamResp} returns this
 */
proto.xcommon.GetOverdueListParamResp.prototype.clearRobotcallintenttagmapMap = function() {
  this.getRobotcallintenttagmapMap().clear();
  return this;
};


/**
 * optional string AppList = 5;
 * @return {string}
 */
proto.xcommon.GetOverdueListParamResp.prototype.getApplist = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListParamResp} returns this
 */
proto.xcommon.GetOverdueListParamResp.prototype.setApplist = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetOverdueListReq.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOverdueListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOverdueListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOverdueListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    action: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    mobile: jspb.Message.getFieldWithDefault(msg, 6, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tickettag: jspb.Message.getFieldWithDefault(msg, 8, 0),
    overdueday: jspb.Message.getFieldWithDefault(msg, 9, ""),
    isroll: jspb.Message.getFieldWithDefault(msg, 10, 0),
    isrobot: jspb.Message.getFieldWithDefault(msg, 11, 0),
    prestatusList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    isreloan: jspb.Message.getFieldWithDefault(msg, 13, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOverdueListReq}
 */
proto.xcommon.GetOverdueListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOverdueListReq;
  return proto.xcommon.GetOverdueListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOverdueListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOverdueListReq}
 */
proto.xcommon.GetOverdueListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTickettag(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverdueday(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsroll(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsrobot(value);
      break;
    case 12:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPrestatus(values[i]);
      }
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOverdueListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOverdueListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOverdueListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTickettag();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getOverdueday();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsroll();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getIsrobot();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getPrestatusList();
  if (f.length > 0) {
    writer.writePackedInt32(
      12,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOverdueListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
*/
proto.xcommon.GetOverdueListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetOverdueListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
*/
proto.xcommon.GetOverdueListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Action = 3;
 * @return {string}
 */
proto.xcommon.GetOverdueListReq.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetOverdueListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetOverdueListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string Mobile = 6;
 * @return {string}
 */
proto.xcommon.GetOverdueListReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string CompleteTimeRange = 7;
 * @return {string}
 */
proto.xcommon.GetOverdueListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setCompletetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 TicketTag = 8;
 * @return {number}
 */
proto.xcommon.GetOverdueListReq.prototype.getTickettag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setTickettag = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string OverdueDay = 9;
 * @return {string}
 */
proto.xcommon.GetOverdueListReq.prototype.getOverdueday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setOverdueday = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional Bool IsRoll = 10;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetOverdueListReq.prototype.getIsroll = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setIsroll = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional Bool IsRobot = 11;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetOverdueListReq.prototype.getIsrobot = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setIsrobot = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * repeated int32 PreStatus = 12;
 * @return {!Array<number>}
 */
proto.xcommon.GetOverdueListReq.prototype.getPrestatusList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setPrestatusList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.addPrestatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.clearPrestatusList = function() {
  return this.setPrestatusList([]);
};


/**
 * optional int32 IsReloan = 13;
 * @return {number}
 */
proto.xcommon.GetOverdueListReq.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setIsreloan = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string AppName = 14;
 * @return {string}
 */
proto.xcommon.GetOverdueListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOverdueListReq} returns this
 */
proto.xcommon.GetOverdueListReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetOverdueListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOverdueListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOverdueListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOverdueListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.CollectionTicket.toObject, includeInstance),
    showreloan: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOverdueListResp}
 */
proto.xcommon.GetOverdueListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOverdueListResp;
  return proto.xcommon.GetOverdueListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOverdueListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOverdueListResp}
 */
proto.xcommon.GetOverdueListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.CollectionTicket;
      reader.readMessage(value,proto.xcommon.CollectionTicket.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowreloan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOverdueListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOverdueListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOverdueListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.CollectionTicket.serializeBinaryToWriter
    );
  }
  f = message.getShowreloan();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOverdueListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetOverdueListResp} returns this
*/
proto.xcommon.GetOverdueListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueListResp} returns this
 */
proto.xcommon.GetOverdueListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetOverdueListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetOverdueListResp} returns this
*/
proto.xcommon.GetOverdueListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueListResp} returns this
 */
proto.xcommon.GetOverdueListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CollectionTicket List = 3;
 * @return {!Array<!proto.xcommon.CollectionTicket>}
 */
proto.xcommon.GetOverdueListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.CollectionTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CollectionTicket, 3));
};


/**
 * @param {!Array<!proto.xcommon.CollectionTicket>} value
 * @return {!proto.xcommon.GetOverdueListResp} returns this
*/
proto.xcommon.GetOverdueListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.CollectionTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CollectionTicket}
 */
proto.xcommon.GetOverdueListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.CollectionTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetOverdueListResp} returns this
 */
proto.xcommon.GetOverdueListResp.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional bool ShowReloan = 4;
 * @return {boolean}
 */
proto.xcommon.GetOverdueListResp.prototype.getShowreloan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.GetOverdueListResp} returns this
 */
proto.xcommon.GetOverdueListResp.prototype.setShowreloan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRemindListReq.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRemindListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRemindListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRemindListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    relatedid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    action: jspb.Message.getFieldWithDefault(msg, 5, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    mobile: jspb.Message.getFieldWithDefault(msg, 7, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 8, ""),
    tickettag: jspb.Message.getFieldWithDefault(msg, 9, 0),
    overdueday: jspb.Message.getFieldWithDefault(msg, 10, ""),
    isroll: jspb.Message.getFieldWithDefault(msg, 11, 0),
    isrobot: jspb.Message.getFieldWithDefault(msg, 12, 0),
    prestatusList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    isreloan: jspb.Message.getFieldWithDefault(msg, 14, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRemindListReq}
 */
proto.xcommon.GetRemindListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRemindListReq;
  return proto.xcommon.GetRemindListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRemindListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRemindListReq}
 */
proto.xcommon.GetRemindListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRelatedid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTickettag(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverdueday(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsroll(value);
      break;
    case 12:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsrobot(value);
      break;
    case 13:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPrestatus(values[i]);
      }
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRemindListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRemindListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRemindListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRelatedid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTickettag();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getOverdueday();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getIsroll();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getIsrobot();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getPrestatusList();
  if (f.length > 0) {
    writer.writePackedInt32(
      13,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRemindListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
*/
proto.xcommon.GetRemindListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetRemindListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
*/
proto.xcommon.GetRemindListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.GetRemindListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 RelatedId = 4;
 * @return {number}
 */
proto.xcommon.GetRemindListReq.prototype.getRelatedid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setRelatedid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Action = 5;
 * @return {string}
 */
proto.xcommon.GetRemindListReq.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setAction = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 OrderId = 6;
 * @return {string}
 */
proto.xcommon.GetRemindListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string Mobile = 7;
 * @return {string}
 */
proto.xcommon.GetRemindListReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string CompleteTimeRange = 8;
 * @return {string}
 */
proto.xcommon.GetRemindListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setCompletetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 TicketTag = 9;
 * @return {number}
 */
proto.xcommon.GetRemindListReq.prototype.getTickettag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setTickettag = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string OverdueDay = 10;
 * @return {string}
 */
proto.xcommon.GetRemindListReq.prototype.getOverdueday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setOverdueday = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional Bool IsRoll = 11;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetRemindListReq.prototype.getIsroll = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setIsroll = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional Bool IsRobot = 12;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetRemindListReq.prototype.getIsrobot = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setIsrobot = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * repeated int32 PreStatus = 13;
 * @return {!Array<number>}
 */
proto.xcommon.GetRemindListReq.prototype.getPrestatusList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setPrestatusList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.addPrestatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.clearPrestatusList = function() {
  return this.setPrestatusList([]);
};


/**
 * optional int32 IsReloan = 14;
 * @return {number}
 */
proto.xcommon.GetRemindListReq.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setIsreloan = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string AppName = 15;
 * @return {string}
 */
proto.xcommon.GetRemindListReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRemindListReq} returns this
 */
proto.xcommon.GetRemindListReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRemindListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRemindListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRemindListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRemindListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.RmTicket.toObject, includeInstance),
    showreloan: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRemindListResp}
 */
proto.xcommon.GetRemindListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRemindListResp;
  return proto.xcommon.GetRemindListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRemindListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRemindListResp}
 */
proto.xcommon.GetRemindListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.RmTicket;
      reader.readMessage(value,proto.xcommon.RmTicket.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowreloan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRemindListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRemindListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRemindListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.RmTicket.serializeBinaryToWriter
    );
  }
  f = message.getShowreloan();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRemindListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetRemindListResp} returns this
*/
proto.xcommon.GetRemindListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindListResp} returns this
 */
proto.xcommon.GetRemindListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetRemindListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetRemindListResp} returns this
*/
proto.xcommon.GetRemindListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindListResp} returns this
 */
proto.xcommon.GetRemindListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated RmTicket List = 3;
 * @return {!Array<!proto.xcommon.RmTicket>}
 */
proto.xcommon.GetRemindListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.RmTicket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RmTicket, 3));
};


/**
 * @param {!Array<!proto.xcommon.RmTicket>} value
 * @return {!proto.xcommon.GetRemindListResp} returns this
*/
proto.xcommon.GetRemindListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RmTicket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RmTicket}
 */
proto.xcommon.GetRemindListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RmTicket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetRemindListResp} returns this
 */
proto.xcommon.GetRemindListResp.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional bool ShowReloan = 4;
 * @return {boolean}
 */
proto.xcommon.GetRemindListResp.prototype.getShowreloan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.GetRemindListResp} returns this
 */
proto.xcommon.GetRemindListResp.prototype.setShowreloan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOverdueCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOverdueCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOverdueCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOverdueCaseReq}
 */
proto.xcommon.GetOverdueCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOverdueCaseReq;
  return proto.xcommon.GetOverdueCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOverdueCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOverdueCaseReq}
 */
proto.xcommon.GetOverdueCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOverdueCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOverdueCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOverdueCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOverdueCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetOverdueCaseReq} returns this
*/
proto.xcommon.GetOverdueCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueCaseReq} returns this
 */
proto.xcommon.GetOverdueCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.GetOverdueCaseReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOverdueCaseReq} returns this
 */
proto.xcommon.GetOverdueCaseReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOverdueCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOverdueCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOverdueCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    urgebase: (f = msg.getUrgebase()) && proto.xcommon.UrgeCaseBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOverdueCaseResp}
 */
proto.xcommon.GetOverdueCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOverdueCaseResp;
  return proto.xcommon.GetOverdueCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOverdueCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOverdueCaseResp}
 */
proto.xcommon.GetOverdueCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.UrgeCaseBaseInfo;
      reader.readMessage(value,proto.xcommon.UrgeCaseBaseInfo.deserializeBinaryFromReader);
      msg.setUrgebase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOverdueCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOverdueCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOverdueCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOverdueCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUrgebase();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.UrgeCaseBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOverdueCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetOverdueCaseResp} returns this
*/
proto.xcommon.GetOverdueCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueCaseResp} returns this
 */
proto.xcommon.GetOverdueCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UrgeCaseBaseInfo UrgeBase = 2;
 * @return {?proto.xcommon.UrgeCaseBaseInfo}
 */
proto.xcommon.GetOverdueCaseResp.prototype.getUrgebase = function() {
  return /** @type{?proto.xcommon.UrgeCaseBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.UrgeCaseBaseInfo, 2));
};


/**
 * @param {?proto.xcommon.UrgeCaseBaseInfo|undefined} value
 * @return {!proto.xcommon.GetOverdueCaseResp} returns this
*/
proto.xcommon.GetOverdueCaseResp.prototype.setUrgebase = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOverdueCaseResp} returns this
 */
proto.xcommon.GetOverdueCaseResp.prototype.clearUrgebase = function() {
  return this.setUrgebase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOverdueCaseResp.prototype.hasUrgebase = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRemindCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRemindCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRemindCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRemindCaseReq}
 */
proto.xcommon.GetRemindCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRemindCaseReq;
  return proto.xcommon.GetRemindCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRemindCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRemindCaseReq}
 */
proto.xcommon.GetRemindCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRemindCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRemindCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRemindCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRemindCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetRemindCaseReq} returns this
*/
proto.xcommon.GetRemindCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindCaseReq} returns this
 */
proto.xcommon.GetRemindCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.GetRemindCaseReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRemindCaseReq} returns this
 */
proto.xcommon.GetRemindCaseReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRemindCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRemindCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRemindCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    urgebase: (f = msg.getUrgebase()) && proto.xcommon.UrgeCaseBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRemindCaseResp}
 */
proto.xcommon.GetRemindCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRemindCaseResp;
  return proto.xcommon.GetRemindCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRemindCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRemindCaseResp}
 */
proto.xcommon.GetRemindCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.UrgeCaseBaseInfo;
      reader.readMessage(value,proto.xcommon.UrgeCaseBaseInfo.deserializeBinaryFromReader);
      msg.setUrgebase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRemindCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRemindCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRemindCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRemindCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUrgebase();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.UrgeCaseBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRemindCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetRemindCaseResp} returns this
*/
proto.xcommon.GetRemindCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindCaseResp} returns this
 */
proto.xcommon.GetRemindCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UrgeCaseBaseInfo UrgeBase = 2;
 * @return {?proto.xcommon.UrgeCaseBaseInfo}
 */
proto.xcommon.GetRemindCaseResp.prototype.getUrgebase = function() {
  return /** @type{?proto.xcommon.UrgeCaseBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.UrgeCaseBaseInfo, 2));
};


/**
 * @param {?proto.xcommon.UrgeCaseBaseInfo|undefined} value
 * @return {!proto.xcommon.GetRemindCaseResp} returns this
*/
proto.xcommon.GetRemindCaseResp.prototype.setUrgebase = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRemindCaseResp} returns this
 */
proto.xcommon.GetRemindCaseResp.prototype.clearUrgebase = function() {
  return this.setUrgebase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRemindCaseResp.prototype.hasUrgebase = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.PhoneInfos.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.PhoneInfos.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.PhoneInfos} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneInfos.toObject = function(includeInstance, msg) {
  var f, obj = {
    mobiledes: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mobilenxsalt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contact1des: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contact2des: jspb.Message.getFieldWithDefault(msg, 4, ""),
    contact3des: jspb.Message.getFieldWithDefault(msg, 5, ""),
    contact1nxsalt: jspb.Message.getFieldWithDefault(msg, 6, ""),
    contact2nxsalt: jspb.Message.getFieldWithDefault(msg, 7, ""),
    contact3nxsalt: jspb.Message.getFieldWithDefault(msg, 8, ""),
    secondmobiledes: jspb.Message.getFieldWithDefault(msg, 9, ""),
    secondmobilenxsalt: jspb.Message.getFieldWithDefault(msg, 10, ""),
    familydes: jspb.Message.getFieldWithDefault(msg, 11, ""),
    familynxsalt: jspb.Message.getFieldWithDefault(msg, 12, ""),
    sparemobile: jspb.Message.getFieldWithDefault(msg, 13, ""),
    contact4des: jspb.Message.getFieldWithDefault(msg, 14, ""),
    contact4nxsalt: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.PhoneInfos}
 */
proto.xcommon.PhoneInfos.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.PhoneInfos;
  return proto.xcommon.PhoneInfos.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.PhoneInfos} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.PhoneInfos}
 */
proto.xcommon.PhoneInfos.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobiledes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilenxsalt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1des(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2des(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3des(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1nxsalt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2nxsalt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3nxsalt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondmobiledes(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondmobilenxsalt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilydes(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilynxsalt(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSparemobile(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact4des(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact4nxsalt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.PhoneInfos.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.PhoneInfos.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.PhoneInfos} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.PhoneInfos.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMobiledes();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMobilenxsalt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContact1des();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContact2des();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getContact3des();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContact1nxsalt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getContact2nxsalt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getContact3nxsalt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSecondmobiledes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecondmobilenxsalt();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFamilydes();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFamilynxsalt();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSparemobile();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getContact4des();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getContact4nxsalt();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string MobileDes = 1;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getMobiledes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setMobiledes = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string MobileNXSalt = 2;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getMobilenxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setMobilenxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Contact1Des = 3;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact1des = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact1des = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Contact2Des = 4;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact2des = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact2des = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Contact3Des = 5;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact3des = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact3des = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Contact1NXSalt = 6;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact1nxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact1nxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Contact2NXSalt = 7;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact2nxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact2nxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Contact3NXSalt = 8;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact3nxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact3nxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string SecondMobileDes = 9;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getSecondmobiledes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setSecondmobiledes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string SecondMobileNXSalt = 10;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getSecondmobilenxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setSecondmobilenxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string FamilyDes = 11;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getFamilydes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setFamilydes = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string FamilyNXSalt = 12;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getFamilynxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setFamilynxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string SpareMobile = 13;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getSparemobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setSparemobile = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Contact4Des = 14;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact4des = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact4des = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string Contact4NXSalt = 15;
 * @return {string}
 */
proto.xcommon.PhoneInfos.prototype.getContact4nxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.PhoneInfos} returns this
 */
proto.xcommon.PhoneInfos.prototype.setContact4nxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ExtContacts.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ExtContacts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ExtContacts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtContacts.toObject = function(includeInstance, msg) {
  var f, obj = {
    extcontactdes: jspb.Message.getFieldWithDefault(msg, 1, ""),
    extcontactnxsalt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    extrelationship: jspb.Message.getFieldWithDefault(msg, 3, 0),
    extname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    extcontactid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    extcontactobject: jspb.Message.getFieldWithDefault(msg, 6, ""),
    extcontactobjectid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ExtContacts}
 */
proto.xcommon.ExtContacts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ExtContacts;
  return proto.xcommon.ExtContacts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ExtContacts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ExtContacts}
 */
proto.xcommon.ExtContacts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtcontactdes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtcontactnxsalt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExtrelationship(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtcontactid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtcontactobject(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtcontactobjectid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ExtContacts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ExtContacts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ExtContacts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ExtContacts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExtcontactdes();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExtcontactnxsalt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExtrelationship();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getExtname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExtcontactid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getExtcontactobject();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExtcontactobjectid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string ExtContactDes = 1;
 * @return {string}
 */
proto.xcommon.ExtContacts.prototype.getExtcontactdes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtcontactdes = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ExtContactNXSalt = 2;
 * @return {string}
 */
proto.xcommon.ExtContacts.prototype.getExtcontactnxsalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtcontactnxsalt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 ExtRelationship = 3;
 * @return {number}
 */
proto.xcommon.ExtContacts.prototype.getExtrelationship = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtrelationship = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string ExtName = 4;
 * @return {string}
 */
proto.xcommon.ExtContacts.prototype.getExtname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 ExtContactID = 5;
 * @return {number}
 */
proto.xcommon.ExtContacts.prototype.getExtcontactid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtcontactid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string ExtContactObject = 6;
 * @return {string}
 */
proto.xcommon.ExtContacts.prototype.getExtcontactobject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtcontactobject = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 ExtContactObjectID = 7;
 * @return {number}
 */
proto.xcommon.ExtContacts.prototype.getExtcontactobjectid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setExtcontactobjectid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.ExtContacts.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ExtContacts} returns this
 */
proto.xcommon.ExtContacts.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.UrgeCaseBaseInfo.repeatedFields_ = [8,33,41,46,47,48];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeCaseBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeCaseBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeCaseBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountbase: (f = msg.getAccountbase()) && xcommon_core_pb.AccountBaseInfo.toObject(includeInstance, f),
    accountprofile: (f = msg.getAccountprofile()) && xcommon_core_pb.AccountProfileInfo.toObject(includeInstance, f),
    urgecase: (f = msg.getUrgecase()) && proto.xcommon.OverdueCase.toObject(includeInstance, f),
    remindcase: (f = msg.getRemindcase()) && proto.xcommon.RepayRemindCase.toObject(includeInstance, f),
    orderdata: (f = msg.getOrderdata()) && xcommon_core_pb.OrderInfo.toObject(includeInstance, f),
    ticketdata: (f = msg.getTicketdata()) && xcommon_ticket_pb.Ticket.toObject(includeInstance, f),
    repayplan: (f = msg.getRepayplan()) && xcommon_core_pb.RepayPlanInfo.toObject(includeInstance, f),
    repayplanstageList: jspb.Message.toObjectList(msg.getRepayplanstageList(),
    xcommon_core_pb.RepayPlanStageInfo.toObject, includeInstance),
    autocallresult: (f = msg.getAutocallresult()) && xcommon_core_pb.AutoCallResultInfo.toObject(includeInstance, f),
    repayinfo: (f = msg.getRepayinfo()) && xcommon_core_pb.UrgeRepayInfo.toObject(includeInstance, f),
    loaninfo: (f = msg.getLoaninfo()) && xcommon_core_pb.UrgeLoanInfo.toObject(includeInstance, f),
    repayinclinationmapMap: (f = msg.getRepayinclinationmapMap()) ? f.toObject(includeInstance, undefined) : [],
    notrepayreasonmapMap: (f = msg.getNotrepayreasonmapMap()) ? f.toObject(includeInstance, undefined) : [],
    urgeresultmapMap: (f = msg.getUrgeresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    communicationwaymapMap: (f = msg.getCommunicationwaymapMap()) ? f.toObject(includeInstance, undefined) : [],
    smstaskidmapMap: (f = msg.getSmstaskidmapMap()) ? f.toObject(includeInstance, undefined) : [],
    relationshipmapMap: (f = msg.getRelationshipmapMap()) ? f.toObject(includeInstance, undefined) : [],
    smscontentmapMap: (f = msg.getSmscontentmapMap()) ? f.toObject(includeInstance, undefined) : [],
    riskreportmapMap: (f = msg.getRiskreportmapMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneinfo: (f = msg.getPhoneinfo()) && proto.xcommon.PhoneInfos.toObject(includeInstance, f),
    phoneobjectMap: (f = msg.getPhoneobjectMap()) ? f.toObject(includeInstance, undefined) : [],
    lastphoneconnect: jspb.Message.getFieldWithDefault(msg, 30, 0),
    urgestatusmsg: jspb.Message.getFieldWithDefault(msg, 31, ""),
    repayinclination: jspb.Message.getFieldWithDefault(msg, 32, 0),
    extcontactList: jspb.Message.toObjectList(msg.getExtcontactList(),
    proto.xcommon.ExtContacts.toObject, includeInstance),
    phoneobjectmobileMap: (f = msg.getPhoneobjectmobileMap()) ? f.toObject(includeInstance, undefined) : [],
    ishidewhatsapp: jspb.Message.getFieldWithDefault(msg, 35, 0),
    isshowcouponmap: jspb.Message.getFieldWithDefault(msg, 36, 0),
    customerothermobileMap: (f = msg.getCustomerothermobileMap()) ? f.toObject(includeInstance, undefined) : [],
    havecustomerothermobile: jspb.Message.getFieldWithDefault(msg, 38, 0),
    ticketclassify: jspb.Message.getFieldWithDefault(msg, 39, ""),
    suppliertypeList: (f = jspb.Message.getRepeatedField(msg, 41)) == null ? undefined : f,
    whatsappflagMap: (f = msg.getWhatsappflagMap()) ? f.toObject(includeInstance, undefined) : [],
    accountsocials: (f = msg.getAccountsocials()) && xcommon_core_pb.AccountSocialInfo.toObject(includeInstance, f),
    urgeresultconnectedmapMap: (f = msg.getUrgeresultconnectedmapMap()) ? f.toObject(includeInstance, undefined) : [],
    ismutiloan: jspb.Message.getFieldWithDefault(msg, 45, 0),
    rollinfolistList: jspb.Message.toObjectList(msg.getRollinfolistList(),
    xcommon_core_pb.UrgeRollInfo.toObject, includeInstance),
    loaninfolistList: jspb.Message.toObjectList(msg.getLoaninfolistList(),
    xcommon_core_pb.UrgeLoanInfo.toObject, includeInstance),
    repayplanstagetablistList: jspb.Message.toObjectList(msg.getRepayplanstagetablistList(),
    proto.xcommon.RepayPlanStageTab.toObject, includeInstance),
    nocopymobileself: jspb.Message.getFieldWithDefault(msg, 49, 0),
    nocopymobilecontact: jspb.Message.getFieldWithDefault(msg, 50, 0),
    robotcalltags: jspb.Message.getFieldWithDefault(msg, 51, ""),
    suggest: (f = msg.getSuggest()) && xcommon_core_pb.SuggestInfo.toObject(includeInstance, f),
    showsuggest: jspb.Message.getFieldWithDefault(msg, 53, 0),
    customization: (f = msg.getCustomization()) && xcommon_core_pb.OrderCustomization.toObject(includeInstance, f),
    ordertags: (f = msg.getOrdertags()) && xcommon_core_pb.OrderTagExtInfo.toObject(includeInstance, f),
    ishiddencontact: jspb.Message.getFieldWithDefault(msg, 56, 0),
    phoneconnectedurgeresultmapMap: (f = msg.getPhoneconnectedurgeresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    phoneunconnectedurgeresultmapMap: (f = msg.getPhoneunconnectedurgeresultmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeCaseBaseInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeCaseBaseInfo;
  return proto.xcommon.UrgeCaseBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeCaseBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeCaseBaseInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_core_pb.AccountBaseInfo;
      reader.readMessage(value,xcommon_core_pb.AccountBaseInfo.deserializeBinaryFromReader);
      msg.setAccountbase(value);
      break;
    case 2:
      var value = new xcommon_core_pb.AccountProfileInfo;
      reader.readMessage(value,xcommon_core_pb.AccountProfileInfo.deserializeBinaryFromReader);
      msg.setAccountprofile(value);
      break;
    case 3:
      var value = new proto.xcommon.OverdueCase;
      reader.readMessage(value,proto.xcommon.OverdueCase.deserializeBinaryFromReader);
      msg.setUrgecase(value);
      break;
    case 4:
      var value = new proto.xcommon.RepayRemindCase;
      reader.readMessage(value,proto.xcommon.RepayRemindCase.deserializeBinaryFromReader);
      msg.setRemindcase(value);
      break;
    case 5:
      var value = new xcommon_core_pb.OrderInfo;
      reader.readMessage(value,xcommon_core_pb.OrderInfo.deserializeBinaryFromReader);
      msg.setOrderdata(value);
      break;
    case 6:
      var value = new xcommon_ticket_pb.Ticket;
      reader.readMessage(value,xcommon_ticket_pb.Ticket.deserializeBinaryFromReader);
      msg.setTicketdata(value);
      break;
    case 7:
      var value = new xcommon_core_pb.RepayPlanInfo;
      reader.readMessage(value,xcommon_core_pb.RepayPlanInfo.deserializeBinaryFromReader);
      msg.setRepayplan(value);
      break;
    case 8:
      var value = new xcommon_core_pb.RepayPlanStageInfo;
      reader.readMessage(value,xcommon_core_pb.RepayPlanStageInfo.deserializeBinaryFromReader);
      msg.addRepayplanstage(value);
      break;
    case 10:
      var value = new xcommon_core_pb.AutoCallResultInfo;
      reader.readMessage(value,xcommon_core_pb.AutoCallResultInfo.deserializeBinaryFromReader);
      msg.setAutocallresult(value);
      break;
    case 12:
      var value = new xcommon_core_pb.UrgeRepayInfo;
      reader.readMessage(value,xcommon_core_pb.UrgeRepayInfo.deserializeBinaryFromReader);
      msg.setRepayinfo(value);
      break;
    case 13:
      var value = new xcommon_core_pb.UrgeLoanInfo;
      reader.readMessage(value,xcommon_core_pb.UrgeLoanInfo.deserializeBinaryFromReader);
      msg.setLoaninfo(value);
      break;
    case 14:
      var value = msg.getRepayinclinationmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 15:
      var value = msg.getNotrepayreasonmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 16:
      var value = msg.getUrgeresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 17:
      var value = msg.getCommunicationwaymapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 18:
      var value = msg.getSmstaskidmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 23:
      var value = msg.getRelationshipmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 24:
      var value = msg.getSmscontentmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 27:
      var value = msg.getRiskreportmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 28:
      var value = new proto.xcommon.PhoneInfos;
      reader.readMessage(value,proto.xcommon.PhoneInfos.deserializeBinaryFromReader);
      msg.setPhoneinfo(value);
      break;
    case 29:
      var value = msg.getPhoneobjectMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastphoneconnect(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgestatusmsg(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRepayinclination(value);
      break;
    case 33:
      var value = new proto.xcommon.ExtContacts;
      reader.readMessage(value,proto.xcommon.ExtContacts.deserializeBinaryFromReader);
      msg.addExtcontact(value);
      break;
    case 34:
      var value = msg.getPhoneobjectmobileMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIshidewhatsapp(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsshowcouponmap(value);
      break;
    case 37:
      var value = msg.getCustomerothermobileMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 38:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHavecustomerothermobile(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketclassify(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuppliertype(value);
      break;
    case 42:
      var value = msg.getWhatsappflagMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readInt32, null, 0, 0);
         });
      break;
    case 43:
      var value = new xcommon_core_pb.AccountSocialInfo;
      reader.readMessage(value,xcommon_core_pb.AccountSocialInfo.deserializeBinaryFromReader);
      msg.setAccountsocials(value);
      break;
    case 44:
      var value = msg.getUrgeresultconnectedmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readInt32, null, 0, 0);
         });
      break;
    case 45:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsmutiloan(value);
      break;
    case 46:
      var value = new xcommon_core_pb.UrgeRollInfo;
      reader.readMessage(value,xcommon_core_pb.UrgeRollInfo.deserializeBinaryFromReader);
      msg.addRollinfolist(value);
      break;
    case 47:
      var value = new xcommon_core_pb.UrgeLoanInfo;
      reader.readMessage(value,xcommon_core_pb.UrgeLoanInfo.deserializeBinaryFromReader);
      msg.addLoaninfolist(value);
      break;
    case 48:
      var value = new proto.xcommon.RepayPlanStageTab;
      reader.readMessage(value,proto.xcommon.RepayPlanStageTab.deserializeBinaryFromReader);
      msg.addRepayplanstagetablist(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNocopymobileself(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNocopymobilecontact(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setRobotcalltags(value);
      break;
    case 52:
      var value = new xcommon_core_pb.SuggestInfo;
      reader.readMessage(value,xcommon_core_pb.SuggestInfo.deserializeBinaryFromReader);
      msg.setSuggest(value);
      break;
    case 53:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setShowsuggest(value);
      break;
    case 54:
      var value = new xcommon_core_pb.OrderCustomization;
      reader.readMessage(value,xcommon_core_pb.OrderCustomization.deserializeBinaryFromReader);
      msg.setCustomization(value);
      break;
    case 55:
      var value = new xcommon_core_pb.OrderTagExtInfo;
      reader.readMessage(value,xcommon_core_pb.OrderTagExtInfo.deserializeBinaryFromReader);
      msg.setOrdertags(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIshiddencontact(value);
      break;
    case 57:
      var value = msg.getPhoneconnectedurgeresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 58:
      var value = msg.getPhoneunconnectedurgeresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeCaseBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeCaseBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeCaseBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountbase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_core_pb.AccountBaseInfo.serializeBinaryToWriter
    );
  }
  f = message.getAccountprofile();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_core_pb.AccountProfileInfo.serializeBinaryToWriter
    );
  }
  f = message.getUrgecase();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.xcommon.OverdueCase.serializeBinaryToWriter
    );
  }
  f = message.getRemindcase();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.RepayRemindCase.serializeBinaryToWriter
    );
  }
  f = message.getOrderdata();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      xcommon_core_pb.OrderInfo.serializeBinaryToWriter
    );
  }
  f = message.getTicketdata();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      xcommon_ticket_pb.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getRepayplan();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      xcommon_core_pb.RepayPlanInfo.serializeBinaryToWriter
    );
  }
  f = message.getRepayplanstageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      xcommon_core_pb.RepayPlanStageInfo.serializeBinaryToWriter
    );
  }
  f = message.getAutocallresult();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      xcommon_core_pb.AutoCallResultInfo.serializeBinaryToWriter
    );
  }
  f = message.getRepayinfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      xcommon_core_pb.UrgeRepayInfo.serializeBinaryToWriter
    );
  }
  f = message.getLoaninfo();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      xcommon_core_pb.UrgeLoanInfo.serializeBinaryToWriter
    );
  }
  f = message.getRepayinclinationmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(14, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getNotrepayreasonmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(15, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getUrgeresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(16, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCommunicationwaymapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(17, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getSmstaskidmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(18, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRelationshipmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(23, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getSmscontentmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(24, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRiskreportmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(27, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneinfo();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.xcommon.PhoneInfos.serializeBinaryToWriter
    );
  }
  f = message.getPhoneobjectMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(29, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLastphoneconnect();
  if (f !== 0) {
    writer.writeInt32(
      30,
      f
    );
  }
  f = message.getUrgestatusmsg();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getRepayinclination();
  if (f !== 0) {
    writer.writeInt32(
      32,
      f
    );
  }
  f = message.getExtcontactList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      33,
      f,
      proto.xcommon.ExtContacts.serializeBinaryToWriter
    );
  }
  f = message.getPhoneobjectmobileMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(34, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getIshidewhatsapp();
  if (f !== 0) {
    writer.writeInt32(
      35,
      f
    );
  }
  f = message.getIsshowcouponmap();
  if (f !== 0) {
    writer.writeInt32(
      36,
      f
    );
  }
  f = message.getCustomerothermobileMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(37, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getHavecustomerothermobile();
  if (f !== 0) {
    writer.writeInt32(
      38,
      f
    );
  }
  f = message.getTicketclassify();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getSuppliertypeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      41,
      f
    );
  }
  f = message.getWhatsappflagMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(42, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeInt32);
  }
  f = message.getAccountsocials();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      xcommon_core_pb.AccountSocialInfo.serializeBinaryToWriter
    );
  }
  f = message.getUrgeresultconnectedmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(44, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeInt32);
  }
  f = message.getIsmutiloan();
  if (f !== 0) {
    writer.writeInt32(
      45,
      f
    );
  }
  f = message.getRollinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      46,
      f,
      xcommon_core_pb.UrgeRollInfo.serializeBinaryToWriter
    );
  }
  f = message.getLoaninfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      47,
      f,
      xcommon_core_pb.UrgeLoanInfo.serializeBinaryToWriter
    );
  }
  f = message.getRepayplanstagetablistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      48,
      f,
      proto.xcommon.RepayPlanStageTab.serializeBinaryToWriter
    );
  }
  f = message.getNocopymobileself();
  if (f !== 0) {
    writer.writeInt32(
      49,
      f
    );
  }
  f = message.getNocopymobilecontact();
  if (f !== 0) {
    writer.writeInt32(
      50,
      f
    );
  }
  f = message.getRobotcalltags();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = message.getSuggest();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      xcommon_core_pb.SuggestInfo.serializeBinaryToWriter
    );
  }
  f = message.getShowsuggest();
  if (f !== 0.0) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = message.getCustomization();
  if (f != null) {
    writer.writeMessage(
      54,
      f,
      xcommon_core_pb.OrderCustomization.serializeBinaryToWriter
    );
  }
  f = message.getOrdertags();
  if (f != null) {
    writer.writeMessage(
      55,
      f,
      xcommon_core_pb.OrderTagExtInfo.serializeBinaryToWriter
    );
  }
  f = message.getIshiddencontact();
  if (f !== 0) {
    writer.writeInt32(
      56,
      f
    );
  }
  f = message.getPhoneconnectedurgeresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(57, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPhoneunconnectedurgeresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(58, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional AccountBaseInfo AccountBase = 1;
 * @return {?proto.xcommon.AccountBaseInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getAccountbase = function() {
  return /** @type{?proto.xcommon.AccountBaseInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountBaseInfo, 1));
};


/**
 * @param {?proto.xcommon.AccountBaseInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setAccountbase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearAccountbase = function() {
  return this.setAccountbase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasAccountbase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AccountProfileInfo AccountProfile = 2;
 * @return {?proto.xcommon.AccountProfileInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getAccountprofile = function() {
  return /** @type{?proto.xcommon.AccountProfileInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountProfileInfo, 2));
};


/**
 * @param {?proto.xcommon.AccountProfileInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setAccountprofile = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearAccountprofile = function() {
  return this.setAccountprofile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasAccountprofile = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OverdueCase UrgeCase = 3;
 * @return {?proto.xcommon.OverdueCase}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getUrgecase = function() {
  return /** @type{?proto.xcommon.OverdueCase} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.OverdueCase, 3));
};


/**
 * @param {?proto.xcommon.OverdueCase|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setUrgecase = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearUrgecase = function() {
  return this.setUrgecase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasUrgecase = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RepayRemindCase RemindCase = 4;
 * @return {?proto.xcommon.RepayRemindCase}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRemindcase = function() {
  return /** @type{?proto.xcommon.RepayRemindCase} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.RepayRemindCase, 4));
};


/**
 * @param {?proto.xcommon.RepayRemindCase|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setRemindcase = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRemindcase = function() {
  return this.setRemindcase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasRemindcase = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional OrderInfo OrderData = 5;
 * @return {?proto.xcommon.OrderInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getOrderdata = function() {
  return /** @type{?proto.xcommon.OrderInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderInfo, 5));
};


/**
 * @param {?proto.xcommon.OrderInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setOrderdata = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearOrderdata = function() {
  return this.setOrderdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasOrderdata = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Ticket TicketData = 6;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getTicketdata = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.Ticket, 6));
};


/**
 * @param {?proto.xcommon.Ticket|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setTicketdata = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearTicketdata = function() {
  return this.setTicketdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasTicketdata = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RepayPlanInfo RepayPlan = 7;
 * @return {?proto.xcommon.RepayPlanInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRepayplan = function() {
  return /** @type{?proto.xcommon.RepayPlanInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.RepayPlanInfo, 7));
};


/**
 * @param {?proto.xcommon.RepayPlanInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setRepayplan = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRepayplan = function() {
  return this.setRepayplan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasRepayplan = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated RepayPlanStageInfo RepayPlanStage = 8;
 * @return {!Array<!proto.xcommon.RepayPlanStageInfo>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRepayplanstageList = function() {
  return /** @type{!Array<!proto.xcommon.RepayPlanStageInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.RepayPlanStageInfo, 8));
};


/**
 * @param {!Array<!proto.xcommon.RepayPlanStageInfo>} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setRepayplanstageList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.xcommon.RepayPlanStageInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RepayPlanStageInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.addRepayplanstage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.xcommon.RepayPlanStageInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRepayplanstageList = function() {
  return this.setRepayplanstageList([]);
};


/**
 * optional AutoCallResultInfo AutoCallResult = 10;
 * @return {?proto.xcommon.AutoCallResultInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getAutocallresult = function() {
  return /** @type{?proto.xcommon.AutoCallResultInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AutoCallResultInfo, 10));
};


/**
 * @param {?proto.xcommon.AutoCallResultInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setAutocallresult = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearAutocallresult = function() {
  return this.setAutocallresult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasAutocallresult = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional UrgeRepayInfo RepayInfo = 12;
 * @return {?proto.xcommon.UrgeRepayInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRepayinfo = function() {
  return /** @type{?proto.xcommon.UrgeRepayInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.UrgeRepayInfo, 12));
};


/**
 * @param {?proto.xcommon.UrgeRepayInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setRepayinfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRepayinfo = function() {
  return this.setRepayinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasRepayinfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional UrgeLoanInfo LoanInfo = 13;
 * @return {?proto.xcommon.UrgeLoanInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getLoaninfo = function() {
  return /** @type{?proto.xcommon.UrgeLoanInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.UrgeLoanInfo, 13));
};


/**
 * @param {?proto.xcommon.UrgeLoanInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setLoaninfo = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearLoaninfo = function() {
  return this.setLoaninfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasLoaninfo = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * map<int32, string> RepayInclinationMap = 14;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRepayinclinationmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 14, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRepayinclinationmapMap = function() {
  this.getRepayinclinationmapMap().clear();
  return this;
};


/**
 * map<int32, string> NotRepayReasonMap = 15;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getNotrepayreasonmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 15, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearNotrepayreasonmapMap = function() {
  this.getNotrepayreasonmapMap().clear();
  return this;
};


/**
 * map<int32, string> UrgeResultMap = 16;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getUrgeresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 16, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearUrgeresultmapMap = function() {
  this.getUrgeresultmapMap().clear();
  return this;
};


/**
 * map<int32, string> CommunicationWayMap = 17;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getCommunicationwaymapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 17, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearCommunicationwaymapMap = function() {
  this.getCommunicationwaymapMap().clear();
  return this;
};


/**
 * map<int64, string> SmsTaskIdMap = 18;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getSmstaskidmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 18, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearSmstaskidmapMap = function() {
  this.getSmstaskidmapMap().clear();
  return this;
};


/**
 * map<int32, string> RelationshipMap = 23;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRelationshipmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 23, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRelationshipmapMap = function() {
  this.getRelationshipmapMap().clear();
  return this;
};


/**
 * map<int64, string> SmsContentMap = 24;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getSmscontentmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 24, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearSmscontentmapMap = function() {
  this.getSmscontentmapMap().clear();
  return this;
};


/**
 * map<int32, string> RiskReportMap = 27;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRiskreportmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 27, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRiskreportmapMap = function() {
  this.getRiskreportmapMap().clear();
  return this;
};


/**
 * optional PhoneInfos PhoneInfo = 28;
 * @return {?proto.xcommon.PhoneInfos}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getPhoneinfo = function() {
  return /** @type{?proto.xcommon.PhoneInfos} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.PhoneInfos, 28));
};


/**
 * @param {?proto.xcommon.PhoneInfos|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setPhoneinfo = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearPhoneinfo = function() {
  return this.setPhoneinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasPhoneinfo = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * map<int32, string> PhoneObject = 29;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getPhoneobjectMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 29, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearPhoneobjectMap = function() {
  this.getPhoneobjectMap().clear();
  return this;
};


/**
 * optional int32 LastPhoneConnect = 30;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getLastphoneconnect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setLastphoneconnect = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional string UrgeStatusMsg = 31;
 * @return {string}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getUrgestatusmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setUrgestatusmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional int32 RepayInclination = 32;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRepayinclination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setRepayinclination = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * repeated ExtContacts ExtContact = 33;
 * @return {!Array<!proto.xcommon.ExtContacts>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getExtcontactList = function() {
  return /** @type{!Array<!proto.xcommon.ExtContacts>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ExtContacts, 33));
};


/**
 * @param {!Array<!proto.xcommon.ExtContacts>} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setExtcontactList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 33, value);
};


/**
 * @param {!proto.xcommon.ExtContacts=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ExtContacts}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.addExtcontact = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 33, opt_value, proto.xcommon.ExtContacts, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearExtcontactList = function() {
  return this.setExtcontactList([]);
};


/**
 * map<int32, string> PhoneObjectMobile = 34;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getPhoneobjectmobileMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 34, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearPhoneobjectmobileMap = function() {
  this.getPhoneobjectmobileMap().clear();
  return this;
};


/**
 * optional int32 IsHideWhatsApp = 35;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getIshidewhatsapp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setIshidewhatsapp = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int32 IsShowCouponMap = 36;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getIsshowcouponmap = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setIsshowcouponmap = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * map<int32, string> CustomerOtherMobile = 37;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getCustomerothermobileMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 37, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearCustomerothermobileMap = function() {
  this.getCustomerothermobileMap().clear();
  return this;
};


/**
 * optional int32 HaveCustomerOtherMobile = 38;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getHavecustomerothermobile = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setHavecustomerothermobile = function(value) {
  return jspb.Message.setProto3IntField(this, 38, value);
};


/**
 * optional string TicketClassify = 39;
 * @return {string}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getTicketclassify = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setTicketclassify = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * repeated string SupplierType = 41;
 * @return {!Array<string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getSuppliertypeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 41));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setSuppliertypeList = function(value) {
  return jspb.Message.setField(this, 41, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.addSuppliertype = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 41, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearSuppliertypeList = function() {
  return this.setSuppliertypeList([]);
};


/**
 * map<int32, int32> WhatsappFlag = 42;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getWhatsappflagMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 42, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearWhatsappflagMap = function() {
  this.getWhatsappflagMap().clear();
  return this;
};


/**
 * optional AccountSocialInfo AccountSocials = 43;
 * @return {?proto.xcommon.AccountSocialInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getAccountsocials = function() {
  return /** @type{?proto.xcommon.AccountSocialInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountSocialInfo, 43));
};


/**
 * @param {?proto.xcommon.AccountSocialInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setAccountsocials = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearAccountsocials = function() {
  return this.setAccountsocials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasAccountsocials = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * map<int32, int32> UrgeResultConnectedMap = 44;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getUrgeresultconnectedmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 44, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearUrgeresultconnectedmapMap = function() {
  this.getUrgeresultconnectedmapMap().clear();
  return this;
};


/**
 * optional int32 IsMutiLoan = 45;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getIsmutiloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setIsmutiloan = function(value) {
  return jspb.Message.setProto3IntField(this, 45, value);
};


/**
 * repeated UrgeRollInfo RollInfoList = 46;
 * @return {!Array<!proto.xcommon.UrgeRollInfo>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRollinfolistList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeRollInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.UrgeRollInfo, 46));
};


/**
 * @param {!Array<!proto.xcommon.UrgeRollInfo>} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setRollinfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 46, value);
};


/**
 * @param {!proto.xcommon.UrgeRollInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeRollInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.addRollinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 46, opt_value, proto.xcommon.UrgeRollInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRollinfolistList = function() {
  return this.setRollinfolistList([]);
};


/**
 * repeated UrgeLoanInfo LoanInfoList = 47;
 * @return {!Array<!proto.xcommon.UrgeLoanInfo>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getLoaninfolistList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeLoanInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.UrgeLoanInfo, 47));
};


/**
 * @param {!Array<!proto.xcommon.UrgeLoanInfo>} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setLoaninfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 47, value);
};


/**
 * @param {!proto.xcommon.UrgeLoanInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeLoanInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.addLoaninfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 47, opt_value, proto.xcommon.UrgeLoanInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearLoaninfolistList = function() {
  return this.setLoaninfolistList([]);
};


/**
 * repeated RepayPlanStageTab RepayPlanStageTabList = 48;
 * @return {!Array<!proto.xcommon.RepayPlanStageTab>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRepayplanstagetablistList = function() {
  return /** @type{!Array<!proto.xcommon.RepayPlanStageTab>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RepayPlanStageTab, 48));
};


/**
 * @param {!Array<!proto.xcommon.RepayPlanStageTab>} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setRepayplanstagetablistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 48, value);
};


/**
 * @param {!proto.xcommon.RepayPlanStageTab=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RepayPlanStageTab}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.addRepayplanstagetablist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 48, opt_value, proto.xcommon.RepayPlanStageTab, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearRepayplanstagetablistList = function() {
  return this.setRepayplanstagetablistList([]);
};


/**
 * optional int32 NoCopyMobileSelf = 49;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getNocopymobileself = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setNocopymobileself = function(value) {
  return jspb.Message.setProto3IntField(this, 49, value);
};


/**
 * optional int32 NoCopyMobileContact = 50;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getNocopymobilecontact = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setNocopymobilecontact = function(value) {
  return jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * optional string RobotCallTags = 51;
 * @return {string}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getRobotcalltags = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setRobotcalltags = function(value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional SuggestInfo Suggest = 52;
 * @return {?proto.xcommon.SuggestInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getSuggest = function() {
  return /** @type{?proto.xcommon.SuggestInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.SuggestInfo, 52));
};


/**
 * @param {?proto.xcommon.SuggestInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setSuggest = function(value) {
  return jspb.Message.setWrapperField(this, 52, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearSuggest = function() {
  return this.setSuggest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasSuggest = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional Bool ShowSuggest = 53;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getShowsuggest = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setShowsuggest = function(value) {
  return jspb.Message.setProto3EnumField(this, 53, value);
};


/**
 * optional OrderCustomization Customization = 54;
 * @return {?proto.xcommon.OrderCustomization}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getCustomization = function() {
  return /** @type{?proto.xcommon.OrderCustomization} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderCustomization, 54));
};


/**
 * @param {?proto.xcommon.OrderCustomization|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setCustomization = function(value) {
  return jspb.Message.setWrapperField(this, 54, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearCustomization = function() {
  return this.setCustomization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasCustomization = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional OrderTagExtInfo OrderTags = 55;
 * @return {?proto.xcommon.OrderTagExtInfo}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getOrdertags = function() {
  return /** @type{?proto.xcommon.OrderTagExtInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderTagExtInfo, 55));
};


/**
 * @param {?proto.xcommon.OrderTagExtInfo|undefined} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
*/
proto.xcommon.UrgeCaseBaseInfo.prototype.setOrdertags = function(value) {
  return jspb.Message.setWrapperField(this, 55, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearOrdertags = function() {
  return this.setOrdertags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.hasOrdertags = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional int32 IsHiddenContact = 56;
 * @return {number}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getIshiddencontact = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.setIshiddencontact = function(value) {
  return jspb.Message.setProto3IntField(this, 56, value);
};


/**
 * map<int32, string> PhoneConnectedUrgeResultMap = 57;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getPhoneconnectedurgeresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 57, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearPhoneconnectedurgeresultmapMap = function() {
  this.getPhoneconnectedurgeresultmapMap().clear();
  return this;
};


/**
 * map<int32, string> PhoneUnConnectedUrgeResultMap = 58;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.getPhoneunconnectedurgeresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 58, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.UrgeCaseBaseInfo} returns this
 */
proto.xcommon.UrgeCaseBaseInfo.prototype.clearPhoneunconnectedurgeresultmapMap = function() {
  this.getPhoneunconnectedurgeresultmapMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RepayPlanStageTab.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RepayPlanStageTab.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RepayPlanStageTab.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RepayPlanStageTab} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayPlanStageTab.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    repayplanstageList: jspb.Message.toObjectList(msg.getRepayplanstageList(),
    xcommon_core_pb.RepayPlanStageInfo.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RepayPlanStageTab}
 */
proto.xcommon.RepayPlanStageTab.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RepayPlanStageTab;
  return proto.xcommon.RepayPlanStageTab.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RepayPlanStageTab} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RepayPlanStageTab}
 */
proto.xcommon.RepayPlanStageTab.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = new xcommon_core_pb.RepayPlanStageInfo;
      reader.readMessage(value,xcommon_core_pb.RepayPlanStageInfo.deserializeBinaryFromReader);
      msg.addRepayplanstage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RepayPlanStageTab.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RepayPlanStageTab.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RepayPlanStageTab} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayPlanStageTab.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getRepayplanstageList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.RepayPlanStageInfo.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.RepayPlanStageTab.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayPlanStageTab} returns this
 */
proto.xcommon.RepayPlanStageTab.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RepayPlanStageTab.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayPlanStageTab} returns this
 */
proto.xcommon.RepayPlanStageTab.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * repeated RepayPlanStageInfo RepayPlanStage = 3;
 * @return {!Array<!proto.xcommon.RepayPlanStageInfo>}
 */
proto.xcommon.RepayPlanStageTab.prototype.getRepayplanstageList = function() {
  return /** @type{!Array<!proto.xcommon.RepayPlanStageInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.RepayPlanStageInfo, 3));
};


/**
 * @param {!Array<!proto.xcommon.RepayPlanStageInfo>} value
 * @return {!proto.xcommon.RepayPlanStageTab} returns this
*/
proto.xcommon.RepayPlanStageTab.prototype.setRepayplanstageList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RepayPlanStageInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RepayPlanStageInfo}
 */
proto.xcommon.RepayPlanStageTab.prototype.addRepayplanstage = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RepayPlanStageInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.RepayPlanStageTab} returns this
 */
proto.xcommon.RepayPlanStageTab.prototype.clearRepayplanstageList = function() {
  return this.setRepayplanstageList([]);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.RepayPlanStageTab.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayPlanStageTab} returns this
 */
proto.xcommon.RepayPlanStageTab.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.VerifyTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.VerifyTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.VerifyTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VerifyTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && xcommon_ticket_pb.Ticket.toObject(includeInstance, f),
    isstatusdone: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    verifyresult: jspb.Message.getFieldWithDefault(msg, 3, ""),
    inspectionresult: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.VerifyTicket}
 */
proto.xcommon.VerifyTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.VerifyTicket;
  return proto.xcommon.VerifyTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.VerifyTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.VerifyTicket}
 */
proto.xcommon.VerifyTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_ticket_pb.Ticket;
      reader.readMessage(value,xcommon_ticket_pb.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsstatusdone(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerifyresult(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInspectionresult(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.VerifyTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.VerifyTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.VerifyTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VerifyTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_ticket_pb.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getIsstatusdone();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getVerifyresult();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInspectionresult();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.VerifyTicket.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.Ticket, 1));
};


/**
 * @param {?proto.xcommon.Ticket|undefined} value
 * @return {!proto.xcommon.VerifyTicket} returns this
*/
proto.xcommon.VerifyTicket.prototype.setTicket = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.VerifyTicket} returns this
 */
proto.xcommon.VerifyTicket.prototype.clearTicket = function() {
  return this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.VerifyTicket.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool IsStatusDone = 2;
 * @return {boolean}
 */
proto.xcommon.VerifyTicket.prototype.getIsstatusdone = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.VerifyTicket} returns this
 */
proto.xcommon.VerifyTicket.prototype.setIsstatusdone = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string VerifyResult = 3;
 * @return {string}
 */
proto.xcommon.VerifyTicket.prototype.getVerifyresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VerifyTicket} returns this
 */
proto.xcommon.VerifyTicket.prototype.setVerifyresult = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string InspectionResult = 4;
 * @return {string}
 */
proto.xcommon.VerifyTicket.prototype.getInspectionresult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VerifyTicket} returns this
 */
proto.xcommon.VerifyTicket.prototype.setInspectionresult = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.VerifyTicket.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VerifyTicket} returns this
 */
proto.xcommon.VerifyTicket.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RmTicket.repeatedFields_ = [20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RmTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RmTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RmTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RmTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && xcommon_ticket_pb.Ticket.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    accountname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    conumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
    dailyhandlenum: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lastcotime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    lastcolog: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 9, 0),
    phoneconnect: jspb.Message.getFieldWithDefault(msg, 10, 0),
    unconnectreason: jspb.Message.getFieldWithDefault(msg, 11, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 12, "0"),
    completetime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    loanamount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    overdueday: jspb.Message.getFieldWithDefault(msg, 15, 0),
    lasturgeremark: jspb.Message.getFieldWithDefault(msg, 16, ""),
    risklevel: jspb.Message.getFieldWithDefault(msg, 17, ""),
    ordertags: (f = msg.getOrdertags()) && xcommon_core_pb.OrderTagExtInfo.toObject(includeInstance, f),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 19, ""),
    tickettagsList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    prestatus: jspb.Message.getFieldWithDefault(msg, 22, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 23, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RmTicket}
 */
proto.xcommon.RmTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RmTicket;
  return proto.xcommon.RmTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RmTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RmTicket}
 */
proto.xcommon.RmTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_ticket_pb.Ticket;
      reader.readMessage(value,xcommon_ticket_pb.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDailyhandlenum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastcotime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastcolog(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnect(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnconnectreason(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletetime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoanamount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverdueday(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLasturgeremark(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setRisklevel(value);
      break;
    case 18:
      var value = new xcommon_core_pb.OrderTagExtInfo;
      reader.readMessage(value,xcommon_core_pb.OrderTagExtInfo.deserializeBinaryFromReader);
      msg.setOrdertags(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickettags(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrestatus(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RmTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RmTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RmTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RmTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_ticket_pb.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getAccountname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDailyhandlenum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLastcotime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getLastcolog();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPhoneconnect();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getUnconnectreason();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      12,
      f
    );
  }
  f = message.getCompletetime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getLoanamount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getOverdueday();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getLasturgeremark();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRisklevel();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getOrdertags();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      xcommon_core_pb.OrderTagExtInfo.serializeBinaryToWriter
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getTickettagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getPrestatus();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.RmTicket.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.Ticket, 1));
};


/**
 * @param {?proto.xcommon.Ticket|undefined} value
 * @return {!proto.xcommon.RmTicket} returns this
*/
proto.xcommon.RmTicket.prototype.setTicket = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.clearTicket = function() {
  return this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RmTicket.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketID = 2;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AccountID = 3;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string AccountName = 4;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getAccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setAccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 CoNumber = 5;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getConumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setConumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 DailyHandleNum = 6;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getDailyhandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setDailyhandlenum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 LastCoTime = 7;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getLastcotime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setLastcotime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string LastCoLog = 8;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getLastcolog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setLastcolog = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 IsReloan = 9;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setIsreloan = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 PhoneConnect = 10;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getPhoneconnect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setPhoneconnect = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 UnconnectReason = 11;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getUnconnectreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setUnconnectreason = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 OrderID = 12;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 12, value);
};


/**
 * optional int64 CompleteTime = 13;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getCompletetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setCompletetime = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 LoanAmount = 14;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getLoanamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setLoanamount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 OverdueDay = 15;
 * @return {number}
 */
proto.xcommon.RmTicket.prototype.getOverdueday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setOverdueday = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string LastUrgeRemark = 16;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getLasturgeremark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setLasturgeremark = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string RiskLevel = 17;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getRisklevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setRisklevel = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional OrderTagExtInfo OrderTags = 18;
 * @return {?proto.xcommon.OrderTagExtInfo}
 */
proto.xcommon.RmTicket.prototype.getOrdertags = function() {
  return /** @type{?proto.xcommon.OrderTagExtInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderTagExtInfo, 18));
};


/**
 * @param {?proto.xcommon.OrderTagExtInfo|undefined} value
 * @return {!proto.xcommon.RmTicket} returns this
*/
proto.xcommon.RmTicket.prototype.setOrdertags = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.clearOrdertags = function() {
  return this.setOrdertags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RmTicket.prototype.hasOrdertags = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string TicketStatus = 19;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setTicketstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * repeated string TicketTags = 20;
 * @return {!Array<string>}
 */
proto.xcommon.RmTicket.prototype.getTickettagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setTickettagsList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.addTickettags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.clearTickettagsList = function() {
  return this.setTickettagsList([]);
};


/**
 * optional string PreStatus = 22;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getPrestatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setPrestatus = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string AppName = 23;
 * @return {string}
 */
proto.xcommon.RmTicket.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RmTicket} returns this
 */
proto.xcommon.RmTicket.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CollectionTicket.repeatedFields_ = [20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CollectionTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CollectionTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CollectionTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CollectionTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticket: (f = msg.getTicket()) && xcommon_ticket_pb.Ticket.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    accountname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    dailyhandlenum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    conumber: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lastcotime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    lastcolog: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isreloan: jspb.Message.getFieldWithDefault(msg, 9, 0),
    caselevel: jspb.Message.getFieldWithDefault(msg, 10, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 11, "0"),
    overdueday: jspb.Message.getFieldWithDefault(msg, 12, 0),
    completetime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    loanamount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    isemptynumber: jspb.Message.getFieldWithDefault(msg, 15, 0),
    lasturgeremark: jspb.Message.getFieldWithDefault(msg, 16, ""),
    risklevel: jspb.Message.getFieldWithDefault(msg, 17, ""),
    ordertags: (f = msg.getOrdertags()) && xcommon_core_pb.OrderTagExtInfo.toObject(includeInstance, f),
    ticketstatus: jspb.Message.getFieldWithDefault(msg, 19, ""),
    tickettagsList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    nexthandletime: jspb.Message.getFieldWithDefault(msg, 21, 0),
    prestatus: jspb.Message.getFieldWithDefault(msg, 23, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CollectionTicket}
 */
proto.xcommon.CollectionTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CollectionTicket;
  return proto.xcommon.CollectionTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CollectionTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CollectionTicket}
 */
proto.xcommon.CollectionTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_ticket_pb.Ticket;
      reader.readMessage(value,xcommon_ticket_pb.Ticket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDailyhandlenum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConumber(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastcotime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastcolog(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverdueday(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletetime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoanamount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsemptynumber(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLasturgeremark(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setRisklevel(value);
      break;
    case 18:
      var value = new xcommon_core_pb.OrderTagExtInfo;
      reader.readMessage(value,xcommon_core_pb.OrderTagExtInfo.deserializeBinaryFromReader);
      msg.setOrdertags(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketstatus(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickettags(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNexthandletime(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrestatus(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CollectionTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CollectionTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CollectionTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CollectionTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_ticket_pb.Ticket.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getAccountname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDailyhandlenum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getConumber();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLastcotime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getLastcolog();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      11,
      f
    );
  }
  f = message.getOverdueday();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getCompletetime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getLoanamount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getIsemptynumber();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getLasturgeremark();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRisklevel();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getOrdertags();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      xcommon_core_pb.OrderTagExtInfo.serializeBinaryToWriter
    );
  }
  f = message.getTicketstatus();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getTickettagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getNexthandletime();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getPrestatus();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional Ticket Ticket = 1;
 * @return {?proto.xcommon.Ticket}
 */
proto.xcommon.CollectionTicket.prototype.getTicket = function() {
  return /** @type{?proto.xcommon.Ticket} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.Ticket, 1));
};


/**
 * @param {?proto.xcommon.Ticket|undefined} value
 * @return {!proto.xcommon.CollectionTicket} returns this
*/
proto.xcommon.CollectionTicket.prototype.setTicket = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.clearTicket = function() {
  return this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CollectionTicket.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketID = 2;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AccountID = 3;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string AccountName = 4;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getAccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setAccountname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 DailyHandleNum = 5;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getDailyhandlenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setDailyhandlenum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 CoNumber = 6;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getConumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setConumber = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 LastCoTime = 7;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getLastcotime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setLastcotime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string LastCoLog = 8;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getLastcolog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setLastcolog = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 IsReloan = 9;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setIsreloan = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string CaseLevel = 10;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 OrderID = 11;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 11, value);
};


/**
 * optional int32 OverdueDay = 12;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getOverdueday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setOverdueday = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 CompleteTime = 13;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getCompletetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setCompletetime = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 LoanAmount = 14;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getLoanamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setLoanamount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 IsEmptyNumber = 15;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getIsemptynumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setIsemptynumber = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string LastUrgeRemark = 16;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getLasturgeremark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setLasturgeremark = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string RiskLevel = 17;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getRisklevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setRisklevel = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional OrderTagExtInfo OrderTags = 18;
 * @return {?proto.xcommon.OrderTagExtInfo}
 */
proto.xcommon.CollectionTicket.prototype.getOrdertags = function() {
  return /** @type{?proto.xcommon.OrderTagExtInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.OrderTagExtInfo, 18));
};


/**
 * @param {?proto.xcommon.OrderTagExtInfo|undefined} value
 * @return {!proto.xcommon.CollectionTicket} returns this
*/
proto.xcommon.CollectionTicket.prototype.setOrdertags = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.clearOrdertags = function() {
  return this.setOrdertags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CollectionTicket.prototype.hasOrdertags = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string TicketStatus = 19;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getTicketstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setTicketstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * repeated string TicketTags = 20;
 * @return {!Array<string>}
 */
proto.xcommon.CollectionTicket.prototype.getTickettagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setTickettagsList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.addTickettags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.clearTickettagsList = function() {
  return this.setTickettagsList([]);
};


/**
 * optional int64 NextHandleTime = 21;
 * @return {number}
 */
proto.xcommon.CollectionTicket.prototype.getNexthandletime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setNexthandletime = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string PreStatus = 23;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getPrestatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setPrestatus = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string AppName = 24;
 * @return {string}
 */
proto.xcommon.CollectionTicket.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CollectionTicket} returns this
 */
proto.xcommon.CollectionTicket.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RepayRemindCase.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RepayRemindCase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RepayRemindCase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayRemindCase.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    level: jspb.Message.getFieldWithDefault(msg, 3, ""),
    useraccountid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    opuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    promiserepaytime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    result: jspb.Message.getFieldWithDefault(msg, 7, ""),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    invalidreason: jspb.Message.getFieldWithDefault(msg, 9, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    invalidtime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    issendcoupon: jspb.Message.getFieldWithDefault(msg, 13, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RepayRemindCase}
 */
proto.xcommon.RepayRemindCase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RepayRemindCase;
  return proto.xcommon.RepayRemindCase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RepayRemindCase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RepayRemindCase}
 */
proto.xcommon.RepayRemindCase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUseraccountid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPromiserepaytime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInvalidreason(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvalidtime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIssendcoupon(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RepayRemindCase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RepayRemindCase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RepayRemindCase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayRemindCase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUseraccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPromiserepaytime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getInvalidreason();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getInvalidtime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getIssendcoupon();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RepayRemindCase.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string Level = 3;
 * @return {string}
 */
proto.xcommon.RepayRemindCase.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 UserAccountId = 4;
 * @return {string}
 */
proto.xcommon.RepayRemindCase.prototype.getUseraccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setUseraccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int64 OpUid = 5;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 PromiseRepayTime = 6;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getPromiserepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setPromiserepaytime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string Result = 7;
 * @return {string}
 */
proto.xcommon.RepayRemindCase.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 Status = 8;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 InvalidReason = 9;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getInvalidreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setInvalidreason = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Ctime = 10;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 InvalidTime = 11;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getInvalidtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setInvalidtime = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 Utime = 12;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 IsSendCoupon = 13;
 * @return {number}
 */
proto.xcommon.RepayRemindCase.prototype.getIssendcoupon = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setIssendcoupon = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string AppName = 14;
 * @return {string}
 */
proto.xcommon.RepayRemindCase.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RepayRemindCase} returns this
 */
proto.xcommon.RepayRemindCase.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RemindCaseLog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RemindCaseLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RemindCaseLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RemindCaseLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RemindCaseLog}
 */
proto.xcommon.RemindCaseLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RemindCaseLog;
  return proto.xcommon.RemindCaseLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RemindCaseLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RemindCaseLog}
 */
proto.xcommon.RemindCaseLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RemindCaseLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RemindCaseLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RemindCaseLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RemindCaseLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.RemindCaseLog.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RemindCaseLog} returns this
 */
proto.xcommon.RemindCaseLog.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RemindCaseDialog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RemindCaseDialog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RemindCaseDialog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RemindCaseDialog.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
    target: jspb.Message.getFieldWithDefault(msg, 4, ""),
    listname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RemindCaseDialog}
 */
proto.xcommon.RemindCaseDialog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RemindCaseDialog;
  return proto.xcommon.RemindCaseDialog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RemindCaseDialog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RemindCaseDialog}
 */
proto.xcommon.RemindCaseDialog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTarget(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setListname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RemindCaseDialog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RemindCaseDialog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RemindCaseDialog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RemindCaseDialog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTarget();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getListname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int64 TicketId = 1;
 * @return {number}
 */
proto.xcommon.RemindCaseDialog.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RemindCaseDialog} returns this
 */
proto.xcommon.RemindCaseDialog.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.RemindCaseDialog.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RemindCaseDialog} returns this
 */
proto.xcommon.RemindCaseDialog.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Phone = 3;
 * @return {string}
 */
proto.xcommon.RemindCaseDialog.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RemindCaseDialog} returns this
 */
proto.xcommon.RemindCaseDialog.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Target = 4;
 * @return {string}
 */
proto.xcommon.RemindCaseDialog.prototype.getTarget = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RemindCaseDialog} returns this
 */
proto.xcommon.RemindCaseDialog.prototype.setTarget = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ListName = 5;
 * @return {string}
 */
proto.xcommon.RemindCaseDialog.prototype.getListname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RemindCaseDialog} returns this
 */
proto.xcommon.RemindCaseDialog.prototype.setListname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Sid = 6;
 * @return {string}
 */
proto.xcommon.RemindCaseDialog.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RemindCaseDialog} returns this
 */
proto.xcommon.RemindCaseDialog.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReasonConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReasonConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReasonConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReasonConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sort: jspb.Message.getFieldWithDefault(msg, 4, 0),
    setid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    lang: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReasonConfig}
 */
proto.xcommon.ReasonConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReasonConfig;
  return proto.xcommon.ReasonConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReasonConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReasonConfig}
 */
proto.xcommon.ReasonConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSort(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSetid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLang(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReasonConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReasonConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReasonConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReasonConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSort();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSetid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getLang();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Pid = 2;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getPid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setPid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.ReasonConfig.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Sort = 4;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getSort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setSort = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 SetId = 5;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getSetid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setSetid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string Lang = 6;
 * @return {string}
 */
proto.xcommon.ReasonConfig.prototype.getLang = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setLang = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 Status = 7;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 Ctime = 8;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Utime = 9;
 * @return {number}
 */
proto.xcommon.ReasonConfig.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReasonConfig} returns this
 */
proto.xcommon.ReasonConfig.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RiskReportShow.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RiskReportShow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RiskReportShow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RiskReportShow.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isreported: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RiskReportShow}
 */
proto.xcommon.RiskReportShow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RiskReportShow;
  return proto.xcommon.RiskReportShow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RiskReportShow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RiskReportShow}
 */
proto.xcommon.RiskReportShow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIsreported(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RiskReportShow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RiskReportShow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RiskReportShow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RiskReportShow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsreported();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.RiskReportShow.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RiskReportShow} returns this
 */
proto.xcommon.RiskReportShow.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.RiskReportShow.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.RiskReportShow} returns this
 */
proto.xcommon.RiskReportShow.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 IsReported = 3;
 * @return {number}
 */
proto.xcommon.RiskReportShow.prototype.getIsreported = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.RiskReportShow} returns this
 */
proto.xcommon.RiskReportShow.prototype.setIsreported = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OverdueCase.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OverdueCase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OverdueCase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OverdueCase.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    caselevel: jspb.Message.getFieldWithDefault(msg, 3, ""),
    overduedays: jspb.Message.getFieldWithDefault(msg, 4, 0),
    repaytime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    joinurgetime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignuid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    urgeuid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    urgetime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    result: jspb.Message.getFieldWithDefault(msg, 10, ""),
    isout: jspb.Message.getFieldWithDefault(msg, 11, 0),
    outreason: jspb.Message.getFieldWithDefault(msg, 12, 0),
    outurgetime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    stageindex: jspb.Message.getFieldWithDefault(msg, 15, 0),
    isdeleted: jspb.Message.getFieldWithDefault(msg, 16, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OverdueCase}
 */
proto.xcommon.OverdueCase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OverdueCase;
  return proto.xcommon.OverdueCase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OverdueCase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OverdueCase}
 */
proto.xcommon.OverdueCase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedays(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJoinurgetime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAssignuid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUrgeuid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUrgetime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsout(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutreason(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOuturgetime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStageindex(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsdeleted(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OverdueCase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OverdueCase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OverdueCase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OverdueCase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRepaytime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getJoinurgetime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAssignuid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUrgeuid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUrgetime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getIsout();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getOutreason();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getOuturgetime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getStageindex();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getIsdeleted();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.OverdueCase.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string CaseLevel = 3;
 * @return {string}
 */
proto.xcommon.OverdueCase.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 OverdueDays = 4;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setOverduedays = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 RepayTime = 5;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getRepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setRepaytime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 JoinUrgeTime = 6;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getJoinurgetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setJoinurgetime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AssignUid = 7;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getAssignuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setAssignuid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 UrgeUid = 8;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getUrgeuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setUrgeuid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 UrgeTime = 9;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getUrgetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setUrgetime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string Result = 10;
 * @return {string}
 */
proto.xcommon.OverdueCase.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 IsOut = 11;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getIsout = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setIsout = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 OutReason = 12;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getOutreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setOutreason = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 OutUrgeTime = 13;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getOuturgetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setOuturgetime = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 Utime = 14;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 StageIndex = 15;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getStageindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setStageindex = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 IsDeleted = 16;
 * @return {number}
 */
proto.xcommon.OverdueCase.prototype.getIsdeleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setIsdeleted = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string AppName = 17;
 * @return {string}
 */
proto.xcommon.OverdueCase.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCase} returns this
 */
proto.xcommon.OverdueCase.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OverdueCaseDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OverdueCaseDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OverdueCaseDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OverdueCaseDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 3, 0),
    phoneobjectmobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    phoneconnect: jspb.Message.getFieldWithDefault(msg, 6, 0),
    promiserepaytime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    overduereason: jspb.Message.getFieldWithDefault(msg, 8, ""),
    overduereasonitem: jspb.Message.getFieldWithDefault(msg, 9, 0),
    repayinclination: jspb.Message.getFieldWithDefault(msg, 10, 0),
    unconnectreason: jspb.Message.getFieldWithDefault(msg, 11, 0),
    result: jspb.Message.getFieldWithDefault(msg, 12, ""),
    remark: jspb.Message.getFieldWithDefault(msg, 13, ""),
    urgetype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    autodailtype: jspb.Message.getFieldWithDefault(msg, 15, ""),
    answertimestamp: jspb.Message.getFieldWithDefault(msg, 16, 0),
    endtimestamp: jspb.Message.getFieldWithDefault(msg, 17, 0),
    hangupdirection: jspb.Message.getFieldWithDefault(msg, 18, 0),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 19, 0),
    callmethod: jspb.Message.getFieldWithDefault(msg, 20, 0),
    suppliertype: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OverdueCaseDetails}
 */
proto.xcommon.OverdueCaseDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OverdueCaseDetails;
  return proto.xcommon.OverdueCaseDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OverdueCaseDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OverdueCaseDetails}
 */
proto.xcommon.OverdueCaseDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobjectmobile(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhonetime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnect(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPromiserepaytime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverduereason(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduereasonitem(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRepayinclination(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnconnectreason(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUrgetype(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAutodailtype(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswertimestamp(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtimestamp(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHangupdirection(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHangupcause(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCallmethod(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuppliertype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OverdueCaseDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OverdueCaseDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OverdueCaseDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OverdueCaseDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPhoneobjectmobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhonetime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPhoneconnect();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPromiserepaytime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getOverduereason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOverduereasonitem();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRepayinclination();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getUnconnectreason();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getUrgetype();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getAutodailtype();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAnswertimestamp();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getEndtimestamp();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getHangupdirection();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getHangupcause();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getCallmethod();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getSuppliertype();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OpUid = 2;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 PhoneObject = 3;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string PhoneObjectMobile = 4;
 * @return {string}
 */
proto.xcommon.OverdueCaseDetails.prototype.getPhoneobjectmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setPhoneobjectmobile = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 PhoneTime = 5;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getPhonetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setPhonetime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 PhoneConnect = 6;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getPhoneconnect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setPhoneconnect = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 PromiseRepayTime = 7;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getPromiserepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setPromiserepaytime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string OverdueReason = 8;
 * @return {string}
 */
proto.xcommon.OverdueCaseDetails.prototype.getOverduereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setOverduereason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 OverdueReasonItem = 9;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getOverduereasonitem = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setOverduereasonitem = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 RepayInclination = 10;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getRepayinclination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setRepayinclination = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 UnconnectReason = 11;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getUnconnectreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setUnconnectreason = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string Result = 12;
 * @return {string}
 */
proto.xcommon.OverdueCaseDetails.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string Remark = 13;
 * @return {string}
 */
proto.xcommon.OverdueCaseDetails.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 UrgeType = 14;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getUrgetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setUrgetype = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string AutoDailType = 15;
 * @return {string}
 */
proto.xcommon.OverdueCaseDetails.prototype.getAutodailtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setAutodailtype = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int64 AnswerTimestamp = 16;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getAnswertimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setAnswertimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 EndTimestamp = 17;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getEndtimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setEndtimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 HangupDirection = 18;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getHangupdirection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setHangupdirection = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 HangupCause = 19;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getHangupcause = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setHangupcause = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 CallMethod = 20;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getCallmethod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setCallmethod = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 SupplierType = 21;
 * @return {number}
 */
proto.xcommon.OverdueCaseDetails.prototype.getSuppliertype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OverdueCaseDetails} returns this
 */
proto.xcommon.OverdueCaseDetails.prototype.setSuppliertype = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CaseLogDetailBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CaseLogDetailBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CaseLogDetailBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CaseLogDetailBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    opname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 3, ""),
    urgetype: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phoneobjectmobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    answertimestamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    endtimestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
    hangupdirection: jspb.Message.getFieldWithDefault(msg, 9, ""),
    hangupcause: jspb.Message.getFieldWithDefault(msg, 10, ""),
    phoneconnect: jspb.Message.getFieldWithDefault(msg, 11, ""),
    promiserepaytime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    overduereason: jspb.Message.getFieldWithDefault(msg, 13, ""),
    repayinclination: jspb.Message.getFieldWithDefault(msg, 14, ""),
    unconnectreason: jspb.Message.getFieldWithDefault(msg, 15, ""),
    result: jspb.Message.getFieldWithDefault(msg, 16, ""),
    remark: jspb.Message.getFieldWithDefault(msg, 17, ""),
    dialway: jspb.Message.getFieldWithDefault(msg, 18, ""),
    promiserepayamount: jspb.Message.getFieldWithDefault(msg, 19, ""),
    submittime: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CaseLogDetailBackend}
 */
proto.xcommon.CaseLogDetailBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CaseLogDetailBackend;
  return proto.xcommon.CaseLogDetailBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CaseLogDetailBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CaseLogDetailBackend}
 */
proto.xcommon.CaseLogDetailBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobject(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgetype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneobjectmobile(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhonetime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAnswertimestamp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtimestamp(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupdirection(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHangupcause(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneconnect(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPromiserepaytime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverduereason(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepayinclination(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnconnectreason(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setDialway(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromiserepayamount(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CaseLogDetailBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CaseLogDetailBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CaseLogDetailBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CaseLogDetailBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOpname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhoneobject();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrgetype();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhoneobjectmobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhonetime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAnswertimestamp();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getEndtimestamp();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getHangupdirection();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHangupcause();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPhoneconnect();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPromiserepaytime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getOverduereason();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getRepayinclination();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUnconnectreason();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getDialway();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getPromiserepayamount();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSubmittime();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string OpName = 2;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getOpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setOpname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string PhoneObject = 3;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getPhoneobject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UrgeType = 4;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getUrgetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setUrgetype = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PhoneObjectMobile = 5;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getPhoneobjectmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setPhoneobjectmobile = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 PhoneTime = 6;
 * @return {number}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getPhonetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setPhonetime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AnswerTimestamp = 7;
 * @return {number}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getAnswertimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setAnswertimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 EndTimestamp = 8;
 * @return {number}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getEndtimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setEndtimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string HangupDirection = 9;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getHangupdirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setHangupdirection = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string HangupCause = 10;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getHangupcause = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setHangupcause = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string PhoneConnect = 11;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getPhoneconnect = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setPhoneconnect = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 PromiseRepayTime = 12;
 * @return {number}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getPromiserepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setPromiserepaytime = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string OverdueReason = 13;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getOverduereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setOverduereason = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string RepayInclination = 14;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getRepayinclination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setRepayinclination = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string UnconnectReason = 15;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getUnconnectreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setUnconnectreason = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string Result = 16;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string Remark = 17;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string DialWay = 18;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getDialway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setDialway = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string PromiseRepayAmount = 19;
 * @return {string}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getPromiserepayamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setPromiserepayamount = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional int64 SubmitTime = 20;
 * @return {number}
 */
proto.xcommon.CaseLogDetailBackend.prototype.getSubmittime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CaseLogDetailBackend} returns this
 */
proto.xcommon.CaseLogDetailBackend.prototype.setSubmittime = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReplayPlanPageAddField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReplayPlanPageAddField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReplayPlanPageAddField.toObject = function(includeInstance, msg) {
  var f, obj = {
    waitpaid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    waitinterestpaid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    waitpenaltyinterestpaid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalpaidamonut: jspb.Message.getFieldWithDefault(msg, 4, 0),
    totalpaided: jspb.Message.getFieldWithDefault(msg, 5, 0),
    waitpaidtotal: jspb.Message.getFieldWithDefault(msg, 6, 0),
    penaltytotal: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReplayPlanPageAddField}
 */
proto.xcommon.ReplayPlanPageAddField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReplayPlanPageAddField;
  return proto.xcommon.ReplayPlanPageAddField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReplayPlanPageAddField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReplayPlanPageAddField}
 */
proto.xcommon.ReplayPlanPageAddField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWaitpaid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWaitinterestpaid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWaitpenaltyinterestpaid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalpaidamonut(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalpaided(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWaitpaidtotal(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltytotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReplayPlanPageAddField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReplayPlanPageAddField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReplayPlanPageAddField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWaitpaid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getWaitinterestpaid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getWaitpenaltyinterestpaid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalpaidamonut();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getTotalpaided();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getWaitpaidtotal();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPenaltytotal();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 WaitPaid = 1;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getWaitpaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setWaitpaid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 WaitInterestPaid = 2;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getWaitinterestpaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setWaitinterestpaid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 WaitPenaltyInterestPaid = 3;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getWaitpenaltyinterestpaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setWaitpenaltyinterestpaid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TotalPaidAmonut = 4;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getTotalpaidamonut = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setTotalpaidamonut = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 TotalPaided = 5;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getTotalpaided = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setTotalpaided = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 WaitPaidTotal = 6;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getWaitpaidtotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setWaitpaidtotal = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 PenaltyTotal = 7;
 * @return {number}
 */
proto.xcommon.ReplayPlanPageAddField.prototype.getPenaltytotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReplayPlanPageAddField} returns this
 */
proto.xcommon.ReplayPlanPageAddField.prototype.setPenaltytotal = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountAlternativeContactUrge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountAlternativeContactUrge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountAlternativeContactUrge.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountalternative: (f = msg.getAccountalternative()) && xcommon_core_pb.AccountAlternativeContactInfo.toObject(includeInstance, f),
    relationshipconfMap: (f = msg.getRelationshipconfMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountAlternativeContactUrge}
 */
proto.xcommon.AccountAlternativeContactUrge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountAlternativeContactUrge;
  return proto.xcommon.AccountAlternativeContactUrge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountAlternativeContactUrge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountAlternativeContactUrge}
 */
proto.xcommon.AccountAlternativeContactUrge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_core_pb.AccountAlternativeContactInfo;
      reader.readMessage(value,xcommon_core_pb.AccountAlternativeContactInfo.deserializeBinaryFromReader);
      msg.setAccountalternative(value);
      break;
    case 2:
      var value = msg.getRelationshipconfMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountAlternativeContactUrge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountAlternativeContactUrge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountAlternativeContactUrge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountalternative();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_core_pb.AccountAlternativeContactInfo.serializeBinaryToWriter
    );
  }
  f = message.getRelationshipconfMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional AccountAlternativeContactInfo AccountAlternative = 1;
 * @return {?proto.xcommon.AccountAlternativeContactInfo}
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.getAccountalternative = function() {
  return /** @type{?proto.xcommon.AccountAlternativeContactInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountAlternativeContactInfo, 1));
};


/**
 * @param {?proto.xcommon.AccountAlternativeContactInfo|undefined} value
 * @return {!proto.xcommon.AccountAlternativeContactUrge} returns this
*/
proto.xcommon.AccountAlternativeContactUrge.prototype.setAccountalternative = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.AccountAlternativeContactUrge} returns this
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.clearAccountalternative = function() {
  return this.setAccountalternative(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.hasAccountalternative = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int32, string> RelationshipConf = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.getRelationshipconfMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.AccountAlternativeContactUrge} returns this
 */
proto.xcommon.AccountAlternativeContactUrge.prototype.clearRelationshipconfMap = function() {
  this.getRelationshipconfMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OtherOrderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OtherOrderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OtherOrderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OtherOrderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    appname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    leftrepayamount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    todaycallnum: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OtherOrderInfo}
 */
proto.xcommon.OtherOrderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OtherOrderInfo;
  return proto.xcommon.OtherOrderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OtherOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OtherOrderInfo}
 */
proto.xcommon.OtherOrderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftrepayamount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTodaycallnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OtherOrderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OtherOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OtherOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OtherOrderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLeftrepayamount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getTodaycallnum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string AppName = 1;
 * @return {string}
 */
proto.xcommon.OtherOrderInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OtherOrderInfo} returns this
 */
proto.xcommon.OtherOrderInfo.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {number}
 */
proto.xcommon.OtherOrderInfo.prototype.getOrderid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OtherOrderInfo} returns this
 */
proto.xcommon.OtherOrderInfo.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AccountId = 3;
 * @return {number}
 */
proto.xcommon.OtherOrderInfo.prototype.getAccountid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OtherOrderInfo} returns this
 */
proto.xcommon.OtherOrderInfo.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Mobile = 4;
 * @return {string}
 */
proto.xcommon.OtherOrderInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OtherOrderInfo} returns this
 */
proto.xcommon.OtherOrderInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 LeftRepayAmount = 5;
 * @return {number}
 */
proto.xcommon.OtherOrderInfo.prototype.getLeftrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OtherOrderInfo} returns this
 */
proto.xcommon.OtherOrderInfo.prototype.setLeftrepayamount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 TodayCallNum = 6;
 * @return {number}
 */
proto.xcommon.OtherOrderInfo.prototype.getTodaycallnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OtherOrderInfo} returns this
 */
proto.xcommon.OtherOrderInfo.prototype.setTodaycallnum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReductionListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReductionListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReductionListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReductionListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    param: (f = msg.getParam()) && xcommon_core_pb.ReductionListParam.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReductionListReq}
 */
proto.xcommon.GetReductionListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReductionListReq;
  return proto.xcommon.GetReductionListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReductionListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReductionListReq}
 */
proto.xcommon.GetReductionListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = new xcommon_core_pb.ReductionListParam;
      reader.readMessage(value,xcommon_core_pb.ReductionListParam.deserializeBinaryFromReader);
      msg.setParam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReductionListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReductionListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReductionListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReductionListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getParam();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_core_pb.ReductionListParam.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetReductionListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetReductionListReq} returns this
*/
proto.xcommon.GetReductionListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetReductionListReq} returns this
 */
proto.xcommon.GetReductionListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReductionListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetReductionListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetReductionListReq} returns this
*/
proto.xcommon.GetReductionListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetReductionListReq} returns this
 */
proto.xcommon.GetReductionListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReductionListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ReductionListParam Param = 3;
 * @return {?proto.xcommon.ReductionListParam}
 */
proto.xcommon.GetReductionListReq.prototype.getParam = function() {
  return /** @type{?proto.xcommon.ReductionListParam} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.ReductionListParam, 3));
};


/**
 * @param {?proto.xcommon.ReductionListParam|undefined} value
 * @return {!proto.xcommon.GetReductionListReq} returns this
*/
proto.xcommon.GetReductionListReq.prototype.setParam = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetReductionListReq} returns this
 */
proto.xcommon.GetReductionListReq.prototype.clearParam = function() {
  return this.setParam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReductionListReq.prototype.hasParam = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetReductionListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetReductionListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetReductionListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetReductionListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReductionListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_core_pb.ReduceRecordListItem.toObject, includeInstance),
    reducetypemapMap: (f = msg.getReducetypemapMap()) ? f.toObject(includeInstance, undefined) : [],
    reducestatusmapMap: (f = msg.getReducestatusmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetReductionListResp}
 */
proto.xcommon.GetReductionListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetReductionListResp;
  return proto.xcommon.GetReductionListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetReductionListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetReductionListResp}
 */
proto.xcommon.GetReductionListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.ReduceRecordListItem;
      reader.readMessage(value,xcommon_core_pb.ReduceRecordListItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 4:
      var value = msg.getReducetypemapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 5:
      var value = msg.getReducestatusmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetReductionListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetReductionListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetReductionListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetReductionListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.ReduceRecordListItem.serializeBinaryToWriter
    );
  }
  f = message.getReducetypemapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getReducestatusmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetReductionListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetReductionListResp} returns this
*/
proto.xcommon.GetReductionListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetReductionListResp} returns this
 */
proto.xcommon.GetReductionListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReductionListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetReductionListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetReductionListResp} returns this
*/
proto.xcommon.GetReductionListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetReductionListResp} returns this
 */
proto.xcommon.GetReductionListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetReductionListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ReduceRecordListItem List = 3;
 * @return {!Array<!proto.xcommon.ReduceRecordListItem>}
 */
proto.xcommon.GetReductionListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.ReduceRecordListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.ReduceRecordListItem, 3));
};


/**
 * @param {!Array<!proto.xcommon.ReduceRecordListItem>} value
 * @return {!proto.xcommon.GetReductionListResp} returns this
*/
proto.xcommon.GetReductionListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.ReduceRecordListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ReduceRecordListItem}
 */
proto.xcommon.GetReductionListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.ReduceRecordListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetReductionListResp} returns this
 */
proto.xcommon.GetReductionListResp.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * map<int32, string> ReduceTypeMap = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetReductionListResp.prototype.getReducetypemapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetReductionListResp} returns this
 */
proto.xcommon.GetReductionListResp.prototype.clearReducetypemapMap = function() {
  this.getReducetypemapMap().clear();
  return this;
};


/**
 * map<int32, string> ReduceStatusMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetReductionListResp.prototype.getReducestatusmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetReductionListResp} returns this
 */
proto.xcommon.GetReductionListResp.prototype.clearReducestatusmapMap = function() {
  this.getReducestatusmapMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneObjectsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneObjectsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneObjectsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneObjectsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    accountid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    contactlistshow: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneObjectsReq}
 */
proto.xcommon.GetPhoneObjectsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneObjectsReq;
  return proto.xcommon.GetPhoneObjectsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneObjectsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneObjectsReq}
 */
proto.xcommon.GetPhoneObjectsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContactlistshow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneObjectsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneObjectsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneObjectsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneObjectsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getContactlistshow();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetPhoneObjectsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetPhoneObjectsReq} returns this
*/
proto.xcommon.GetPhoneObjectsReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneObjectsReq} returns this
 */
proto.xcommon.GetPhoneObjectsReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneObjectsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AccountId = 2;
 * @return {string}
 */
proto.xcommon.GetPhoneObjectsReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetPhoneObjectsReq} returns this
 */
proto.xcommon.GetPhoneObjectsReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int32 ContactListShow = 3;
 * @return {number}
 */
proto.xcommon.GetPhoneObjectsReq.prototype.getContactlistshow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetPhoneObjectsReq} returns this
 */
proto.xcommon.GetPhoneObjectsReq.prototype.setContactlistshow = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetPhoneObjectsResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetPhoneObjectsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetPhoneObjectsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetPhoneObjectsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneObjectsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    objectoptionsList: jspb.Message.toObjectList(msg.getObjectoptionsList(),
    proto.xcommon.OptionItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetPhoneObjectsResp}
 */
proto.xcommon.GetPhoneObjectsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetPhoneObjectsResp;
  return proto.xcommon.GetPhoneObjectsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetPhoneObjectsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetPhoneObjectsResp}
 */
proto.xcommon.GetPhoneObjectsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.OptionItem;
      reader.readMessage(value,proto.xcommon.OptionItem.deserializeBinaryFromReader);
      msg.addObjectoptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetPhoneObjectsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetPhoneObjectsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetPhoneObjectsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetPhoneObjectsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getObjectoptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.OptionItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetPhoneObjectsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetPhoneObjectsResp} returns this
*/
proto.xcommon.GetPhoneObjectsResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetPhoneObjectsResp} returns this
 */
proto.xcommon.GetPhoneObjectsResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetPhoneObjectsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OptionItem ObjectOptions = 2;
 * @return {!Array<!proto.xcommon.OptionItem>}
 */
proto.xcommon.GetPhoneObjectsResp.prototype.getObjectoptionsList = function() {
  return /** @type{!Array<!proto.xcommon.OptionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.OptionItem, 2));
};


/**
 * @param {!Array<!proto.xcommon.OptionItem>} value
 * @return {!proto.xcommon.GetPhoneObjectsResp} returns this
*/
proto.xcommon.GetPhoneObjectsResp.prototype.setObjectoptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.OptionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OptionItem}
 */
proto.xcommon.GetPhoneObjectsResp.prototype.addObjectoptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.OptionItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetPhoneObjectsResp} returns this
 */
proto.xcommon.GetPhoneObjectsResp.prototype.clearObjectoptionsList = function() {
  return this.setObjectoptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveOverdueCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveOverdueCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveOverdueCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOverdueCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    baseinfo: (f = msg.getBaseinfo()) && proto.xcommon.SaveUrgeCaseBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveOverdueCaseReq}
 */
proto.xcommon.SaveOverdueCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveOverdueCaseReq;
  return proto.xcommon.SaveOverdueCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveOverdueCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveOverdueCaseReq}
 */
proto.xcommon.SaveOverdueCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.SaveUrgeCaseBaseInfo;
      reader.readMessage(value,proto.xcommon.SaveUrgeCaseBaseInfo.deserializeBinaryFromReader);
      msg.setBaseinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveOverdueCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveOverdueCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveOverdueCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOverdueCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getBaseinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.SaveUrgeCaseBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveOverdueCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveOverdueCaseReq} returns this
*/
proto.xcommon.SaveOverdueCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveOverdueCaseReq} returns this
 */
proto.xcommon.SaveOverdueCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveOverdueCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SaveUrgeCaseBaseInfo BaseInfo = 2;
 * @return {?proto.xcommon.SaveUrgeCaseBaseInfo}
 */
proto.xcommon.SaveOverdueCaseReq.prototype.getBaseinfo = function() {
  return /** @type{?proto.xcommon.SaveUrgeCaseBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.SaveUrgeCaseBaseInfo, 2));
};


/**
 * @param {?proto.xcommon.SaveUrgeCaseBaseInfo|undefined} value
 * @return {!proto.xcommon.SaveOverdueCaseReq} returns this
*/
proto.xcommon.SaveOverdueCaseReq.prototype.setBaseinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveOverdueCaseReq} returns this
 */
proto.xcommon.SaveOverdueCaseReq.prototype.clearBaseinfo = function() {
  return this.setBaseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveOverdueCaseReq.prototype.hasBaseinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveOverdueCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveOverdueCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveOverdueCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOverdueCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveOverdueCaseResp}
 */
proto.xcommon.SaveOverdueCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveOverdueCaseResp;
  return proto.xcommon.SaveOverdueCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveOverdueCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveOverdueCaseResp}
 */
proto.xcommon.SaveOverdueCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveOverdueCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveOverdueCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveOverdueCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveOverdueCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveOverdueCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveOverdueCaseResp} returns this
*/
proto.xcommon.SaveOverdueCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveOverdueCaseResp} returns this
 */
proto.xcommon.SaveOverdueCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveOverdueCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMessage = 2;
 * @return {string}
 */
proto.xcommon.SaveOverdueCaseResp.prototype.getOpmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveOverdueCaseResp} returns this
 */
proto.xcommon.SaveOverdueCaseResp.prototype.setOpmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveRemindCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveRemindCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveRemindCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRemindCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    baseinfo: (f = msg.getBaseinfo()) && proto.xcommon.SaveUrgeCaseBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveRemindCaseReq}
 */
proto.xcommon.SaveRemindCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveRemindCaseReq;
  return proto.xcommon.SaveRemindCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveRemindCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveRemindCaseReq}
 */
proto.xcommon.SaveRemindCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.SaveUrgeCaseBaseInfo;
      reader.readMessage(value,proto.xcommon.SaveUrgeCaseBaseInfo.deserializeBinaryFromReader);
      msg.setBaseinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveRemindCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveRemindCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveRemindCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRemindCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getBaseinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.SaveUrgeCaseBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveRemindCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveRemindCaseReq} returns this
*/
proto.xcommon.SaveRemindCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRemindCaseReq} returns this
 */
proto.xcommon.SaveRemindCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRemindCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SaveUrgeCaseBaseInfo BaseInfo = 2;
 * @return {?proto.xcommon.SaveUrgeCaseBaseInfo}
 */
proto.xcommon.SaveRemindCaseReq.prototype.getBaseinfo = function() {
  return /** @type{?proto.xcommon.SaveUrgeCaseBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.SaveUrgeCaseBaseInfo, 2));
};


/**
 * @param {?proto.xcommon.SaveUrgeCaseBaseInfo|undefined} value
 * @return {!proto.xcommon.SaveRemindCaseReq} returns this
*/
proto.xcommon.SaveRemindCaseReq.prototype.setBaseinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRemindCaseReq} returns this
 */
proto.xcommon.SaveRemindCaseReq.prototype.clearBaseinfo = function() {
  return this.setBaseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRemindCaseReq.prototype.hasBaseinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveRemindCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveRemindCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveRemindCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRemindCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveRemindCaseResp}
 */
proto.xcommon.SaveRemindCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveRemindCaseResp;
  return proto.xcommon.SaveRemindCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveRemindCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveRemindCaseResp}
 */
proto.xcommon.SaveRemindCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveRemindCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveRemindCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveRemindCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRemindCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveRemindCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveRemindCaseResp} returns this
*/
proto.xcommon.SaveRemindCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRemindCaseResp} returns this
 */
proto.xcommon.SaveRemindCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRemindCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMessage = 2;
 * @return {string}
 */
proto.xcommon.SaveRemindCaseResp.prototype.getOpmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveRemindCaseResp} returns this
 */
proto.xcommon.SaveRemindCaseResp.prototype.setOpmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveUrgeCaseBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveUrgeCaseBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveUrgeCaseBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: jspb.Message.getFieldWithDefault(msg, 1, ""),
    remark: jspb.Message.getFieldWithDefault(msg, 2, ""),
    caseid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalriskreport: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    phoneconnected: jspb.Message.getFieldWithDefault(msg, 6, 0),
    repayinclination: jspb.Message.getFieldWithDefault(msg, 7, 0),
    phoneunconnectreason: jspb.Message.getFieldWithDefault(msg, 8, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 9, 0),
    phonecallinput: jspb.Message.getFieldWithDefault(msg, 10, ""),
    reasonitem: jspb.Message.getFieldWithDefault(msg, 11, 0),
    communicationway: jspb.Message.getFieldWithDefault(msg, 12, 0),
    communicationwayremark: jspb.Message.getFieldWithDefault(msg, 13, ""),
    promiserepaytime: jspb.Message.getFieldWithDefault(msg, 14, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 15, ""),
    callid: jspb.Message.getFieldWithDefault(msg, 16, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 17, 0),
    nextdialtime: jspb.Message.getFieldWithDefault(msg, 18, ""),
    promiserepayamount: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveUrgeCaseBaseInfo;
  return proto.xcommon.SaveUrgeCaseBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveUrgeCaseBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalriskreport(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnected(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRepayinclination(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneunconnectreason(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonecallinput(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReasonitem(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCommunicationway(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommunicationwayremark(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromiserepaytime(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonetime(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCallid(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextdialtime(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromiserepayamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveUrgeCaseBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveUrgeCaseBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveUrgeCaseBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalriskreport();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getPhoneconnected();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRepayinclination();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPhoneunconnectreason();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPhonecallinput();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getReasonitem();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getCommunicationway();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getCommunicationwayremark();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPromiserepaytime();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getPhonetime();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCallid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      16,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getNextdialtime();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getPromiserepayamount();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string Result = 1;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Remark = 2;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 CaseId = 3;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TotalRiskReport = 4;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getTotalriskreport = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setTotalriskreport = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int32 PhoneConnected = 6;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPhoneconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPhoneconnected = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 RepayInclination = 7;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getRepayinclination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setRepayinclination = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 PhoneUnconnectReason = 8;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPhoneunconnectreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPhoneunconnectreason = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 PhoneObject = 9;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string PhoneCallInput = 10;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPhonecallinput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPhonecallinput = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int32 ReasonItem = 11;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getReasonitem = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setReasonitem = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 CommunicationWay = 12;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getCommunicationway = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setCommunicationway = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string CommunicationWayRemark = 13;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getCommunicationwayremark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setCommunicationwayremark = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string PromiseRepayTime = 14;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPromiserepaytime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPromiserepaytime = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string PhoneTime = 15;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPhonetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPhonetime = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int64 CallId = 16;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getCallid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setCallid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 16, value);
};


/**
 * optional int32 ItemId = 17;
 * @return {number}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string NextDialTime = 18;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getNextdialtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setNextdialtime = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string PromiseRepayAmount = 19;
 * @return {string}
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.getPromiserepayamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveUrgeCaseBaseInfo} returns this
 */
proto.xcommon.SaveUrgeCaseBaseInfo.prototype.setPromiserepayamount = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OptionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OptionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OptionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OptionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    index: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OptionItem}
 */
proto.xcommon.OptionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OptionItem;
  return proto.xcommon.OptionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OptionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OptionItem}
 */
proto.xcommon.OptionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OptionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OptionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OptionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OptionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 Index = 1;
 * @return {number}
 */
proto.xcommon.OptionItem.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OptionItem} returns this
 */
proto.xcommon.OptionItem.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.OptionItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OptionItem} returns this
 */
proto.xcommon.OptionItem.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCustomerDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCustomerDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCustomerDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    systemtype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCustomerDetailReq}
 */
proto.xcommon.GetCustomerDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCustomerDetailReq;
  return proto.xcommon.GetCustomerDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCustomerDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCustomerDetailReq}
 */
proto.xcommon.GetCustomerDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.MPSystemType} */ (reader.readEnum());
      msg.setSystemtype(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCustomerDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCustomerDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCustomerDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getSystemtype();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetCustomerDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
*/
proto.xcommon.GetCustomerDetailReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
 */
proto.xcommon.GetCustomerDetailReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetCustomerDetailReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
*/
proto.xcommon.GetCustomerDetailReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
 */
proto.xcommon.GetCustomerDetailReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerDetailReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 AccountId = 3;
 * @return {string}
 */
proto.xcommon.GetCustomerDetailReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
 */
proto.xcommon.GetCustomerDetailReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional MPSystemType SystemType = 5;
 * @return {!proto.xcommon.MPSystemType}
 */
proto.xcommon.GetCustomerDetailReq.prototype.getSystemtype = function() {
  return /** @type {!proto.xcommon.MPSystemType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.xcommon.MPSystemType} value
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
 */
proto.xcommon.GetCustomerDetailReq.prototype.setSystemtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.GetCustomerDetailReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCustomerDetailReq} returns this
 */
proto.xcommon.GetCustomerDetailReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetCustomerDetailResp.repeatedFields_ = [3,6,8,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCustomerDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCustomerDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCustomerDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    detailtabsList: jspb.Message.toObjectList(msg.getDetailtabsList(),
    xcommon_core_pb.CustomerDetailTab.toObject, includeInstance),
    baseinfo: (f = msg.getBaseinfo()) && xcommon_core_pb.AccountBaseInfo.toObject(includeInstance, f),
    profile: (f = msg.getProfile()) && xcommon_core_pb.AccountProfileInfo.toObject(includeInstance, f),
    loanhistoryList: jspb.Message.toObjectList(msg.getLoanhistoryList(),
    xcommon_core_pb.AccountLoanHistoryBackend.toObject, includeInstance),
    totalloanhistory: jspb.Message.getFieldWithDefault(msg, 7, 0),
    changelogList: jspb.Message.toObjectList(msg.getChangelogList(),
    xcommon_core_pb.AccountChangeLog.toObject, includeInstance),
    totalchangelog: jspb.Message.getFieldWithDefault(msg, 9, 0),
    billhistoryList: jspb.Message.toObjectList(msg.getBillhistoryList(),
    xcommon_core_pb.AccountBillHistory.toObject, includeInstance),
    totalbillhistory: jspb.Message.getFieldWithDefault(msg, 11, 0),
    showloanhistory: jspb.Message.getFieldWithDefault(msg, 12, 0),
    showbillhistory: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCustomerDetailResp}
 */
proto.xcommon.GetCustomerDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCustomerDetailResp;
  return proto.xcommon.GetCustomerDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCustomerDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCustomerDetailResp}
 */
proto.xcommon.GetCustomerDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.CustomerDetailTab;
      reader.readMessage(value,xcommon_core_pb.CustomerDetailTab.deserializeBinaryFromReader);
      msg.addDetailtabs(value);
      break;
    case 4:
      var value = new xcommon_core_pb.AccountBaseInfo;
      reader.readMessage(value,xcommon_core_pb.AccountBaseInfo.deserializeBinaryFromReader);
      msg.setBaseinfo(value);
      break;
    case 5:
      var value = new xcommon_core_pb.AccountProfileInfo;
      reader.readMessage(value,xcommon_core_pb.AccountProfileInfo.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 6:
      var value = new xcommon_core_pb.AccountLoanHistoryBackend;
      reader.readMessage(value,xcommon_core_pb.AccountLoanHistoryBackend.deserializeBinaryFromReader);
      msg.addLoanhistory(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalloanhistory(value);
      break;
    case 8:
      var value = new xcommon_core_pb.AccountChangeLog;
      reader.readMessage(value,xcommon_core_pb.AccountChangeLog.deserializeBinaryFromReader);
      msg.addChangelog(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalchangelog(value);
      break;
    case 10:
      var value = new xcommon_core_pb.AccountBillHistory;
      reader.readMessage(value,xcommon_core_pb.AccountBillHistory.deserializeBinaryFromReader);
      msg.addBillhistory(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalbillhistory(value);
      break;
    case 12:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setShowloanhistory(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setShowbillhistory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCustomerDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCustomerDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCustomerDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getDetailtabsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.CustomerDetailTab.serializeBinaryToWriter
    );
  }
  f = message.getBaseinfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      xcommon_core_pb.AccountBaseInfo.serializeBinaryToWriter
    );
  }
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      xcommon_core_pb.AccountProfileInfo.serializeBinaryToWriter
    );
  }
  f = message.getLoanhistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      xcommon_core_pb.AccountLoanHistoryBackend.serializeBinaryToWriter
    );
  }
  f = message.getTotalloanhistory();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getChangelogList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      xcommon_core_pb.AccountChangeLog.serializeBinaryToWriter
    );
  }
  f = message.getTotalchangelog();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getBillhistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      xcommon_core_pb.AccountBillHistory.serializeBinaryToWriter
    );
  }
  f = message.getTotalbillhistory();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getShowloanhistory();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getShowbillhistory();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerDetailResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CustomerDetailTab DetailTabs = 3;
 * @return {!Array<!proto.xcommon.CustomerDetailTab>}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getDetailtabsList = function() {
  return /** @type{!Array<!proto.xcommon.CustomerDetailTab>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.CustomerDetailTab, 3));
};


/**
 * @param {!Array<!proto.xcommon.CustomerDetailTab>} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setDetailtabsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.CustomerDetailTab=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CustomerDetailTab}
 */
proto.xcommon.GetCustomerDetailResp.prototype.addDetailtabs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.CustomerDetailTab, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearDetailtabsList = function() {
  return this.setDetailtabsList([]);
};


/**
 * optional AccountBaseInfo BaseInfo = 4;
 * @return {?proto.xcommon.AccountBaseInfo}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getBaseinfo = function() {
  return /** @type{?proto.xcommon.AccountBaseInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountBaseInfo, 4));
};


/**
 * @param {?proto.xcommon.AccountBaseInfo|undefined} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setBaseinfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearBaseinfo = function() {
  return this.setBaseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerDetailResp.prototype.hasBaseinfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AccountProfileInfo Profile = 5;
 * @return {?proto.xcommon.AccountProfileInfo}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getProfile = function() {
  return /** @type{?proto.xcommon.AccountProfileInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.AccountProfileInfo, 5));
};


/**
 * @param {?proto.xcommon.AccountProfileInfo|undefined} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerDetailResp.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated AccountLoanHistoryBackend LoanHistory = 6;
 * @return {!Array<!proto.xcommon.AccountLoanHistoryBackend>}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getLoanhistoryList = function() {
  return /** @type{!Array<!proto.xcommon.AccountLoanHistoryBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.AccountLoanHistoryBackend, 6));
};


/**
 * @param {!Array<!proto.xcommon.AccountLoanHistoryBackend>} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setLoanhistoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.AccountLoanHistoryBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AccountLoanHistoryBackend}
 */
proto.xcommon.GetCustomerDetailResp.prototype.addLoanhistory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.AccountLoanHistoryBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearLoanhistoryList = function() {
  return this.setLoanhistoryList([]);
};


/**
 * optional int64 TotalLoanHistory = 7;
 * @return {number}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getTotalloanhistory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.setTotalloanhistory = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated AccountChangeLog ChangeLog = 8;
 * @return {!Array<!proto.xcommon.AccountChangeLog>}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getChangelogList = function() {
  return /** @type{!Array<!proto.xcommon.AccountChangeLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.AccountChangeLog, 8));
};


/**
 * @param {!Array<!proto.xcommon.AccountChangeLog>} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setChangelogList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.xcommon.AccountChangeLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AccountChangeLog}
 */
proto.xcommon.GetCustomerDetailResp.prototype.addChangelog = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.xcommon.AccountChangeLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearChangelogList = function() {
  return this.setChangelogList([]);
};


/**
 * optional int64 TotalChangeLog = 9;
 * @return {number}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getTotalchangelog = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.setTotalchangelog = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated AccountBillHistory BillHistory = 10;
 * @return {!Array<!proto.xcommon.AccountBillHistory>}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getBillhistoryList = function() {
  return /** @type{!Array<!proto.xcommon.AccountBillHistory>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.AccountBillHistory, 10));
};


/**
 * @param {!Array<!proto.xcommon.AccountBillHistory>} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
*/
proto.xcommon.GetCustomerDetailResp.prototype.setBillhistoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.xcommon.AccountBillHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AccountBillHistory}
 */
proto.xcommon.GetCustomerDetailResp.prototype.addBillhistory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.xcommon.AccountBillHistory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.clearBillhistoryList = function() {
  return this.setBillhistoryList([]);
};


/**
 * optional int64 TotalBillHistory = 11;
 * @return {number}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getTotalbillhistory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.setTotalbillhistory = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Bool ShowLoanHistory = 12;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getShowloanhistory = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.setShowloanhistory = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional Bool ShowBillHistory = 13;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.GetCustomerDetailResp.prototype.getShowbillhistory = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.xcommon.GetCustomerDetailResp} returns this
 */
proto.xcommon.GetCustomerDetailResp.prototype.setShowbillhistory = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UpdateCustomerSalaryInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    accountid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    salarytype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    salaryday: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UpdateCustomerSalaryInfoReq;
  return proto.xcommon.UpdateCustomerSalaryInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSalarytype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalaryday(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UpdateCustomerSalaryInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getSalarytype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSalaryday();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq} returns this
*/
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 AccountId = 2;
 * @return {string}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int32 SalaryType = 3;
 * @return {number}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.getSalarytype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.setSalarytype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string SalaryDay = 4;
 * @return {string}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.getSalaryday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.setSalaryday = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoReq} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UpdateCustomerSalaryInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmsg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoResp}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UpdateCustomerSalaryInfoResp;
  return proto.xcommon.UpdateCustomerSalaryInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoResp}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UpdateCustomerSalaryInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UpdateCustomerSalaryInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoResp} returns this
*/
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoResp} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMsg = 2;
 * @return {string}
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.getOpmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateCustomerSalaryInfoResp} returns this
 */
proto.xcommon.UpdateCustomerSalaryInfoResp.prototype.setOpmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetSmsTaskIdMapReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetSmsTaskIdMapReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetSmsTaskIdMapReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caselevel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    taskcallresult: jspb.Message.getFieldWithDefault(msg, 3, 0),
    tasktarget: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 5, 0),
    repayinclination: jspb.Message.getFieldWithDefault(msg, 6, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetSmsTaskIdMapReq}
 */
proto.xcommon.GetSmsTaskIdMapReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetSmsTaskIdMapReq;
  return proto.xcommon.GetSmsTaskIdMapReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetSmsTaskIdMapReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetSmsTaskIdMapReq}
 */
proto.xcommon.GetSmsTaskIdMapReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskcallresult(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktarget(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRepayinclination(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetSmsTaskIdMapReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetSmsTaskIdMapReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetSmsTaskIdMapReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskcallresult();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTasktarget();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRepayinclination();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
*/
proto.xcommon.GetSmsTaskIdMapReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CaseLevel = 2;
 * @return {string}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 TaskCallResult = 3;
 * @return {number}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getTaskcallresult = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setTaskcallresult = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string TaskTarget = 4;
 * @return {string}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getTasktarget = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setTasktarget = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 PhoneObject = 5;
 * @return {number}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 RepayInclination = 6;
 * @return {number}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getRepayinclination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setRepayinclination = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 OrderId = 7;
 * @return {string}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetSmsTaskIdMapReq} returns this
 */
proto.xcommon.GetSmsTaskIdMapReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetSmsTaskIdMapResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetSmsTaskIdMapResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetSmsTaskIdMapResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    smstaskidmapMap: (f = msg.getSmstaskidmapMap()) ? f.toObject(includeInstance, undefined) : [],
    smscontentmapMap: (f = msg.getSmscontentmapMap()) ? f.toObject(includeInstance, undefined) : [],
    smsparammapMap: (f = msg.getSmsparammapMap()) ? f.toObject(includeInstance, proto.xcommon.SmsTaskParamList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetSmsTaskIdMapResp}
 */
proto.xcommon.GetSmsTaskIdMapResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetSmsTaskIdMapResp;
  return proto.xcommon.GetSmsTaskIdMapResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetSmsTaskIdMapResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetSmsTaskIdMapResp}
 */
proto.xcommon.GetSmsTaskIdMapResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getSmstaskidmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 3:
      var value = msg.getSmscontentmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 5:
      var value = msg.getSmsparammapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.xcommon.SmsTaskParamList.deserializeBinaryFromReader, 0, new proto.xcommon.SmsTaskParamList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetSmsTaskIdMapResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetSmsTaskIdMapResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetSmsTaskIdMapResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSmstaskidmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getSmscontentmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getSmsparammapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.SmsTaskParamList.serializeBinaryToWriter);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetSmsTaskIdMapResp} returns this
*/
proto.xcommon.GetSmsTaskIdMapResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetSmsTaskIdMapResp} returns this
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int64, string> SmsTaskIdMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.getSmstaskidmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetSmsTaskIdMapResp} returns this
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.clearSmstaskidmapMap = function() {
  this.getSmstaskidmapMap().clear();
  return this;
};


/**
 * map<int64, string> SmsContentMap = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.getSmscontentmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetSmsTaskIdMapResp} returns this
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.clearSmscontentmapMap = function() {
  this.getSmscontentmapMap().clear();
  return this;
};


/**
 * map<int64, SmsTaskParamList> SmsParamMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.SmsTaskParamList>}
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.getSmsparammapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.SmsTaskParamList>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.xcommon.SmsTaskParamList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetSmsTaskIdMapResp} returns this
 */
proto.xcommon.GetSmsTaskIdMapResp.prototype.clearSmsparammapMap = function() {
  this.getSmsparammapMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SendSmsByTaskIdReq.repeatedFields_ = [16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SendSmsByTaskIdReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SendSmsByTaskIdReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendSmsByTaskIdReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, ""),
    taskid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    repayday: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rediskey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    repaymd: jspb.Message.getFieldWithDefault(msg, 6, ""),
    overdueday: jspb.Message.getFieldWithDefault(msg, 7, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 8, "0"),
    smstemplate: jspb.Message.getFieldWithDefault(msg, 9, ""),
    urgetype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 11, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 12, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 13, "0"),
    overduecaseid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 15, 0),
    paramlistList: jspb.Message.toObjectList(msg.getParamlistList(),
    xcommon_core_pb.SmsTaskParamValue.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SendSmsByTaskIdReq}
 */
proto.xcommon.SendSmsByTaskIdReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SendSmsByTaskIdReq;
  return proto.xcommon.SendSmsByTaskIdReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SendSmsByTaskIdReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SendSmsByTaskIdReq}
 */
proto.xcommon.SendSmsByTaskIdReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTaskid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepayday(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRediskey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepaymd(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOverdueday(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSmstemplate(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.CollectionType} */ (reader.readEnum());
      msg.setUrgetype(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOverduecaseid(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 16:
      var value = new xcommon_core_pb.SmsTaskParamValue;
      reader.readMessage(value,xcommon_core_pb.SmsTaskParamValue.deserializeBinaryFromReader);
      msg.addParamlist(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SendSmsByTaskIdReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SendSmsByTaskIdReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendSmsByTaskIdReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRepayday();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRediskey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRepaymd();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOverdueday();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      8,
      f
    );
  }
  f = message.getSmstemplate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUrgetype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      13,
      f
    );
  }
  f = message.getOverduecaseid();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getParamlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      xcommon_core_pb.SmsTaskParamValue.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
*/
proto.xcommon.SendSmsByTaskIdReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 TaskId = 3;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getTaskid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setTaskid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string RepayDay = 4;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getRepayday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setRepayday = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string RedisKey = 5;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getRediskey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setRediskey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string RepayMd = 6;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getRepaymd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setRepaymd = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 OverdueDay = 7;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getOverdueday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setOverdueday = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 AccountId = 8;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 8, value);
};


/**
 * optional string SmsTemplate = 9;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getSmstemplate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setSmstemplate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional CollectionType UrgeType = 10;
 * @return {!proto.xcommon.CollectionType}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getUrgetype = function() {
  return /** @type {!proto.xcommon.CollectionType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.xcommon.CollectionType} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setUrgetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 TicketId = 11;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 ItemId = 12;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 OrderId = 13;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 13, value);
};


/**
 * optional int64 OverdueCaseId = 14;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getOverduecaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setOverduecaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 PhoneObject = 15;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * repeated SmsTaskParamValue ParamList = 16;
 * @return {!Array<!proto.xcommon.SmsTaskParamValue>}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getParamlistList = function() {
  return /** @type{!Array<!proto.xcommon.SmsTaskParamValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.SmsTaskParamValue, 16));
};


/**
 * @param {!Array<!proto.xcommon.SmsTaskParamValue>} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
*/
proto.xcommon.SendSmsByTaskIdReq.prototype.setParamlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.xcommon.SmsTaskParamValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsTaskParamValue}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.addParamlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.xcommon.SmsTaskParamValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.clearParamlistList = function() {
  return this.setParamlistList([]);
};


/**
 * optional string AppName = 17;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdReq} returns this
 */
proto.xcommon.SendSmsByTaskIdReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SendSmsByTaskIdResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SendSmsByTaskIdResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendSmsByTaskIdResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    smsstatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    opmsg: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SendSmsByTaskIdResp}
 */
proto.xcommon.SendSmsByTaskIdResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SendSmsByTaskIdResp;
  return proto.xcommon.SendSmsByTaskIdResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SendSmsByTaskIdResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SendSmsByTaskIdResp}
 */
proto.xcommon.SendSmsByTaskIdResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSmsstatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SendSmsByTaskIdResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SendSmsByTaskIdResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendSmsByTaskIdResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSmsstatus();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOpmsg();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SendSmsByTaskIdResp} returns this
*/
proto.xcommon.SendSmsByTaskIdResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SendSmsByTaskIdResp} returns this
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 SmsStatus = 2;
 * @return {number}
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.getSmsstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendSmsByTaskIdResp} returns this
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.setSmsstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string OpMsg = 3;
 * @return {string}
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.getOpmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendSmsByTaskIdResp} returns this
 */
proto.xcommon.SendSmsByTaskIdResp.prototype.setOpmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUrgeLetterMapReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUrgeLetterMapReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeLetterMapReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caselevel: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUrgeLetterMapReq}
 */
proto.xcommon.GetUrgeLetterMapReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUrgeLetterMapReq;
  return proto.xcommon.GetUrgeLetterMapReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUrgeLetterMapReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUrgeLetterMapReq}
 */
proto.xcommon.GetUrgeLetterMapReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUrgeLetterMapReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUrgeLetterMapReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeLetterMapReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetUrgeLetterMapReq} returns this
*/
proto.xcommon.GetUrgeLetterMapReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetUrgeLetterMapReq} returns this
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CaseLevel = 3;
 * @return {string}
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetUrgeLetterMapReq} returns this
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetUrgeLetterMapReq} returns this
 */
proto.xcommon.GetUrgeLetterMapReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetUrgeLetterMapResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetUrgeLetterMapResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeLetterMapResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    urgelettermapMap: (f = msg.getUrgelettermapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetUrgeLetterMapResp}
 */
proto.xcommon.GetUrgeLetterMapResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetUrgeLetterMapResp;
  return proto.xcommon.GetUrgeLetterMapResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetUrgeLetterMapResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetUrgeLetterMapResp}
 */
proto.xcommon.GetUrgeLetterMapResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = msg.getUrgelettermapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetUrgeLetterMapResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetUrgeLetterMapResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetUrgeLetterMapResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUrgelettermapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetUrgeLetterMapResp} returns this
*/
proto.xcommon.GetUrgeLetterMapResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetUrgeLetterMapResp} returns this
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int64, string> UrgeLetterMap = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.getUrgelettermapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetUrgeLetterMapResp} returns this
 */
proto.xcommon.GetUrgeLetterMapResp.prototype.clearUrgelettermapMap = function() {
  this.getUrgelettermapMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DownloadUrgeLetterReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DownloadUrgeLetterReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadUrgeLetterReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    letterid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    extraparamsMap: (f = msg.getExtraparamsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DownloadUrgeLetterReq}
 */
proto.xcommon.DownloadUrgeLetterReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DownloadUrgeLetterReq;
  return proto.xcommon.DownloadUrgeLetterReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DownloadUrgeLetterReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DownloadUrgeLetterReq}
 */
proto.xcommon.DownloadUrgeLetterReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLetterid(value);
      break;
    case 5:
      var value = msg.getExtraparamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DownloadUrgeLetterReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DownloadUrgeLetterReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadUrgeLetterReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getLetterid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getExtraparamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DownloadUrgeLetterReq} returns this
*/
proto.xcommon.DownloadUrgeLetterReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DownloadUrgeLetterReq} returns this
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DownloadUrgeLetterReq} returns this
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 LetterId = 4;
 * @return {number}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.getLetterid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DownloadUrgeLetterReq} returns this
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.setLetterid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * map<string, string> ExtraParams = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.getExtraparamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.DownloadUrgeLetterReq} returns this
 */
proto.xcommon.DownloadUrgeLetterReq.prototype.clearExtraparamsMap = function() {
  this.getExtraparamsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DownloadUrgeLetterResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DownloadUrgeLetterResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadUrgeLetterResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    letter: (f = msg.getLetter()) && xcommon_core_pb.File.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DownloadUrgeLetterResp}
 */
proto.xcommon.DownloadUrgeLetterResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DownloadUrgeLetterResp;
  return proto.xcommon.DownloadUrgeLetterResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DownloadUrgeLetterResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DownloadUrgeLetterResp}
 */
proto.xcommon.DownloadUrgeLetterResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.File;
      reader.readMessage(value,xcommon_core_pb.File.deserializeBinaryFromReader);
      msg.setLetter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DownloadUrgeLetterResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DownloadUrgeLetterResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadUrgeLetterResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getLetter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_core_pb.File.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.DownloadUrgeLetterResp} returns this
*/
proto.xcommon.DownloadUrgeLetterResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DownloadUrgeLetterResp} returns this
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional File Letter = 3;
 * @return {?proto.xcommon.File}
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.getLetter = function() {
  return /** @type{?proto.xcommon.File} */ (
    jspb.Message.getWrapperField(this, xcommon_core_pb.File, 3));
};


/**
 * @param {?proto.xcommon.File|undefined} value
 * @return {!proto.xcommon.DownloadUrgeLetterResp} returns this
*/
proto.xcommon.DownloadUrgeLetterResp.prototype.setLetter = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DownloadUrgeLetterResp} returns this
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.clearLetter = function() {
  return this.setLetter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownloadUrgeLetterResp.prototype.hasLetter = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UpdateMarketPaymentCodeAmountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fee: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UpdateMarketPaymentCodeAmountReq;
  return proto.xcommon.UpdateMarketPaymentCodeAmountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFee(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UpdateMarketPaymentCodeAmountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFee();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} returns this
*/
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 Amount = 3;
 * @return {number}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Fee = 4;
 * @return {number}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.setFee = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountReq} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UpdateMarketPaymentCodeAmountResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountResp}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UpdateMarketPaymentCodeAmountResp;
  return proto.xcommon.UpdateMarketPaymentCodeAmountResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountResp}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmsg(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UpdateMarketPaymentCodeAmountResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} returns this
*/
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMsg = 2;
 * @return {string}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.getOpmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.setOpmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UpdateMarketPaymentCodeAmountResp} returns this
 */
proto.xcommon.UpdateMarketPaymentCodeAmountResp.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CasePageTurningReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CasePageTurningReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CasePageTurningReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CasePageTurningReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ispre: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CasePageTurningReq}
 */
proto.xcommon.CasePageTurningReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CasePageTurningReq;
  return proto.xcommon.CasePageTurningReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CasePageTurningReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CasePageTurningReq}
 */
proto.xcommon.CasePageTurningReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspre(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CasePageTurningReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CasePageTurningReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CasePageTurningReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CasePageTurningReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getIspre();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CasePageTurningReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CasePageTurningReq} returns this
*/
proto.xcommon.CasePageTurningReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CasePageTurningReq} returns this
 */
proto.xcommon.CasePageTurningReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CasePageTurningReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.CasePageTurningReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CasePageTurningReq} returns this
 */
proto.xcommon.CasePageTurningReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool IsPre = 3;
 * @return {boolean}
 */
proto.xcommon.CasePageTurningReq.prototype.getIspre = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.CasePageTurningReq} returns this
 */
proto.xcommon.CasePageTurningReq.prototype.setIspre = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.CasePageTurningReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CasePageTurningReq} returns this
 */
proto.xcommon.CasePageTurningReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int32 ItemId = 5;
 * @return {number}
 */
proto.xcommon.CasePageTurningReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CasePageTurningReq} returns this
 */
proto.xcommon.CasePageTurningReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CasePageTurningResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CasePageTurningResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CasePageTurningResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CasePageTurningResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CasePageTurningResp}
 */
proto.xcommon.CasePageTurningResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CasePageTurningResp;
  return proto.xcommon.CasePageTurningResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CasePageTurningResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CasePageTurningResp}
 */
proto.xcommon.CasePageTurningResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CasePageTurningResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CasePageTurningResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CasePageTurningResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CasePageTurningResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CasePageTurningResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CasePageTurningResp} returns this
*/
proto.xcommon.CasePageTurningResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CasePageTurningResp} returns this
 */
proto.xcommon.CasePageTurningResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CasePageTurningResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.CasePageTurningResp.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CasePageTurningResp} returns this
 */
proto.xcommon.CasePageTurningResp.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.CasePageTurningResp.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CasePageTurningResp} returns this
 */
proto.xcommon.CasePageTurningResp.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveRiskReportReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveRiskReportReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveRiskReportReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRiskReportReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    urgetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    phoneconnected: jspb.Message.getFieldWithDefault(msg, 6, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 7, 0),
    phonecallinput: jspb.Message.getFieldWithDefault(msg, 8, ""),
    phonetime: jspb.Message.getFieldWithDefault(msg, 9, ""),
    riskreport: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveRiskReportReq}
 */
proto.xcommon.SaveRiskReportReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveRiskReportReq;
  return proto.xcommon.SaveRiskReportReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveRiskReportReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveRiskReportReq}
 */
proto.xcommon.SaveRiskReportReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.CollectionType} */ (reader.readEnum());
      msg.setUrgetype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneconnected(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonecallinput(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonetime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskreport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveRiskReportReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveRiskReportReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveRiskReportReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRiskReportReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUrgetype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getPhoneconnected();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPhonecallinput();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPhonetime();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRiskreport();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveRiskReportReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
*/
proto.xcommon.SaveRiskReportReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRiskReportReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CaseId = 2;
 * @return {number}
 */
proto.xcommon.SaveRiskReportReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.SaveRiskReportReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional CollectionType UrgeType = 4;
 * @return {!proto.xcommon.CollectionType}
 */
proto.xcommon.SaveRiskReportReq.prototype.getUrgetype = function() {
  return /** @type {!proto.xcommon.CollectionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.xcommon.CollectionType} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setUrgetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.SaveRiskReportReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int32 PhoneConnected = 6;
 * @return {number}
 */
proto.xcommon.SaveRiskReportReq.prototype.getPhoneconnected = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setPhoneconnected = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 PhoneObject = 7;
 * @return {number}
 */
proto.xcommon.SaveRiskReportReq.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string PhoneCallInput = 8;
 * @return {string}
 */
proto.xcommon.SaveRiskReportReq.prototype.getPhonecallinput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setPhonecallinput = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string PhoneTime = 9;
 * @return {string}
 */
proto.xcommon.SaveRiskReportReq.prototype.getPhonetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setPhonetime = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string RiskReport = 10;
 * @return {string}
 */
proto.xcommon.SaveRiskReportReq.prototype.getRiskreport = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveRiskReportReq} returns this
 */
proto.xcommon.SaveRiskReportReq.prototype.setRiskreport = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveRiskReportResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveRiskReportResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveRiskReportResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRiskReportResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    opmessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveRiskReportResp}
 */
proto.xcommon.SaveRiskReportResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveRiskReportResp;
  return proto.xcommon.SaveRiskReportResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveRiskReportResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveRiskReportResp}
 */
proto.xcommon.SaveRiskReportResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveRiskReportResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveRiskReportResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveRiskReportResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRiskReportResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOpmessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveRiskReportResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveRiskReportResp} returns this
*/
proto.xcommon.SaveRiskReportResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRiskReportResp} returns this
 */
proto.xcommon.SaveRiskReportResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRiskReportResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string OpMessage = 2;
 * @return {string}
 */
proto.xcommon.SaveRiskReportResp.prototype.getOpmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveRiskReportResp} returns this
 */
proto.xcommon.SaveRiskReportResp.prototype.setOpmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveContactReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveContactReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveContactReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveContactReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    contact: jspb.Message.getFieldWithDefault(msg, 3, ""),
    relationship: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    opuid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    extcontactid: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveContactReq}
 */
proto.xcommon.SaveContactReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveContactReq;
  return proto.xcommon.SaveContactReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveContactReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveContactReq}
 */
proto.xcommon.SaveContactReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRelationship(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExtcontactid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveContactReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveContactReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveContactReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveContactReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getContact();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRelationship();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExtcontactid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveContactReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveContactReq} returns this
*/
proto.xcommon.SaveContactReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveContactReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderID = 2;
 * @return {string}
 */
proto.xcommon.SaveContactReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string Contact = 3;
 * @return {string}
 */
proto.xcommon.SaveContactReq.prototype.getContact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.setContact = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 Relationship = 4;
 * @return {number}
 */
proto.xcommon.SaveContactReq.prototype.getRelationship = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.setRelationship = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.xcommon.SaveContactReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 OpUID = 6;
 * @return {number}
 */
proto.xcommon.SaveContactReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 ExtContactID = 7;
 * @return {number}
 */
proto.xcommon.SaveContactReq.prototype.getExtcontactid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveContactReq} returns this
 */
proto.xcommon.SaveContactReq.prototype.setExtcontactid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveContactResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveContactResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveContactResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveContactResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveContactResp}
 */
proto.xcommon.SaveContactResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveContactResp;
  return proto.xcommon.SaveContactResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveContactResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveContactResp}
 */
proto.xcommon.SaveContactResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveContactResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveContactResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveContactResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveContactResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveContactResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveContactResp} returns this
*/
proto.xcommon.SaveContactResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveContactResp} returns this
 */
proto.xcommon.SaveContactResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveContactResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWhatsAppMsgMapReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWhatsAppMsgMapReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWhatsAppMsgMapReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caselevel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    lang: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq}
 */
proto.xcommon.GetWhatsAppMsgMapReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWhatsAppMsgMapReq;
  return proto.xcommon.GetWhatsAppMsgMapReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWhatsAppMsgMapReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq}
 */
proto.xcommon.GetWhatsAppMsgMapReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLang(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWhatsAppMsgMapReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWhatsAppMsgMapReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWhatsAppMsgMapReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getLang();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq} returns this
*/
proto.xcommon.GetWhatsAppMsgMapReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq} returns this
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CaseLevel = 2;
 * @return {string}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq} returns this
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq} returns this
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string Lang = 4;
 * @return {string}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.getLang = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq} returns this
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.setLang = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapReq} returns this
 */
proto.xcommon.GetWhatsAppMsgMapReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetWhatsAppMsgMapResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetWhatsAppMsgMapResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWhatsAppMsgMapResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    whatsappmsgmapMap: (f = msg.getWhatsappmsgmapMap()) ? f.toObject(includeInstance, undefined) : [],
    countrycode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp}
 */
proto.xcommon.GetWhatsAppMsgMapResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetWhatsAppMsgMapResp;
  return proto.xcommon.GetWhatsAppMsgMapResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetWhatsAppMsgMapResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp}
 */
proto.xcommon.GetWhatsAppMsgMapResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getWhatsappmsgmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrycode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetWhatsAppMsgMapResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetWhatsAppMsgMapResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetWhatsAppMsgMapResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getWhatsappmsgmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCountrycode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp} returns this
*/
proto.xcommon.GetWhatsAppMsgMapResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp} returns this
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, string> WhatsAppMsgMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.getWhatsappmsgmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp} returns this
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.clearWhatsappmsgmapMap = function() {
  this.getWhatsappmsgmapMap().clear();
  return this;
};


/**
 * optional string CountryCode = 3;
 * @return {string}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.getCountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp} returns this
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.setCountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetWhatsAppMsgMapResp} returns this
 */
proto.xcommon.GetWhatsAppMsgMapResp.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAllAutoCallResultReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAllAutoCallResultReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAllAutoCallResultReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAllAutoCallResultReq}
 */
proto.xcommon.GetAllAutoCallResultReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAllAutoCallResultReq;
  return proto.xcommon.GetAllAutoCallResultReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAllAutoCallResultReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAllAutoCallResultReq}
 */
proto.xcommon.GetAllAutoCallResultReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAllAutoCallResultReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAllAutoCallResultReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAllAutoCallResultReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetAllAutoCallResultReq} returns this
*/
proto.xcommon.GetAllAutoCallResultReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetAllAutoCallResultReq} returns this
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetAllAutoCallResultReq} returns this
*/
proto.xcommon.GetAllAutoCallResultReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetAllAutoCallResultReq} returns this
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Mobile = 3;
 * @return {string}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetAllAutoCallResultReq} returns this
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetAllAutoCallResultReq} returns this
 */
proto.xcommon.GetAllAutoCallResultReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetAllAutoCallResultResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetAllAutoCallResultResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetAllAutoCallResultResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAllAutoCallResultResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_core_pb.AutoCallResultInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetAllAutoCallResultResp}
 */
proto.xcommon.GetAllAutoCallResultResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetAllAutoCallResultResp;
  return proto.xcommon.GetAllAutoCallResultResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetAllAutoCallResultResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetAllAutoCallResultResp}
 */
proto.xcommon.GetAllAutoCallResultResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.AutoCallResultInfo;
      reader.readMessage(value,xcommon_core_pb.AutoCallResultInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetAllAutoCallResultResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetAllAutoCallResultResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetAllAutoCallResultResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.AutoCallResultInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetAllAutoCallResultResp} returns this
*/
proto.xcommon.GetAllAutoCallResultResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetAllAutoCallResultResp} returns this
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetAllAutoCallResultResp} returns this
*/
proto.xcommon.GetAllAutoCallResultResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetAllAutoCallResultResp} returns this
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AutoCallResultInfo List = 3;
 * @return {!Array<!proto.xcommon.AutoCallResultInfo>}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.AutoCallResultInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.AutoCallResultInfo, 3));
};


/**
 * @param {!Array<!proto.xcommon.AutoCallResultInfo>} value
 * @return {!proto.xcommon.GetAllAutoCallResultResp} returns this
*/
proto.xcommon.GetAllAutoCallResultResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.AutoCallResultInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AutoCallResultInfo}
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.AutoCallResultInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetAllAutoCallResultResp} returns this
 */
proto.xcommon.GetAllAutoCallResultResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCaseLogDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCaseLogDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCaseLogDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    caseid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCaseLogDetailReq}
 */
proto.xcommon.GetCaseLogDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCaseLogDetailReq;
  return proto.xcommon.GetCaseLogDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCaseLogDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCaseLogDetailReq}
 */
proto.xcommon.GetCaseLogDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCaseLogDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCaseLogDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCaseLogDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
*/
proto.xcommon.GetCaseLogDetailReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
 */
proto.xcommon.GetCaseLogDetailReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
*/
proto.xcommon.GetCaseLogDetailReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
 */
proto.xcommon.GetCaseLogDetailReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 CaseId = 3;
 * @return {number}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
 */
proto.xcommon.GetCaseLogDetailReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 ItemId = 4;
 * @return {number}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
 */
proto.xcommon.GetCaseLogDetailReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetCaseLogDetailReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCaseLogDetailReq} returns this
 */
proto.xcommon.GetCaseLogDetailReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetCaseLogDetailResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCaseLogDetailResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCaseLogDetailResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCaseLogDetailResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.CaseLogDetailBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCaseLogDetailResp}
 */
proto.xcommon.GetCaseLogDetailResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCaseLogDetailResp;
  return proto.xcommon.GetCaseLogDetailResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCaseLogDetailResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCaseLogDetailResp}
 */
proto.xcommon.GetCaseLogDetailResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.xcommon.CaseLogDetailBackend;
      reader.readMessage(value,proto.xcommon.CaseLogDetailBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCaseLogDetailResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCaseLogDetailResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCaseLogDetailResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.CaseLogDetailBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetCaseLogDetailResp} returns this
*/
proto.xcommon.GetCaseLogDetailResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCaseLogDetailResp} returns this
 */
proto.xcommon.GetCaseLogDetailResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetCaseLogDetailResp} returns this
*/
proto.xcommon.GetCaseLogDetailResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCaseLogDetailResp} returns this
 */
proto.xcommon.GetCaseLogDetailResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated CaseLogDetailBackend List = 3;
 * @return {!Array<!proto.xcommon.CaseLogDetailBackend>}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.CaseLogDetailBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CaseLogDetailBackend, 3));
};


/**
 * @param {!Array<!proto.xcommon.CaseLogDetailBackend>} value
 * @return {!proto.xcommon.GetCaseLogDetailResp} returns this
*/
proto.xcommon.GetCaseLogDetailResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.CaseLogDetailBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CaseLogDetailBackend}
 */
proto.xcommon.GetCaseLogDetailResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.CaseLogDetailBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetCaseLogDetailResp} returns this
 */
proto.xcommon.GetCaseLogDetailResp.prototype.clearListList = function() {
  return this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CreatePaymentVoucherReq.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreatePaymentVoucherReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreatePaymentVoucherReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentVoucherReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    remarks: jspb.Message.getFieldWithDefault(msg, 5, ""),
    imagesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    trxid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 10, 0),
    bucket: jspb.Message.getFieldWithDefault(msg, 11, ""),
    paymentdate: jspb.Message.getFieldWithDefault(msg, 12, ""),
    repaychanneltype: jspb.Message.getFieldWithDefault(msg, 13, 0),
    otherrepaychannel: jspb.Message.getFieldWithDefault(msg, 14, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreatePaymentVoucherReq}
 */
proto.xcommon.CreatePaymentVoucherReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreatePaymentVoucherReq;
  return proto.xcommon.CreatePaymentVoucherReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreatePaymentVoucherReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreatePaymentVoucherReq}
 */
proto.xcommon.CreatePaymentVoucherReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemarks(value);
      break;
    case 6:
      var values = /** @type {!Array<string>} */ (reader.isDelimited() ? reader.readPackedInt64String() : [reader.readInt64String()]);
      for (var i = 0; i < values.length; i++) {
        msg.addImages(values[i]);
      }
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrxid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBucket(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentdate(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaychanneltype(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOtherrepaychannel(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreatePaymentVoucherReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreatePaymentVoucherReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentVoucherReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getRemarks();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writePackedInt64String(
      6,
      f
    );
  }
  f = message.getTrxid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getBucket();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPaymentdate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRepaychanneltype();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getOtherrepaychannel();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
*/
proto.xcommon.CreatePaymentVoucherReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string Remarks = 5;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getRemarks = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setRemarks = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated int64 Images = 6;
 * @return {!Array<string>}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getImagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setImagesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.addImages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.clearImagesList = function() {
  return this.setImagesList([]);
};


/**
 * optional string TrxID = 9;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getTrxid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setTrxid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 Amount = 10;
 * @return {number}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string Bucket = 11;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getBucket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setBucket = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string PaymentDate = 12;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getPaymentdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setPaymentdate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 RepayChannelType = 13;
 * @return {number}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getRepaychanneltype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setRepaychanneltype = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string OtherRepayChannel = 14;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getOtherrepaychannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setOtherrepaychannel = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string AppName = 15;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherReq} returns this
 */
proto.xcommon.CreatePaymentVoucherReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreatePaymentVoucherResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreatePaymentVoucherResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentVoucherResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    isexist: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreatePaymentVoucherResp}
 */
proto.xcommon.CreatePaymentVoucherResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreatePaymentVoucherResp;
  return proto.xcommon.CreatePaymentVoucherResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreatePaymentVoucherResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreatePaymentVoucherResp}
 */
proto.xcommon.CreatePaymentVoucherResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsexist(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreatePaymentVoucherResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreatePaymentVoucherResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentVoucherResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getIsexist();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CreatePaymentVoucherResp} returns this
*/
proto.xcommon.CreatePaymentVoucherResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CreatePaymentVoucherResp} returns this
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool IsExist = 3;
 * @return {boolean}
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.getIsexist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.xcommon.CreatePaymentVoucherResp} returns this
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.setIsexist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentVoucherResp} returns this
 */
proto.xcommon.CreatePaymentVoucherResp.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UploadDocumentReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UploadDocumentReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UploadDocumentReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UploadDocumentReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    relatedid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    contenttype: jspb.Message.getFieldWithDefault(msg, 4, ""),
    exten: jspb.Message.getFieldWithDefault(msg, 5, ""),
    data: msg.getData_asB64(),
    usemark: jspb.Message.getFieldWithDefault(msg, 7, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UploadDocumentReq}
 */
proto.xcommon.UploadDocumentReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UploadDocumentReq;
  return proto.xcommon.UploadDocumentReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UploadDocumentReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UploadDocumentReq}
 */
proto.xcommon.UploadDocumentReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setRelatedid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContenttype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setExten(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.ResourceUseMark} */ (reader.readEnum());
      msg.setUsemark(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UploadDocumentReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UploadDocumentReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UploadDocumentReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UploadDocumentReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getRelatedid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getContenttype();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExten();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = message.getUsemark();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.UploadDocumentReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
*/
proto.xcommon.UploadDocumentReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UploadDocumentReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 RelatedID = 3;
 * @return {string}
 */
proto.xcommon.UploadDocumentReq.prototype.getRelatedid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.setRelatedid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string ContentType = 4;
 * @return {string}
 */
proto.xcommon.UploadDocumentReq.prototype.getContenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.setContenttype = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Exten = 5;
 * @return {string}
 */
proto.xcommon.UploadDocumentReq.prototype.getExten = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.setExten = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bytes Data = 6;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.UploadDocumentReq.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes Data = 6;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.xcommon.UploadDocumentReq.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.xcommon.UploadDocumentReq.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 6, value);
};


/**
 * optional ResourceUseMark UseMark = 7;
 * @return {!proto.xcommon.ResourceUseMark}
 */
proto.xcommon.UploadDocumentReq.prototype.getUsemark = function() {
  return /** @type {!proto.xcommon.ResourceUseMark} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.ResourceUseMark} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.setUsemark = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string AppName = 8;
 * @return {string}
 */
proto.xcommon.UploadDocumentReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UploadDocumentReq} returns this
 */
proto.xcommon.UploadDocumentReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UploadDocumentResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UploadDocumentResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UploadDocumentResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UploadDocumentResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    resourceid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UploadDocumentResp}
 */
proto.xcommon.UploadDocumentResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UploadDocumentResp;
  return proto.xcommon.UploadDocumentResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UploadDocumentResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UploadDocumentResp}
 */
proto.xcommon.UploadDocumentResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setResourceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UploadDocumentResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UploadDocumentResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UploadDocumentResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UploadDocumentResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getResourceid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.UploadDocumentResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.UploadDocumentResp} returns this
*/
proto.xcommon.UploadDocumentResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.UploadDocumentResp} returns this
 */
proto.xcommon.UploadDocumentResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UploadDocumentResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ResourceID = 3;
 * @return {string}
 */
proto.xcommon.UploadDocumentResp.prototype.getResourceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UploadDocumentResp} returns this
 */
proto.xcommon.UploadDocumentResp.prototype.setResourceid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.UploadDocumentResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.UploadDocumentResp} returns this
 */
proto.xcommon.UploadDocumentResp.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DownloadDocumentReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DownloadDocumentReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DownloadDocumentReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadDocumentReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    resourceid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    usemark: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DownloadDocumentReq}
 */
proto.xcommon.DownloadDocumentReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DownloadDocumentReq;
  return proto.xcommon.DownloadDocumentReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DownloadDocumentReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DownloadDocumentReq}
 */
proto.xcommon.DownloadDocumentReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setResourceid(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.ResourceUseMark} */ (reader.readEnum());
      msg.setUsemark(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DownloadDocumentReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DownloadDocumentReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DownloadDocumentReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadDocumentReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getResourceid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getUsemark();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.DownloadDocumentReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.DownloadDocumentReq} returns this
*/
proto.xcommon.DownloadDocumentReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DownloadDocumentReq} returns this
 */
proto.xcommon.DownloadDocumentReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownloadDocumentReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 ResourceID = 2;
 * @return {string}
 */
proto.xcommon.DownloadDocumentReq.prototype.getResourceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DownloadDocumentReq} returns this
 */
proto.xcommon.DownloadDocumentReq.prototype.setResourceid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional ResourceUseMark UseMark = 3;
 * @return {!proto.xcommon.ResourceUseMark}
 */
proto.xcommon.DownloadDocumentReq.prototype.getUsemark = function() {
  return /** @type {!proto.xcommon.ResourceUseMark} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.ResourceUseMark} value
 * @return {!proto.xcommon.DownloadDocumentReq} returns this
 */
proto.xcommon.DownloadDocumentReq.prototype.setUsemark = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DownloadDocumentResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DownloadDocumentResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DownloadDocumentResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadDocumentResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    mediaheader: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mediabody: msg.getMediabody_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DownloadDocumentResp}
 */
proto.xcommon.DownloadDocumentResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DownloadDocumentResp;
  return proto.xcommon.DownloadDocumentResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DownloadDocumentResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DownloadDocumentResp}
 */
proto.xcommon.DownloadDocumentResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediaheader(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMediabody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DownloadDocumentResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DownloadDocumentResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DownloadDocumentResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DownloadDocumentResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMediaheader();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMediabody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.DownloadDocumentResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.DownloadDocumentResp} returns this
*/
proto.xcommon.DownloadDocumentResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.DownloadDocumentResp} returns this
 */
proto.xcommon.DownloadDocumentResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.DownloadDocumentResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string MediaHeader = 2;
 * @return {string}
 */
proto.xcommon.DownloadDocumentResp.prototype.getMediaheader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DownloadDocumentResp} returns this
 */
proto.xcommon.DownloadDocumentResp.prototype.setMediaheader = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes MediaBody = 3;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.DownloadDocumentResp.prototype.getMediabody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes MediaBody = 3;
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {string}
 */
proto.xcommon.DownloadDocumentResp.prototype.getMediabody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMediabody()));
};


/**
 * optional bytes MediaBody = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMediabody()`
 * @return {!Uint8Array}
 */
proto.xcommon.DownloadDocumentResp.prototype.getMediabody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMediabody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.xcommon.DownloadDocumentResp} returns this
 */
proto.xcommon.DownloadDocumentResp.prototype.setMediabody = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCustomerOtherMobileReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCustomerOtherMobileReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerOtherMobileReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    accountid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    identity: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCustomerOtherMobileReq}
 */
proto.xcommon.GetCustomerOtherMobileReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCustomerOtherMobileReq;
  return proto.xcommon.GetCustomerOtherMobileReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCustomerOtherMobileReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCustomerOtherMobileReq}
 */
proto.xcommon.GetCustomerOtherMobileReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCustomerOtherMobileReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCustomerOtherMobileReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerOtherMobileReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getIdentity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetCustomerOtherMobileReq} returns this
*/
proto.xcommon.GetCustomerOtherMobileReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerOtherMobileReq} returns this
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCustomerOtherMobileReq} returns this
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCustomerOtherMobileReq} returns this
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 AccountId = 4;
 * @return {string}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCustomerOtherMobileReq} returns this
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string Identity = 5;
 * @return {string}
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.getIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCustomerOtherMobileReq} returns this
 */
proto.xcommon.GetCustomerOtherMobileReq.prototype.setIdentity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetCustomerOtherMobileResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCustomerOtherMobileResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCustomerOtherMobileResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerOtherMobileResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    mobilesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCustomerOtherMobileResp}
 */
proto.xcommon.GetCustomerOtherMobileResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCustomerOtherMobileResp;
  return proto.xcommon.GetCustomerOtherMobileResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCustomerOtherMobileResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCustomerOtherMobileResp}
 */
proto.xcommon.GetCustomerOtherMobileResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMobiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCustomerOtherMobileResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCustomerOtherMobileResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCustomerOtherMobileResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMobilesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetCustomerOtherMobileResp} returns this
*/
proto.xcommon.GetCustomerOtherMobileResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCustomerOtherMobileResp} returns this
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string Mobiles = 2;
 * @return {!Array<string>}
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.getMobilesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.GetCustomerOtherMobileResp} returns this
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.setMobilesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.GetCustomerOtherMobileResp} returns this
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.addMobiles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetCustomerOtherMobileResp} returns this
 */
proto.xcommon.GetCustomerOtherMobileResp.prototype.clearMobilesList = function() {
  return this.setMobilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCouponTaskIdMapReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCouponTaskIdMapReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCouponTaskIdMapReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCouponTaskIdMapReq}
 */
proto.xcommon.GetCouponTaskIdMapReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCouponTaskIdMapReq;
  return proto.xcommon.GetCouponTaskIdMapReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCouponTaskIdMapReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCouponTaskIdMapReq}
 */
proto.xcommon.GetCouponTaskIdMapReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCouponTaskIdMapReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCouponTaskIdMapReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCouponTaskIdMapReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetCouponTaskIdMapReq} returns this
*/
proto.xcommon.GetCouponTaskIdMapReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCouponTaskIdMapReq} returns this
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetCouponTaskIdMapReq} returns this
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AccountId = 3;
 * @return {string}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCouponTaskIdMapReq} returns this
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCouponTaskIdMapReq} returns this
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetCouponTaskIdMapReq} returns this
 */
proto.xcommon.GetCouponTaskIdMapReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetCouponTaskIdMapResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetCouponTaskIdMapResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCouponTaskIdMapResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    coupontaskidmapMap: (f = msg.getCoupontaskidmapMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetCouponTaskIdMapResp}
 */
proto.xcommon.GetCouponTaskIdMapResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetCouponTaskIdMapResp;
  return proto.xcommon.GetCouponTaskIdMapResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetCouponTaskIdMapResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetCouponTaskIdMapResp}
 */
proto.xcommon.GetCouponTaskIdMapResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getCoupontaskidmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetCouponTaskIdMapResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetCouponTaskIdMapResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetCouponTaskIdMapResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getCoupontaskidmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetCouponTaskIdMapResp} returns this
*/
proto.xcommon.GetCouponTaskIdMapResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetCouponTaskIdMapResp} returns this
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, string> CouponTaskIdMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.getCoupontaskidmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetCouponTaskIdMapResp} returns this
 */
proto.xcommon.GetCouponTaskIdMapResp.prototype.clearCoupontaskidmapMap = function() {
  this.getCoupontaskidmapMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SendCouponByTaskIdReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SendCouponByTaskIdReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendCouponByTaskIdReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    couponid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    ticketid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SendCouponByTaskIdReq}
 */
proto.xcommon.SendCouponByTaskIdReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SendCouponByTaskIdReq;
  return proto.xcommon.SendCouponByTaskIdReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SendCouponByTaskIdReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SendCouponByTaskIdReq}
 */
proto.xcommon.SendCouponByTaskIdReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCouponid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SendCouponByTaskIdReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SendCouponByTaskIdReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendCouponByTaskIdReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getCouponid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
*/
proto.xcommon.SendCouponByTaskIdReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 AccountId = 3;
 * @return {string}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int64 CouponId = 5;
 * @return {string}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getCouponid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.setCouponid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int64 TicketId = 6;
 * @return {number}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string AppName = 7;
 * @return {string}
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.SendCouponByTaskIdReq} returns this
 */
proto.xcommon.SendCouponByTaskIdReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SendCouponByTaskIdResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SendCouponByTaskIdResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SendCouponByTaskIdResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendCouponByTaskIdResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SendCouponByTaskIdResp}
 */
proto.xcommon.SendCouponByTaskIdResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SendCouponByTaskIdResp;
  return proto.xcommon.SendCouponByTaskIdResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SendCouponByTaskIdResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SendCouponByTaskIdResp}
 */
proto.xcommon.SendCouponByTaskIdResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SendCouponByTaskIdResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SendCouponByTaskIdResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SendCouponByTaskIdResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SendCouponByTaskIdResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SendCouponByTaskIdResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SendCouponByTaskIdResp} returns this
*/
proto.xcommon.SendCouponByTaskIdResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SendCouponByTaskIdResp} returns this
 */
proto.xcommon.SendCouponByTaskIdResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SendCouponByTaskIdResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CalcMarketPaymentCodeFeeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    marketpaymentList: jspb.Message.toObjectList(msg.getMarketpaymentList(),
    xcommon_core_pb.CalcMarketPaymentFeeParam.toObject, includeInstance),
    willrepayamount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CalcMarketPaymentCodeFeeReq;
  return proto.xcommon.CalcMarketPaymentCodeFeeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = new xcommon_core_pb.CalcMarketPaymentFeeParam;
      reader.readMessage(value,xcommon_core_pb.CalcMarketPaymentFeeParam.deserializeBinaryFromReader);
      msg.addMarketpayment(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWillrepayamount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CalcMarketPaymentCodeFeeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getMarketpaymentList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      xcommon_core_pb.CalcMarketPaymentFeeParam.serializeBinaryToWriter
    );
  }
  f = message.getWillrepayamount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
*/
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * repeated CalcMarketPaymentFeeParam MarketPayment = 4;
 * @return {!Array<!proto.xcommon.CalcMarketPaymentFeeParam>}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.getMarketpaymentList = function() {
  return /** @type{!Array<!proto.xcommon.CalcMarketPaymentFeeParam>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.CalcMarketPaymentFeeParam, 4));
};


/**
 * @param {!Array<!proto.xcommon.CalcMarketPaymentFeeParam>} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
*/
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.setMarketpaymentList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.CalcMarketPaymentFeeParam=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CalcMarketPaymentFeeParam}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.addMarketpayment = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.CalcMarketPaymentFeeParam, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.clearMarketpaymentList = function() {
  return this.setMarketpaymentList([]);
};


/**
 * optional int64 WillRepayAmount = 5;
 * @return {number}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.getWillrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.setWillrepayamount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeReq} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CalcMarketPaymentCodeFeeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    marketpaymentList: jspb.Message.toObjectList(msg.getMarketpaymentList(),
    xcommon_core_pb.CalcMarketPaymentFeeResult.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CalcMarketPaymentCodeFeeResp;
  return proto.xcommon.CalcMarketPaymentCodeFeeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 3:
      var value = new xcommon_core_pb.CalcMarketPaymentFeeResult;
      reader.readMessage(value,xcommon_core_pb.CalcMarketPaymentFeeResult.deserializeBinaryFromReader);
      msg.addMarketpayment(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CalcMarketPaymentCodeFeeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CalcMarketPaymentCodeFeeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getMarketpaymentList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_core_pb.CalcMarketPaymentFeeResult.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp} returns this
*/
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated CalcMarketPaymentFeeResult MarketPayment = 3;
 * @return {!Array<!proto.xcommon.CalcMarketPaymentFeeResult>}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.getMarketpaymentList = function() {
  return /** @type{!Array<!proto.xcommon.CalcMarketPaymentFeeResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_core_pb.CalcMarketPaymentFeeResult, 3));
};


/**
 * @param {!Array<!proto.xcommon.CalcMarketPaymentFeeResult>} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp} returns this
*/
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.setMarketpaymentList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.CalcMarketPaymentFeeResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CalcMarketPaymentFeeResult}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.addMarketpayment = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.CalcMarketPaymentFeeResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.clearMarketpaymentList = function() {
  return this.setMarketpaymentList([]);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CalcMarketPaymentCodeFeeResp} returns this
 */
proto.xcommon.CalcMarketPaymentCodeFeeResp.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVoipQICaseListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVoipQICaseListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    callrecordid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    caseid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, ""),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 9, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    starttimerange: jspb.Message.getFieldWithDefault(msg, 11, ""),
    closetimerange: jspb.Message.getFieldWithDefault(msg, 12, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 13, ""),
    aitimerange: jspb.Message.getFieldWithDefault(msg, 14, ""),
    aiscorerange: jspb.Message.getFieldWithDefault(msg, 15, ""),
    humantimerange: jspb.Message.getFieldWithDefault(msg, 16, ""),
    humanscorerange: jspb.Message.getFieldWithDefault(msg, 17, ""),
    aistatus: jspb.Message.getFieldWithDefault(msg, 18, 0),
    durationrange: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVoipQICaseListReq}
 */
proto.xcommon.GetVoipQICaseListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVoipQICaseListReq;
  return proto.xcommon.GetVoipQICaseListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVoipQICaseListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVoipQICaseListReq}
 */
proto.xcommon.GetVoipQICaseListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setCallrecordid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttimerange(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosetimerange(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAitimerange(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiscorerange(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setHumantimerange(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setHumanscorerange(value);
      break;
    case 18:
      var value = /** @type {!proto.xcommon.AiStatusEnum} */ (reader.readEnum());
      msg.setAistatus(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setDurationrange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVoipQICaseListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVoipQICaseListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getCallrecordid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStarttimerange();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getClosetimerange();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAitimerange();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAiscorerange();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getHumantimerange();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getHumanscorerange();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getAistatus();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getDurationrange();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
*/
proto.xcommon.GetVoipQICaseListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
*/
proto.xcommon.GetVoipQICaseListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int64 CallRecordId = 6;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getCallrecordid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setCallrecordid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional int64 CaseId = 7;
 * @return {number}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string Status = 8;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CreateTimeRange = 9;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setCreatetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CompleteTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setCompletetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string StartTimeRange = 11;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getStarttimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setStarttimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string CloseTimeRange = 12;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getClosetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setClosetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string AssignTimeRange = 13;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setAssigntimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string AiTimeRange = 14;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getAitimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setAitimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string AiScoreRange = 15;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getAiscorerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setAiscorerange = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string HumanTimeRange = 16;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getHumantimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setHumantimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string HumanScoreRange = 17;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getHumanscorerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setHumanscorerange = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional AiStatusEnum AiStatus = 18;
 * @return {!proto.xcommon.AiStatusEnum}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getAistatus = function() {
  return /** @type {!proto.xcommon.AiStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.xcommon.AiStatusEnum} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setAistatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional string DurationRange = 19;
 * @return {string}
 */
proto.xcommon.GetVoipQICaseListReq.prototype.getDurationrange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetVoipQICaseListReq} returns this
 */
proto.xcommon.GetVoipQICaseListReq.prototype.setDurationrange = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVoipQICaseListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVoipQICaseListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVoipQICaseListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_ticket_pb.VoipQITicketBackend.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVoipQICaseListResp}
 */
proto.xcommon.GetVoipQICaseListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVoipQICaseListResp;
  return proto.xcommon.GetVoipQICaseListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVoipQICaseListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVoipQICaseListResp}
 */
proto.xcommon.GetVoipQICaseListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_ticket_pb.VoipQITicketBackend;
      reader.readMessage(value,xcommon_ticket_pb.VoipQITicketBackend.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVoipQICaseListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVoipQICaseListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_ticket_pb.VoipQITicketBackend.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseListResp} returns this
*/
proto.xcommon.GetVoipQICaseListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseListResp} returns this
 */
proto.xcommon.GetVoipQICaseListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseListResp} returns this
*/
proto.xcommon.GetVoipQICaseListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseListResp} returns this
 */
proto.xcommon.GetVoipQICaseListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated VoipQITicketBackend List = 3;
 * @return {!Array<!proto.xcommon.VoipQITicketBackend>}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.VoipQITicketBackend>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_ticket_pb.VoipQITicketBackend, 3));
};


/**
 * @param {!Array<!proto.xcommon.VoipQITicketBackend>} value
 * @return {!proto.xcommon.GetVoipQICaseListResp} returns this
*/
proto.xcommon.GetVoipQICaseListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.VoipQITicketBackend=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.VoipQITicketBackend}
 */
proto.xcommon.GetVoipQICaseListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.VoipQITicketBackend, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetVoipQICaseListResp} returns this
 */
proto.xcommon.GetVoipQICaseListResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVoipQICaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVoipQICaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVoipQICaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVoipQICaseReq}
 */
proto.xcommon.GetVoipQICaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVoipQICaseReq;
  return proto.xcommon.GetVoipQICaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVoipQICaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVoipQICaseReq}
 */
proto.xcommon.GetVoipQICaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVoipQICaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVoipQICaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVoipQICaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetVoipQICaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseReq} returns this
*/
proto.xcommon.GetVoipQICaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseReq} returns this
 */
proto.xcommon.GetVoipQICaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.GetVoipQICaseReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVoipQICaseReq} returns this
 */
proto.xcommon.GetVoipQICaseReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetVoipQICaseReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetVoipQICaseReq} returns this
 */
proto.xcommon.GetVoipQICaseReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetVoipQICaseResp.repeatedFields_ = [4,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetVoipQICaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetVoipQICaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetVoipQICaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    caseresult: (f = msg.getCaseresult()) && proto.xcommon.VoipQICaseData.toObject(includeInstance, f),
    dialinfo: (f = msg.getDialinfo()) && xcommon_dialer_pb.DialInfoResp.toObject(includeInstance, f),
    calltextList: jspb.Message.toObjectList(msg.getCalltextList(),
    xcommon_dialer_pb.AudioText.toObject, includeInstance),
    voipqiresultmapMap: (f = msg.getVoipqiresultmapMap()) ? f.toObject(includeInstance, undefined) : [],
    audiomarktextMap: (f = msg.getAudiomarktextMap()) ? f.toObject(includeInstance, proto.xcommon.AudioMarkTextList.toObject) : [],
    discardreasonList: jspb.Message.toObjectList(msg.getDiscardreasonList(),
    proto.xcommon.DiscardReason.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetVoipQICaseResp}
 */
proto.xcommon.GetVoipQICaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetVoipQICaseResp;
  return proto.xcommon.GetVoipQICaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetVoipQICaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetVoipQICaseResp}
 */
proto.xcommon.GetVoipQICaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.VoipQICaseData;
      reader.readMessage(value,proto.xcommon.VoipQICaseData.deserializeBinaryFromReader);
      msg.setCaseresult(value);
      break;
    case 3:
      var value = new xcommon_dialer_pb.DialInfoResp;
      reader.readMessage(value,xcommon_dialer_pb.DialInfoResp.deserializeBinaryFromReader);
      msg.setDialinfo(value);
      break;
    case 4:
      var value = new xcommon_dialer_pb.AudioText;
      reader.readMessage(value,xcommon_dialer_pb.AudioText.deserializeBinaryFromReader);
      msg.addCalltext(value);
      break;
    case 5:
      var value = msg.getVoipqiresultmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0, "");
         });
      break;
    case 6:
      var value = msg.getAudiomarktextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.xcommon.AudioMarkTextList.deserializeBinaryFromReader, 0, new proto.xcommon.AudioMarkTextList());
         });
      break;
    case 7:
      var value = new proto.xcommon.DiscardReason;
      reader.readMessage(value,proto.xcommon.DiscardReason.deserializeBinaryFromReader);
      msg.addDiscardreason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetVoipQICaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetVoipQICaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetVoipQICaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetVoipQICaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getCaseresult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.VoipQICaseData.serializeBinaryToWriter
    );
  }
  f = message.getDialinfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_dialer_pb.DialInfoResp.serializeBinaryToWriter
    );
  }
  f = message.getCalltextList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      xcommon_dialer_pb.AudioText.serializeBinaryToWriter
    );
  }
  f = message.getVoipqiresultmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAudiomarktextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.AudioMarkTextList.serializeBinaryToWriter);
  }
  f = message.getDiscardreasonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.xcommon.DiscardReason.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
*/
proto.xcommon.GetVoipQICaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional VoipQICaseData CaseResult = 2;
 * @return {?proto.xcommon.VoipQICaseData}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getCaseresult = function() {
  return /** @type{?proto.xcommon.VoipQICaseData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.VoipQICaseData, 2));
};


/**
 * @param {?proto.xcommon.VoipQICaseData|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
*/
proto.xcommon.GetVoipQICaseResp.prototype.setCaseresult = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearCaseresult = function() {
  return this.setCaseresult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseResp.prototype.hasCaseresult = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DialInfoResp DialInfo = 3;
 * @return {?proto.xcommon.DialInfoResp}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getDialinfo = function() {
  return /** @type{?proto.xcommon.DialInfoResp} */ (
    jspb.Message.getWrapperField(this, xcommon_dialer_pb.DialInfoResp, 3));
};


/**
 * @param {?proto.xcommon.DialInfoResp|undefined} value
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
*/
proto.xcommon.GetVoipQICaseResp.prototype.setDialinfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearDialinfo = function() {
  return this.setDialinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetVoipQICaseResp.prototype.hasDialinfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated AudioText CallText = 4;
 * @return {!Array<!proto.xcommon.AudioText>}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getCalltextList = function() {
  return /** @type{!Array<!proto.xcommon.AudioText>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_dialer_pb.AudioText, 4));
};


/**
 * @param {!Array<!proto.xcommon.AudioText>} value
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
*/
proto.xcommon.GetVoipQICaseResp.prototype.setCalltextList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.AudioText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioText}
 */
proto.xcommon.GetVoipQICaseResp.prototype.addCalltext = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.AudioText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearCalltextList = function() {
  return this.setCalltextList([]);
};


/**
 * map<int32, string> VoipQIResultMap = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getVoipqiresultmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearVoipqiresultmapMap = function() {
  this.getVoipqiresultmapMap().clear();
  return this;
};


/**
 * map<int32, AudioMarkTextList> AudioMarkText = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.AudioMarkTextList>}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getAudiomarktextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.AudioMarkTextList>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.xcommon.AudioMarkTextList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearAudiomarktextMap = function() {
  this.getAudiomarktextMap().clear();
  return this;
};


/**
 * repeated DiscardReason DiscardReason = 7;
 * @return {!Array<!proto.xcommon.DiscardReason>}
 */
proto.xcommon.GetVoipQICaseResp.prototype.getDiscardreasonList = function() {
  return /** @type{!Array<!proto.xcommon.DiscardReason>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.DiscardReason, 7));
};


/**
 * @param {!Array<!proto.xcommon.DiscardReason>} value
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
*/
proto.xcommon.GetVoipQICaseResp.prototype.setDiscardreasonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.DiscardReason=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.DiscardReason}
 */
proto.xcommon.GetVoipQICaseResp.prototype.addDiscardreason = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.DiscardReason, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetVoipQICaseResp} returns this
 */
proto.xcommon.GetVoipQICaseResp.prototype.clearDiscardreasonList = function() {
  return this.setDiscardreasonList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.DiscardReason.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.DiscardReason.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.DiscardReason} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DiscardReason.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.DiscardReason}
 */
proto.xcommon.DiscardReason.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.DiscardReason;
  return proto.xcommon.DiscardReason.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.DiscardReason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.DiscardReason}
 */
proto.xcommon.DiscardReason.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.DiscardReason.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.DiscardReason.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.DiscardReason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.DiscardReason.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 Id = 1;
 * @return {number}
 */
proto.xcommon.DiscardReason.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.DiscardReason} returns this
 */
proto.xcommon.DiscardReason.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.DiscardReason.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.DiscardReason} returns this
 */
proto.xcommon.DiscardReason.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveVoipQICaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveVoipQICaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveVoipQICaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveVoipQICaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.xcommon.VoipQICaseData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveVoipQICaseReq}
 */
proto.xcommon.SaveVoipQICaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveVoipQICaseReq;
  return proto.xcommon.SaveVoipQICaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveVoipQICaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveVoipQICaseReq}
 */
proto.xcommon.SaveVoipQICaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new proto.xcommon.VoipQICaseData;
      reader.readMessage(value,proto.xcommon.VoipQICaseData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveVoipQICaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveVoipQICaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveVoipQICaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveVoipQICaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.VoipQICaseData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveVoipQICaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveVoipQICaseReq} returns this
*/
proto.xcommon.SaveVoipQICaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveVoipQICaseReq} returns this
 */
proto.xcommon.SaveVoipQICaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveVoipQICaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional VoipQICaseData Data = 2;
 * @return {?proto.xcommon.VoipQICaseData}
 */
proto.xcommon.SaveVoipQICaseReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.VoipQICaseData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.VoipQICaseData, 2));
};


/**
 * @param {?proto.xcommon.VoipQICaseData|undefined} value
 * @return {!proto.xcommon.SaveVoipQICaseReq} returns this
*/
proto.xcommon.SaveVoipQICaseReq.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveVoipQICaseReq} returns this
 */
proto.xcommon.SaveVoipQICaseReq.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveVoipQICaseReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.VoipQICaseData.repeatedFields_ = [7,12,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.VoipQICaseData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.VoipQICaseData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.VoipQICaseData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VoipQICaseData.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    calltype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    result: jspb.Message.getFieldWithDefault(msg, 4, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    marktextList: jspb.Message.toObjectList(msg.getMarktextList(),
    xcommon_dialer_pb.AudioMarkText.toObject, includeInstance),
    caselevel: jspb.Message.getFieldWithDefault(msg, 8, ""),
    aiscore: jspb.Message.getFieldWithDefault(msg, 9, 0),
    humanscore: jspb.Message.getFieldWithDefault(msg, 10, 0),
    finalscore: jspb.Message.getFieldWithDefault(msg, 11, 0),
    airesultList: jspb.Message.toObjectList(msg.getAiresultList(),
    xcommon_ticket_pb.QualityReport.toObject, includeInstance),
    humanresultList: jspb.Message.toObjectList(msg.getHumanresultList(),
    xcommon_ticket_pb.QualityReport.toObject, includeInstance),
    aistatus: jspb.Message.getFieldWithDefault(msg, 14, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 15, "0"),
    urgeusername: jspb.Message.getFieldWithDefault(msg, 16, ""),
    caseid: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.VoipQICaseData}
 */
proto.xcommon.VoipQICaseData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.VoipQICaseData;
  return proto.xcommon.VoipQICaseData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.VoipQICaseData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.VoipQICaseData}
 */
proto.xcommon.VoipQICaseData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.CallType} */ (reader.readEnum());
      msg.setCalltype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 7:
      var value = new xcommon_dialer_pb.AudioMarkText;
      reader.readMessage(value,xcommon_dialer_pb.AudioMarkText.deserializeBinaryFromReader);
      msg.addMarktext(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiscore(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHumanscore(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFinalscore(value);
      break;
    case 12:
      var value = new xcommon_ticket_pb.QualityReport;
      reader.readMessage(value,xcommon_ticket_pb.QualityReport.deserializeBinaryFromReader);
      msg.addAiresult(value);
      break;
    case 13:
      var value = new xcommon_ticket_pb.QualityReport;
      reader.readMessage(value,xcommon_ticket_pb.QualityReport.deserializeBinaryFromReader);
      msg.addHumanresult(value);
      break;
    case 14:
      var value = /** @type {!proto.xcommon.AiStatusEnum} */ (reader.readEnum());
      msg.setAistatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrgeusername(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.VoipQICaseData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.VoipQICaseData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.VoipQICaseData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.VoipQICaseData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCalltype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMarktextList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      xcommon_dialer_pb.AudioMarkText.serializeBinaryToWriter
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAiscore();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getHumanscore();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getFinalscore();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getAiresultList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      xcommon_ticket_pb.QualityReport.serializeBinaryToWriter
    );
  }
  f = message.getHumanresultList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      xcommon_ticket_pb.QualityReport.serializeBinaryToWriter
    );
  }
  f = message.getAistatus();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      15,
      f
    );
  }
  f = message.getUrgeusername();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
};


/**
 * optional int32 ItemId = 1;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional CallType CallType = 3;
 * @return {!proto.xcommon.CallType}
 */
proto.xcommon.VoipQICaseData.prototype.getCalltype = function() {
  return /** @type {!proto.xcommon.CallType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.CallType} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setCalltype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Result = 4;
 * @return {string}
 */
proto.xcommon.VoipQICaseData.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Comment = 5;
 * @return {string}
 */
proto.xcommon.VoipQICaseData.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 Status = 6;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated AudioMarkText MarkText = 7;
 * @return {!Array<!proto.xcommon.AudioMarkText>}
 */
proto.xcommon.VoipQICaseData.prototype.getMarktextList = function() {
  return /** @type{!Array<!proto.xcommon.AudioMarkText>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_dialer_pb.AudioMarkText, 7));
};


/**
 * @param {!Array<!proto.xcommon.AudioMarkText>} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
*/
proto.xcommon.VoipQICaseData.prototype.setMarktextList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.AudioMarkText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.AudioMarkText}
 */
proto.xcommon.VoipQICaseData.prototype.addMarktext = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.AudioMarkText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.clearMarktextList = function() {
  return this.setMarktextList([]);
};


/**
 * optional string CaseLevel = 8;
 * @return {string}
 */
proto.xcommon.VoipQICaseData.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 AIScore = 9;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getAiscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setAiscore = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 HumanScore = 10;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getHumanscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setHumanscore = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 FinalScore = 11;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getFinalscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setFinalscore = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * repeated QualityReport AiResult = 12;
 * @return {!Array<!proto.xcommon.QualityReport>}
 */
proto.xcommon.VoipQICaseData.prototype.getAiresultList = function() {
  return /** @type{!Array<!proto.xcommon.QualityReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_ticket_pb.QualityReport, 12));
};


/**
 * @param {!Array<!proto.xcommon.QualityReport>} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
*/
proto.xcommon.VoipQICaseData.prototype.setAiresultList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.xcommon.QualityReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QualityReport}
 */
proto.xcommon.VoipQICaseData.prototype.addAiresult = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.xcommon.QualityReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.clearAiresultList = function() {
  return this.setAiresultList([]);
};


/**
 * repeated QualityReport HumanResult = 13;
 * @return {!Array<!proto.xcommon.QualityReport>}
 */
proto.xcommon.VoipQICaseData.prototype.getHumanresultList = function() {
  return /** @type{!Array<!proto.xcommon.QualityReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_ticket_pb.QualityReport, 13));
};


/**
 * @param {!Array<!proto.xcommon.QualityReport>} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
*/
proto.xcommon.VoipQICaseData.prototype.setHumanresultList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.xcommon.QualityReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.QualityReport}
 */
proto.xcommon.VoipQICaseData.prototype.addHumanresult = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.xcommon.QualityReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.clearHumanresultList = function() {
  return this.setHumanresultList([]);
};


/**
 * optional AiStatusEnum AiStatus = 14;
 * @return {!proto.xcommon.AiStatusEnum}
 */
proto.xcommon.VoipQICaseData.prototype.getAistatus = function() {
  return /** @type {!proto.xcommon.AiStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.xcommon.AiStatusEnum} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setAistatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional int64 OrderId = 15;
 * @return {string}
 */
proto.xcommon.VoipQICaseData.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 15, value);
};


/**
 * optional string UrgeUserName = 16;
 * @return {string}
 */
proto.xcommon.VoipQICaseData.prototype.getUrgeusername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setUrgeusername = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 CaseId = 17;
 * @return {number}
 */
proto.xcommon.VoipQICaseData.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.VoipQICaseData} returns this
 */
proto.xcommon.VoipQICaseData.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveVoipQICaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveVoipQICaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveVoipQICaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveVoipQICaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveVoipQICaseResp}
 */
proto.xcommon.SaveVoipQICaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveVoipQICaseResp;
  return proto.xcommon.SaveVoipQICaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveVoipQICaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveVoipQICaseResp}
 */
proto.xcommon.SaveVoipQICaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveVoipQICaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveVoipQICaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveVoipQICaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveVoipQICaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveVoipQICaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveVoipQICaseResp} returns this
*/
proto.xcommon.SaveVoipQICaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveVoipQICaseResp} returns this
 */
proto.xcommon.SaveVoipQICaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveVoipQICaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceCreditCardFeeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceCreditCardFeeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceCreditCardFeeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    cardfee: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceCreditCardFeeReq}
 */
proto.xcommon.ReduceCreditCardFeeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceCreditCardFeeReq;
  return proto.xcommon.ReduceCreditCardFeeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceCreditCardFeeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceCreditCardFeeReq}
 */
proto.xcommon.ReduceCreditCardFeeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardfee(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceCreditCardFeeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceCreditCardFeeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceCreditCardFeeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCardfee();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ReduceCreditCardFeeReq} returns this
*/
proto.xcommon.ReduceCreditCardFeeReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ReduceCreditCardFeeReq} returns this
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ReduceCreditCardFeeReq} returns this
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 CardFee = 4;
 * @return {number}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.getCardfee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ReduceCreditCardFeeReq} returns this
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.setCardfee = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ReduceCreditCardFeeReq} returns this
 */
proto.xcommon.ReduceCreditCardFeeReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceCreditCardFeeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceCreditCardFeeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceCreditCardFeeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceCreditCardFeeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceCreditCardFeeResp}
 */
proto.xcommon.ReduceCreditCardFeeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceCreditCardFeeResp;
  return proto.xcommon.ReduceCreditCardFeeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceCreditCardFeeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceCreditCardFeeResp}
 */
proto.xcommon.ReduceCreditCardFeeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceCreditCardFeeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceCreditCardFeeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceCreditCardFeeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceCreditCardFeeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ReduceCreditCardFeeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ReduceCreditCardFeeResp} returns this
*/
proto.xcommon.ReduceCreditCardFeeResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ReduceCreditCardFeeResp} returns this
 */
proto.xcommon.ReduceCreditCardFeeResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceCreditCardFeeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayReportInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayReportInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayReportInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayReportInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayReportInfoReq}
 */
proto.xcommon.GetRepayReportInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayReportInfoReq;
  return proto.xcommon.GetRepayReportInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayReportInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayReportInfoReq}
 */
proto.xcommon.GetRepayReportInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayReportInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayReportInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayReportInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayReportInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRepayReportInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetRepayReportInfoReq} returns this
*/
proto.xcommon.GetRepayReportInfoReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRepayReportInfoReq} returns this
 */
proto.xcommon.GetRepayReportInfoReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayReportInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.GetRepayReportInfoReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRepayReportInfoReq} returns this
 */
proto.xcommon.GetRepayReportInfoReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRepayReportInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRepayReportInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRepayReportInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayReportInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    repaychannelmapMap: (f = msg.getRepaychannelmapMap()) ? f.toObject(includeInstance, undefined) : [],
    repayreportstatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRepayReportInfoResp}
 */
proto.xcommon.GetRepayReportInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRepayReportInfoResp;
  return proto.xcommon.GetRepayReportInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRepayReportInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRepayReportInfoResp}
 */
proto.xcommon.GetRepayReportInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getRepaychannelmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt64, null, "", 0);
         });
      break;
    case 3:
      var value = /** @type {!proto.xcommon.ReportStatus} */ (reader.readEnum());
      msg.setRepayreportstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRepayReportInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRepayReportInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRepayReportInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRepayReportInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getRepaychannelmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt64);
  }
  f = message.getRepayreportstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRepayReportInfoResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetRepayReportInfoResp} returns this
*/
proto.xcommon.GetRepayReportInfoResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRepayReportInfoResp} returns this
 */
proto.xcommon.GetRepayReportInfoResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRepayReportInfoResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, int64> RepayChannelMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.xcommon.GetRepayReportInfoResp.prototype.getRepaychannelmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.GetRepayReportInfoResp} returns this
 */
proto.xcommon.GetRepayReportInfoResp.prototype.clearRepaychannelmapMap = function() {
  this.getRepaychannelmapMap().clear();
  return this;
};


/**
 * optional ReportStatus RepayReportStatus = 3;
 * @return {!proto.xcommon.ReportStatus}
 */
proto.xcommon.GetRepayReportInfoResp.prototype.getRepayreportstatus = function() {
  return /** @type {!proto.xcommon.ReportStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.ReportStatus} value
 * @return {!proto.xcommon.GetRepayReportInfoResp} returns this
 */
proto.xcommon.GetRepayReportInfoResp.prototype.setRepayreportstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveWhatsappFlagReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveWhatsappFlagReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveWhatsappFlagReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    phoneobject: jspb.Message.getFieldWithDefault(msg, 4, 0),
    havewhatsapp: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveWhatsappFlagReq}
 */
proto.xcommon.SaveWhatsappFlagReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveWhatsappFlagReq;
  return proto.xcommon.SaveWhatsappFlagReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveWhatsappFlagReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveWhatsappFlagReq}
 */
proto.xcommon.SaveWhatsappFlagReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPhoneobject(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHavewhatsapp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveWhatsappFlagReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveWhatsappFlagReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveWhatsappFlagReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPhoneobject();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getHavewhatsapp();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveWhatsappFlagReq} returns this
*/
proto.xcommon.SaveWhatsappFlagReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveWhatsappFlagReq} returns this
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 ItemId = 2;
 * @return {number}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveWhatsappFlagReq} returns this
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 TicketId = 3;
 * @return {number}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveWhatsappFlagReq} returns this
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 PhoneObject = 4;
 * @return {number}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.getPhoneobject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveWhatsappFlagReq} returns this
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.setPhoneobject = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 HaveWhatsapp = 5;
 * @return {number}
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.getHavewhatsapp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.SaveWhatsappFlagReq} returns this
 */
proto.xcommon.SaveWhatsappFlagReq.prototype.setHavewhatsapp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveWhatsappFlagResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveWhatsappFlagResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveWhatsappFlagResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveWhatsappFlagResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveWhatsappFlagResp}
 */
proto.xcommon.SaveWhatsappFlagResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveWhatsappFlagResp;
  return proto.xcommon.SaveWhatsappFlagResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveWhatsappFlagResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveWhatsappFlagResp}
 */
proto.xcommon.SaveWhatsappFlagResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveWhatsappFlagResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveWhatsappFlagResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveWhatsappFlagResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveWhatsappFlagResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveWhatsappFlagResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveWhatsappFlagResp} returns this
*/
proto.xcommon.SaveWhatsappFlagResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveWhatsappFlagResp} returns this
 */
proto.xcommon.SaveWhatsappFlagResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveWhatsappFlagResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ApplyFrozenInterestReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ApplyFrozenInterestReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ApplyFrozenInterestReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ApplyFrozenInterestReq}
 */
proto.xcommon.ApplyFrozenInterestReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ApplyFrozenInterestReq;
  return proto.xcommon.ApplyFrozenInterestReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ApplyFrozenInterestReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ApplyFrozenInterestReq}
 */
proto.xcommon.ApplyFrozenInterestReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ApplyFrozenInterestReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ApplyFrozenInterestReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ApplyFrozenInterestReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ApplyFrozenInterestReq} returns this
*/
proto.xcommon.ApplyFrozenInterestReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ApplyFrozenInterestReq} returns this
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ApplyFrozenInterestReq} returns this
 */
proto.xcommon.ApplyFrozenInterestReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ApplyFrozenInterestResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ApplyFrozenInterestResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ApplyFrozenInterestResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ApplyFrozenInterestResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ApplyFrozenInterestResp}
 */
proto.xcommon.ApplyFrozenInterestResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ApplyFrozenInterestResp;
  return proto.xcommon.ApplyFrozenInterestResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ApplyFrozenInterestResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ApplyFrozenInterestResp}
 */
proto.xcommon.ApplyFrozenInterestResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ApplyFrozenInterestResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ApplyFrozenInterestResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ApplyFrozenInterestResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ApplyFrozenInterestResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ApplyFrozenInterestResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ApplyFrozenInterestResp} returns this
*/
proto.xcommon.ApplyFrozenInterestResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ApplyFrozenInterestResp} returns this
 */
proto.xcommon.ApplyFrozenInterestResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ApplyFrozenInterestResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRobotCorpusMarkCaseListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    audioid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    caseid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    status: jspb.Message.getFieldWithDefault(msg, 9, ""),
    createtimerange: jspb.Message.getFieldWithDefault(msg, 10, ""),
    completetimerange: jspb.Message.getFieldWithDefault(msg, 11, ""),
    starttimerange: jspb.Message.getFieldWithDefault(msg, 12, ""),
    closetimerange: jspb.Message.getFieldWithDefault(msg, 13, ""),
    assigntimerange: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRobotCorpusMarkCaseListReq;
  return proto.xcommon.GetRobotCorpusMarkCaseListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAudioid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetimerange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletetimerange(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttimerange(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosetimerange(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigntimerange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRobotCorpusMarkCaseListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      5,
      f
    );
  }
  f = message.getAudioid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCreatetimerange();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCompletetimerange();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStarttimerange();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getClosetimerange();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAssigntimerange();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 TicketId = 4;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OrderId = 5;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional int64 AudioId = 6;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getAudioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setAudioid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional int64 CaseId = 8;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string Status = 9;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CreateTimeRange = 10;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getCreatetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setCreatetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string CompleteTimeRange = 11;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getCompletetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setCompletetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string StartTimeRange = 12;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getStarttimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setStarttimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string CloseTimeRange = 13;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getClosetimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setClosetimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string AssignTimeRange = 14;
 * @return {string}
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.getAssigntimerange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListReq.prototype.setAssigntimerange = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRobotCorpusMarkCaseListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    listList: jspb.Message.toObjectList(msg.getListList(),
    xcommon_ticket_pb.RobotCorpusMarkData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRobotCorpusMarkCaseListResp;
  return proto.xcommon.GetRobotCorpusMarkCaseListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new xcommon_ticket_pb.RobotCorpusMarkData;
      reader.readMessage(value,xcommon_ticket_pb.RobotCorpusMarkData.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRobotCorpusMarkCaseListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_ticket_pb.RobotCorpusMarkData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated RobotCorpusMarkData List = 3;
 * @return {!Array<!proto.xcommon.RobotCorpusMarkData>}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.RobotCorpusMarkData>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_ticket_pb.RobotCorpusMarkData, 3));
};


/**
 * @param {!Array<!proto.xcommon.RobotCorpusMarkData>} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RobotCorpusMarkData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RobotCorpusMarkData}
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RobotCorpusMarkData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseListResp} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseListResp.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRobotCorpusMarkCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseReq}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRobotCorpusMarkCaseReq;
  return proto.xcommon.GetRobotCorpusMarkCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseReq}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRobotCorpusMarkCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseReq} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 ItemId = 3;
 * @return {number}
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseReq} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetRobotCorpusMarkCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    dialinfo: (f = msg.getDialinfo()) && xcommon_dialer_pb.DialInfoResp.toObject(includeInstance, f),
    data: (f = msg.getData()) && xcommon_ticket_pb.RobotCorpusMarkData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetRobotCorpusMarkCaseResp;
  return proto.xcommon.GetRobotCorpusMarkCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_dialer_pb.DialInfoResp;
      reader.readMessage(value,xcommon_dialer_pb.DialInfoResp.deserializeBinaryFromReader);
      msg.setDialinfo(value);
      break;
    case 3:
      var value = new xcommon_ticket_pb.RobotCorpusMarkData;
      reader.readMessage(value,xcommon_ticket_pb.RobotCorpusMarkData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetRobotCorpusMarkCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetRobotCorpusMarkCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDialinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_dialer_pb.DialInfoResp.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_ticket_pb.RobotCorpusMarkData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DialInfoResp DialInfo = 2;
 * @return {?proto.xcommon.DialInfoResp}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.getDialinfo = function() {
  return /** @type{?proto.xcommon.DialInfoResp} */ (
    jspb.Message.getWrapperField(this, xcommon_dialer_pb.DialInfoResp, 2));
};


/**
 * @param {?proto.xcommon.DialInfoResp|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.setDialinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.clearDialinfo = function() {
  return this.setDialinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.hasDialinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RobotCorpusMarkData Data = 3;
 * @return {?proto.xcommon.RobotCorpusMarkData}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.RobotCorpusMarkData} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.RobotCorpusMarkData, 3));
};


/**
 * @param {?proto.xcommon.RobotCorpusMarkData|undefined} value
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp} returns this
*/
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetRobotCorpusMarkCaseResp} returns this
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetRobotCorpusMarkCaseResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveRobotCorpusMarkCaseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    data: (f = msg.getData()) && xcommon_ticket_pb.RobotCorpusMarkData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseReq}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveRobotCorpusMarkCaseReq;
  return proto.xcommon.SaveRobotCorpusMarkCaseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseReq}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_ticket_pb.RobotCorpusMarkData;
      reader.readMessage(value,xcommon_ticket_pb.RobotCorpusMarkData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveRobotCorpusMarkCaseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_ticket_pb.RobotCorpusMarkData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseReq} returns this
*/
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseReq} returns this
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RobotCorpusMarkData Data = 2;
 * @return {?proto.xcommon.RobotCorpusMarkData}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.getData = function() {
  return /** @type{?proto.xcommon.RobotCorpusMarkData} */ (
    jspb.Message.getWrapperField(this, xcommon_ticket_pb.RobotCorpusMarkData, 2));
};


/**
 * @param {?proto.xcommon.RobotCorpusMarkData|undefined} value
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseReq} returns this
*/
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseReq} returns this
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRobotCorpusMarkCaseReq.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SaveRobotCorpusMarkCaseResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseResp}
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SaveRobotCorpusMarkCaseResp;
  return proto.xcommon.SaveRobotCorpusMarkCaseResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseResp}
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SaveRobotCorpusMarkCaseResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SaveRobotCorpusMarkCaseResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseResp} returns this
*/
proto.xcommon.SaveRobotCorpusMarkCaseResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.SaveRobotCorpusMarkCaseResp} returns this
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SaveRobotCorpusMarkCaseResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CommonCollaborationNotifyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CommonCollaborationNotifyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CommonCollaborationNotifyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    notifybusinesstype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ticketid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    relatedid: jspb.Message.getFieldWithDefault(msg, 6, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CommonCollaborationNotifyReq}
 */
proto.xcommon.CommonCollaborationNotifyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CommonCollaborationNotifyReq;
  return proto.xcommon.CommonCollaborationNotifyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CommonCollaborationNotifyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CommonCollaborationNotifyReq}
 */
proto.xcommon.CommonCollaborationNotifyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.ManMachineCollaborationNotify} */ (reader.readEnum());
      msg.setNotifybusinesstype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setTicketid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setRelatedid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CommonCollaborationNotifyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CommonCollaborationNotifyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CommonCollaborationNotifyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getNotifybusinesstype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTicketid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRelatedid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      6,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
*/
proto.xcommon.CommonCollaborationNotifyReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ManMachineCollaborationNotify NotifyBusinessType = 2;
 * @return {!proto.xcommon.ManMachineCollaborationNotify}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.getNotifybusinesstype = function() {
  return /** @type {!proto.xcommon.ManMachineCollaborationNotify} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.ManMachineCollaborationNotify} value
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.setNotifybusinesstype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 TicketId = 3;
 * @return {string}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.getTicketid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 OrderId = 4;
 * @return {string}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int64 ItemId = 5;
 * @return {number}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 RelatedId = 6;
 * @return {string}
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.getRelatedid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CommonCollaborationNotifyReq} returns this
 */
proto.xcommon.CommonCollaborationNotifyReq.prototype.setRelatedid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.WBSNotifyData.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WBSNotifyData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WBSNotifyData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WBSNotifyData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WBSNotifyData.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    itemid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    relatedid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    backlogcount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    gotourlpath: jspb.Message.getFieldWithDefault(msg, 6, ""),
    calltagsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    suppliertype: jspb.Message.getFieldWithDefault(msg, 8, ""),
    isdial: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WBSNotifyData}
 */
proto.xcommon.WBSNotifyData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WBSNotifyData;
  return proto.xcommon.WBSNotifyData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WBSNotifyData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WBSNotifyData}
 */
proto.xcommon.WBSNotifyData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setTicketid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setItemid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setRelatedid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBacklogcount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGotourlpath(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addCalltags(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuppliertype(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsdial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WBSNotifyData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WBSNotifyData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WBSNotifyData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WBSNotifyData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getItemid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRelatedid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      4,
      f
    );
  }
  f = message.getBacklogcount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getGotourlpath();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCalltagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getSuppliertype();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsdial();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional int64 TicketId = 1;
 * @return {string}
 */
proto.xcommon.WBSNotifyData.prototype.getTicketid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setTicketid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.WBSNotifyData.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 ItemId = 3;
 * @return {number}
 */
proto.xcommon.WBSNotifyData.prototype.getItemid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setItemid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 RelatedId = 4;
 * @return {string}
 */
proto.xcommon.WBSNotifyData.prototype.getRelatedid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setRelatedid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional int64 BacklogCount = 5;
 * @return {number}
 */
proto.xcommon.WBSNotifyData.prototype.getBacklogcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setBacklogcount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string GoToUrlPath = 6;
 * @return {string}
 */
proto.xcommon.WBSNotifyData.prototype.getGotourlpath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setGotourlpath = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string CallTags = 7;
 * @return {!Array<string>}
 */
proto.xcommon.WBSNotifyData.prototype.getCalltagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setCalltagsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.addCalltags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.clearCalltagsList = function() {
  return this.setCalltagsList([]);
};


/**
 * optional string SupplierType = 8;
 * @return {string}
 */
proto.xcommon.WBSNotifyData.prototype.getSuppliertype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setSuppliertype = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string IsDial = 9;
 * @return {string}
 */
proto.xcommon.WBSNotifyData.prototype.getIsdial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WBSNotifyData} returns this
 */
proto.xcommon.WBSNotifyData.prototype.setIsdial = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.WebSocketNotifyResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.WebSocketNotifyResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.WebSocketNotifyResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WebSocketNotifyResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    notifybusinesstype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    notifybusinesstypemsg: jspb.Message.getFieldWithDefault(msg, 4, ""),
    data: (f = msg.getData()) && proto.xcommon.WBSNotifyData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.WebSocketNotifyResp}
 */
proto.xcommon.WebSocketNotifyResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.WebSocketNotifyResp;
  return proto.xcommon.WebSocketNotifyResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.WebSocketNotifyResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.WebSocketNotifyResp}
 */
proto.xcommon.WebSocketNotifyResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.NotifyBusinessType} */ (reader.readEnum());
      msg.setNotifybusinesstype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotifybusinesstypemsg(value);
      break;
    case 5:
      var value = new proto.xcommon.WBSNotifyData;
      reader.readMessage(value,proto.xcommon.WBSNotifyData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.WebSocketNotifyResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.WebSocketNotifyResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.WebSocketNotifyResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.WebSocketNotifyResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getNotifybusinesstype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNotifybusinesstypemsg();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.WBSNotifyData.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.WebSocketNotifyResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.WebSocketNotifyResp} returns this
*/
proto.xcommon.WebSocketNotifyResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.WebSocketNotifyResp} returns this
 */
proto.xcommon.WebSocketNotifyResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WebSocketNotifyResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NotifyBusinessType NotifyBusinessType = 2;
 * @return {!proto.xcommon.NotifyBusinessType}
 */
proto.xcommon.WebSocketNotifyResp.prototype.getNotifybusinesstype = function() {
  return /** @type {!proto.xcommon.NotifyBusinessType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.NotifyBusinessType} value
 * @return {!proto.xcommon.WebSocketNotifyResp} returns this
 */
proto.xcommon.WebSocketNotifyResp.prototype.setNotifybusinesstype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string NotifyBusinessTypeMsg = 4;
 * @return {string}
 */
proto.xcommon.WebSocketNotifyResp.prototype.getNotifybusinesstypemsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.WebSocketNotifyResp} returns this
 */
proto.xcommon.WebSocketNotifyResp.prototype.setNotifybusinesstypemsg = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional WBSNotifyData Data = 5;
 * @return {?proto.xcommon.WBSNotifyData}
 */
proto.xcommon.WebSocketNotifyResp.prototype.getData = function() {
  return /** @type{?proto.xcommon.WBSNotifyData} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.WBSNotifyData, 5));
};


/**
 * @param {?proto.xcommon.WBSNotifyData|undefined} value
 * @return {!proto.xcommon.WebSocketNotifyResp} returns this
*/
proto.xcommon.WebSocketNotifyResp.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.WebSocketNotifyResp} returns this
 */
proto.xcommon.WebSocketNotifyResp.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.WebSocketNotifyResp.prototype.hasData = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreatePaymentLinkReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreatePaymentLinkReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentLinkReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    caselevel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    lang: jspb.Message.getFieldWithDefault(msg, 4, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreatePaymentLinkReq}
 */
proto.xcommon.CreatePaymentLinkReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreatePaymentLinkReq;
  return proto.xcommon.CreatePaymentLinkReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreatePaymentLinkReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreatePaymentLinkReq}
 */
proto.xcommon.CreatePaymentLinkReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaselevel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLang(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreatePaymentLinkReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreatePaymentLinkReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentLinkReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCaselevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getLang();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.CreatePaymentLinkReq} returns this
*/
proto.xcommon.CreatePaymentLinkReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CreatePaymentLinkReq} returns this
 */
proto.xcommon.CreatePaymentLinkReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string CaseLevel = 2;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.getCaselevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkReq} returns this
 */
proto.xcommon.CreatePaymentLinkReq.prototype.setCaselevel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 OrderId = 3;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkReq} returns this
 */
proto.xcommon.CreatePaymentLinkReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string Lang = 4;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.getLang = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkReq} returns this
 */
proto.xcommon.CreatePaymentLinkReq.prototype.setLang = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AppName = 5;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkReq} returns this
 */
proto.xcommon.CreatePaymentLinkReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreatePaymentLinkResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreatePaymentLinkResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentLinkResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    whatsappmsgmapMap: (f = msg.getWhatsappmsgmapMap()) ? f.toObject(includeInstance, undefined) : [],
    countrycode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    paymentlink: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreatePaymentLinkResp}
 */
proto.xcommon.CreatePaymentLinkResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreatePaymentLinkResp;
  return proto.xcommon.CreatePaymentLinkResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreatePaymentLinkResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreatePaymentLinkResp}
 */
proto.xcommon.CreatePaymentLinkResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getWhatsappmsgmapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrycode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentlink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreatePaymentLinkResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreatePaymentLinkResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreatePaymentLinkResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getWhatsappmsgmapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCountrycode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPaymentlink();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.CreatePaymentLinkResp} returns this
*/
proto.xcommon.CreatePaymentLinkResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.CreatePaymentLinkResp} returns this
 */
proto.xcommon.CreatePaymentLinkResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<string, string> WhatsAppMsgMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.getWhatsappmsgmapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.xcommon.CreatePaymentLinkResp} returns this
 */
proto.xcommon.CreatePaymentLinkResp.prototype.clearWhatsappmsgmapMap = function() {
  this.getWhatsappmsgmapMap().clear();
  return this;
};


/**
 * optional string CountryCode = 3;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.getCountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkResp} returns this
 */
proto.xcommon.CreatePaymentLinkResp.prototype.setCountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkResp} returns this
 */
proto.xcommon.CreatePaymentLinkResp.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PaymentLink = 6;
 * @return {string}
 */
proto.xcommon.CreatePaymentLinkResp.prototype.getPaymentlink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.CreatePaymentLinkResp} returns this
 */
proto.xcommon.CreatePaymentLinkResp.prototype.setPaymentlink = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOtherOrdersReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOtherOrdersReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOtherOrdersReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOtherOrdersReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOtherOrdersReq}
 */
proto.xcommon.GetOtherOrdersReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOtherOrdersReq;
  return proto.xcommon.GetOtherOrdersReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOtherOrdersReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOtherOrdersReq}
 */
proto.xcommon.GetOtherOrdersReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOtherOrdersReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOtherOrdersReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOtherOrdersReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOtherOrdersReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetOtherOrdersReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetOtherOrdersReq} returns this
*/
proto.xcommon.GetOtherOrdersReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOtherOrdersReq} returns this
 */
proto.xcommon.GetOtherOrdersReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOtherOrdersReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 OrderId = 2;
 * @return {number}
 */
proto.xcommon.GetOtherOrdersReq.prototype.getOrderid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetOtherOrdersReq} returns this
 */
proto.xcommon.GetOtherOrdersReq.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Mobile = 3;
 * @return {string}
 */
proto.xcommon.GetOtherOrdersReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOtherOrdersReq} returns this
 */
proto.xcommon.GetOtherOrdersReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.GetOtherOrdersReq.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.GetOtherOrdersReq} returns this
 */
proto.xcommon.GetOtherOrdersReq.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetOtherOrdersResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetOtherOrdersResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetOtherOrdersResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOtherOrdersResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    otherorders: (f = msg.getOtherorders()) && proto.xcommon.OtherOrderInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetOtherOrdersResp}
 */
proto.xcommon.GetOtherOrdersResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetOtherOrdersResp;
  return proto.xcommon.GetOtherOrdersResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetOtherOrdersResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetOtherOrdersResp}
 */
proto.xcommon.GetOtherOrdersResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.OtherOrderInfo;
      reader.readMessage(value,proto.xcommon.OtherOrderInfo.deserializeBinaryFromReader);
      msg.setOtherorders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetOtherOrdersResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetOtherOrdersResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetOtherOrdersResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetOtherOrdersResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOtherorders();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.OtherOrderInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.GetOtherOrdersResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.GetOtherOrdersResp} returns this
*/
proto.xcommon.GetOtherOrdersResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOtherOrdersResp} returns this
 */
proto.xcommon.GetOtherOrdersResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOtherOrdersResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OtherOrderInfo OtherOrders = 2;
 * @return {?proto.xcommon.OtherOrderInfo}
 */
proto.xcommon.GetOtherOrdersResp.prototype.getOtherorders = function() {
  return /** @type{?proto.xcommon.OtherOrderInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.OtherOrderInfo, 2));
};


/**
 * @param {?proto.xcommon.OtherOrderInfo|undefined} value
 * @return {!proto.xcommon.GetOtherOrdersResp} returns this
*/
proto.xcommon.GetOtherOrdersResp.prototype.setOtherorders = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetOtherOrdersResp} returns this
 */
proto.xcommon.GetOtherOrdersResp.prototype.clearOtherorders = function() {
  return this.setOtherorders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetOtherOrdersResp.prototype.hasOtherorders = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.xcommon.ResourceUseMark = {
  USE_MARK_UNSPECIFIED: 0,
  USE_MARK_HR_IMAGE: 1,
  USE_MARK_HR_ATTACHMENT: 2
};

module.exports = proto.xcommon;
